
import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { AdminPartnerChat } from '../components/PartnerChat';
import AdminPartnerVacancies from '../components/AdminPartnerVacancies';
import { openCommissionReceipt } from '../utils/commissionReceipt';
import logo from '../assets/logo.png';
import { fmtDate, fmtDateTime } from '../utils/dates';

// ── Registration form data lists (shared with Home.js) ────────────────────────
const KERALA_PLACES = ['Thiruvananthapuram','Kazhakoottam','Attingal','Neyyattinkara','Nedumangad','Varkala','Kattakada','Nemom','Kovalam','Vizhinjam','Karamana','Sreekaryam','Pattom','Kowdiar','Peroorkada','Parassala','Pothencode','Venganoor','Aruvippuram','Thumba','Thiruvallam','Ulloor','Balaramapuram','Pangode','Kazhakuttam','Technopark','Fort','Palayam','Vanchiyoor','Thampanoor','Anayara','Kollam','Punalur','Karunagappally','Kottarakkara','Paravur','Kottiyam','Ayoor','Kundara','Perinad','Chadayamangalam','Chavara','Sasthamkotta','Mynagappally','Kulathupuzha','Anchal','Pathanamthitta','Adoor','Thiruvalla','Ranni','Pandalam','Kozhencherry','Konni','Mallappally','Maramon','Aranmula','Chengannur','Vennikulam','Puthuppally','Niranam','Elanthoor','Alappuzha','Alleppey','Cherthala','Kayamkulam','Harippad','Mannar','Ambalappuzha','Mavelikkara','Changanassery','Kuttanad','Kainakary','Purakkad','Kottayam','Pala','Vaikom','Muvattupuzha','Erattupetta','Kanjirappally','Ettumanoor','Mundakayam','Ponkunnam','Karukachal','Athirampuzha','Kumarakom','Thodupuzha','Munnar','Kattappana','Adimali','Neriyamangalam','Painavu','Rajakkad','Devikulam','Nedumkandam','Upputhara','Vandiperiyar','Kumily','Peermade','Idukki','Kochi','Ernakulam','Aluva','Angamaly','Perumbavoor','Kothamangalam','Thrippunithura','Kalamassery','Edappally','Kakkanad','Vytilla','Fort Kochi','Mattancherry','Elamakkara','Kaloor','Palarivattom','Maradu','Eloor','North Paravur','Munambam','Koovappady','Piravom','Varappuzha','Chottanikkara','Rayamangalam','Thrissur','Irinjalakuda','Chalakudy','Guruvayur','Kodungallur','Kunnamkulam','Mala','Wadakkanchery','Chavakkad','Kecheri','Valapad','Pavaratty','Pariyaram','Puthukkad','Nadathara','Ollur','Cherpu','Arimpur','Palakkad','Ottapalam','Shoranur','Mannarkkad','Pattambi','Alathur','Chittur','Nemmara','Kongad','Kalpathy','Malampuzha','Mundur','Sreekrishnapuram','Vadakkencherry','Thrithala','Shornur','Malappuram','Manjeri','Tirur','Perinthalmanna','Kondotty','Nilambur','Ponnani','Kottakkal','Areekode','Tanur','Valanchery','Tirurrangadi','Vengara','Parappanangadi','Edappal','Tenhipalam','Kozhikode','Calicut','Vadakara','Koyilandy','Ramanattukara','Feroke','Beypore','Thamarassery','Mukkam','Thiruvambadi','Kunnamangalam','Chelannur','Koduvally','Perambra','Mavoor','Kallachi','Payyoli','Quilandy','Kalpetta','Mananthavady','Sulthan Bathery','Vythiri','Ambalavayal','Meenangadi','Panamaram','Pulpally','Meppadi','Kannur','Thalassery','Payyannur','Iritty','Koothuparamba','Anthoor','Mattannur','Chelora','Valapattanam','Dharmadom','Pattuvam','Peravoor','Kalliasseri','Taliparamba','Sreekandapuram','Payyanur','Kasaragod','Kanhangad','Manjeshwaram','Nileshwar','Hosdurg','Cheruvathur','Udma','Bekal','Vidyanagar','Badiadka'];

const QUALIFICATIONS = ['SSLC / 10th','Plus Two / +2 / Higher Secondary','Plus Two - Science','Plus Two - Commerce','Plus Two - Humanities / Arts','ITI (Industrial Training)','Diploma in Engineering','Diploma in Computer Applications (DCA)','Diploma in Pharmacy','Diploma in Nursing','Diploma in Hotel Management','B.A. (Bachelor of Arts)','B.Com (Bachelor of Commerce)','B.Sc (Bachelor of Science)','BBA (Bachelor of Business Administration)','BCA (Bachelor of Computer Applications)','B.Tech (Bachelor of Technology)','B.E. (Bachelor of Engineering)','B.Arch (Bachelor of Architecture)','B.Ed (Bachelor of Education)','B.Pharm (Bachelor of Pharmacy)','B.Sc Nursing','BHM (Bachelor of Hotel Management)','LLB (Bachelor of Laws)','B.P.T. (Physiotherapy)','BAMS (Ayurveda)','BHMS (Homeopathy)','MBBS','BDS (Dental)','B.Sc Psychology','B.Sc Agriculture','M.A. (Master of Arts)','M.Com (Master of Commerce)','M.Sc (Master of Science)','MBA (Master of Business Administration)','MCA (Master of Computer Applications)','M.Tech (Master of Technology)','M.E. (Master of Engineering)','M.Ed (Master of Education)','M.Pharm','M.Sc Nursing','LLM (Master of Laws)','MD (Doctor of Medicine)','MS (Master of Surgery)','MDS (Dental Surgery)','M.Arch','PGDM (Post Graduate Diploma in Management)','Post Graduate Diploma','Ph.D','CA Foundation','CA Intermediate','CA Final (Chartered Accountant)','CMA Foundation','CMA Intermediate','CMA Final (Cost Accountant)','CS Foundation','CS Executive','CS Professional (Company Secretary)','ACCA (UK)','CFA (Chartered Financial Analyst)','Certificate Course (Computer)','Certificate Course (Other)'];

const JOB_ROLES = ['Accountant','Accounts Assistant','Accounts Executive','Accounts Payable Specialist','Accounts Receivable Specialist','Administrative Assistant','Administrative Executive','Area Sales Manager','Architect','Auditor','AutoCAD Operator','Backend Developer','Bank Clerk','Bank PO','BDM (Business Development Manager)','BDE (Business Development Executive)','Branch Manager','Business Analyst','CA Article Assistant','Call Centre Executive','Cashier','Chef / Cook','Civil Engineer','Civil Site Engineer','Clinical Pharmacist','CNC Machine Operator','Computer Hardware Technician','Computer Operator','Content Writer','Corporate Trainer','Cost Accountant','Counter Sales Executive','Credit Officer','Customer Relationship Manager','Customer Service Executive','Data Analyst','Data Entry Operator','Digital Marketing Executive','Driver','Electrical Engineer','Electrical Technician','Electronics Engineer','Electronics Technician','Estimator (Civil)','Executive Assistant','Export/Import Executive','Factory Worker','Field Sales Executive','Finance Executive','Finance Manager','Front Office Executive','Full Stack Developer','General Manager','Graphic Designer','GST Consultant','HR Executive','HR Manager','HVAC Technician','Interior Designer','IT Support Engineer','Junior Accountant','Junior Engineer','Junior Software Developer','Lab Technician','Loan Officer','Logistics Executive','Machine Operator','Management Trainee','Manager','Marketing Executive','Marketing Manager','Mechanical Engineer','Medical Representative','Merchandiser','Network Administrator','Nurse (GNM / B.Sc)','Office Assistant','Operations Executive','Operations Manager','Pharmacist','Plumber','Production Engineer','Production Supervisor','Project Coordinator','Project Manager','Purchase Executive','Purchase Manager','Quality Analyst','QA Engineer','Quality Control Inspector','Radiographer','Receptionist','Regional Sales Manager','Safety Officer','Sales Coordinator','Sales Executive','Sales Manager','SAP Consultant','Security Guard','SEO Executive','Site Engineer','Social Media Manager','Software Developer','Software Tester / QA','Store Incharge','Store Keeper','Supervisor','System Administrator','Tax Consultant','Teacher / Faculty','Team Leader','Technician','Telecaller','Transport Manager','UI/UX Designer','Videographer / Photographer','Warehouse Executive','Web Developer','Welder','X-Ray Technician','Zonal Manager'];

const DEPARTMENTS = ['Accounts & Finance','Administration','Audit & Compliance','Banking & Finance','Business Development','Civil Engineering','CNC Machine Operations','Computer Science & IT','Content & Communication','Customer Service & Support','Data Analytics & MIS','Design & Architecture','Digital Marketing','Education & Training','Electrical Engineering','Electronics & Instrumentation','Export & Import','Fabrication & Welding','Field Operations','Finance & Taxation','FMCG / Retail','Front Office & Hospitality','HR & Payroll','Insurance','Legal','Logistics & Supply Chain','Maintenance & Repair','Manufacturing & Production','Marketing & Branding','Mechanical Engineering','Medical & Healthcare','NBFC & Microfinance','Operations','Pharmacy','Purchase & Procurement','Quality Control & QA','Research & Development','Sales','Security','Software Development','Stores & Inventory','Tele Marketing & Call Centre','Transport & Delivery','Warehouse & Dispatch'];

const DEPT_SECTIONS = {'Accounts & Finance':['Accounts Payable','Accounts Receivable','Billing & Invoicing','Bank Reconciliation','Budgeting & Forecasting','Cost Accounting','Financial Reporting','GST & Taxation','Tally Operations','Payroll Processing','Internal Audit','MIS Reporting'],'Civil Engineering':['Site Supervision','Drawing & Estimation','Structural Design','AutoCAD','BOQ Preparation','MEP Works','Quality & Safety','Project Management','Survey & Layout','Tendering'],'Software Development':['Frontend Development','Backend Development','Full Stack Development','Mobile App Development','QA & Testing','DevOps','Database Administration','UI/UX Design','Cybersecurity','Cloud Computing','API Development'],'Computer Science & IT':['Software Development','Network Administration','Database Administration','IT Support & Helpdesk','Cybersecurity','Cloud & Infrastructure','Business Analysis','ERP Implementation'],'HR & Payroll':['Recruitment & Staffing','Training & Development','Payroll Processing','Employee Relations','Performance Management','Compliance & Labour Law','Induction & Onboarding','HR MIS'],'Sales':['Field Sales','Retail Sales','B2B Sales','Tele Sales','Pre-Sales','After-Sales Support','Sales Coordination','Channel Sales','Counter Sales'],'Marketing & Branding':['Digital Marketing','SEO & SEM','Social Media Marketing','Brand Management','Content Marketing','Offline Marketing','Lead Generation','Market Research','Advertising & Promotions'],'Manufacturing & Production':['Production Planning','Quality Control','Stores','Safety','Process Control','Assembly','Finishing','Packing & Dispatch','Machine Operations'],'Mechanical Engineering':['Design & CAD','Maintenance','Production','Quality Inspection','Fabrication','Tool Room','CNC Programming','HVAC','Welding & Fitting'],'Electrical Engineering':['Power Distribution','Wiring & Installation','PLC/SCADA','Panel Building','Maintenance','Quality & Testing','Project Supervision'],'Customer Service & Support':['Customer Relations','After-Sales Support','Technical Support','CRM','Feedback & Escalation','Chat Support','Email Support'],'Logistics & Supply Chain':['Procurement','Warehouse Management','Dispatch & Delivery','Fleet Management','Import & Export','Inventory Control','Order Processing'],'Banking & Finance':['Loans & Advances','Deposits','Teller Operations','KYC & AML','Insurance Bancassurance','Treasury','Credit Appraisal','Recovery & Collections'],'Medical & Healthcare':['OPD / Outpatient','ICU / Critical Care','Emergency','Lab & Pathology','Pharmacy','Radiology & Imaging','Nursing Station','Operation Theatre','Admin & Medical Records'],'Administration':['Office Management','Facilities Management','Reception & Front Desk','Documentation & Filing','Travel & Logistics','Procurement & Vendor Management','Executive Support'],'Business Development':['Lead Generation','Client Acquisition','Proposal Writing','Market Expansion','Partnerships & Alliances','Key Account Management','Pricing & Negotiation'],'Digital Marketing':['SEO','SEM / Google Ads','Social Media Marketing','Email Marketing','Content Creation','Video Marketing','Analytics & Reporting','Affiliate Marketing'],'Purchase & Procurement':['Vendor Development','Tender & Quotation','Purchase Order Management','Material Planning','Import Procurement','Contract Management','Cost Negotiation'],'Warehouse & Dispatch':['Receiving & Inspection','Storage & Bin Management','Picking & Packing','Dispatch Operations','Inventory Audit','Returns Processing'],'Stores & Inventory':['Stock Management','Material Issue & Receipt','Inventory Control','Bin Card Maintenance','Spares Management'],'Quality Control & QA':['Incoming Quality','In-Process Quality','Final Inspection','Documentation & Audit','Lab Testing','Calibration','ISO Compliance','NABL'],'Audit & Compliance':['Internal Audit','Statutory Audit','Tax Audit','GST Compliance','ROC Filings','Risk Assessment','Process Audit'],'Finance & Taxation':['Income Tax','GST','TDS & TCS','Financial Analysis','Investment Advisory','Audit Support'],'Education & Training':['Teaching (Primary)','Teaching (Secondary)','Teaching (Higher Education)','Technical Training','Soft Skills Training','E-Learning','Administration','Library'],'NBFC & Microfinance':['Business Correspondent','Loan Origination','Field Collection','Recovery','Branch Operations','Credit Analysis','Customer Onboarding'],'Front Office & Hospitality':['Reception','Reservations','Guest Relations','Concierge','Food & Beverage Service','Housekeeping','Banquet Operations'],'Design & Architecture':['Architectural Design','3D Modelling & Rendering','AutoCAD Drawing','Interior Design','Landscape Design','Urban Planning','Graphic Design'],'Insurance':['Life Insurance','General Insurance','Health Insurance','Motor Insurance','Claims Processing','Underwriting','Agency Development'],'Legal':['Corporate Law','Civil Litigation','Criminal Law','Property & Conveyancing','Labour Law','Intellectual Property','Contract Drafting'],'Transport & Delivery':['Local Delivery','Intercity Transport','Fleet Operations','Route Planning','Vehicle Maintenance','Documentation'],'CNC Machine Operations':['CNC Turning','CNC Milling','CNC Programming (G-Code)','Tool Setting','Quality Inspection','Machine Maintenance'],'Fabrication & Welding':['MIG Welding','TIG Welding','ARC Welding','Sheet Metal Fabrication','Structural Fabrication','Gas Cutting','Quality Inspection'],'Field Operations':['Field Survey','Site Operations','Field Sales','Maintenance & Repair','Ground Operations','Data Collection'],'Security':['Premises Security','Access Control','CCTV Monitoring','Patrolling','Fire Safety','VIP Protection'],'Content & Communication':['Content Writing','Copywriting','Technical Writing','Proofreading & Editing','Social Media Content','Video Scripting','PR & Media'],'Data Analytics & MIS':['MIS Reporting','Data Entry & Cleansing','Dashboard & Visualisation','Advanced Excel','Power BI','SQL & Database','Python / R Analytics'],'Electronics & Instrumentation':['PCB Design','Embedded Systems','Industrial Instrumentation','PLC Programming','Maintenance','Testing & QC'],'Export & Import':['Customs Clearance','Shipping Documentation','Freight Coordination','Letter of Credit','Export Compliance','Trade Finance'],'Pharmacy':['Dispensing','Drug Store Management','Clinical Pharmacy','Regulatory Affairs','Quality Assurance','Pharmacovigilance'],'Research & Development':['Product Development','Process Research','Market Research','Testing & Validation','Documentation & Patents'],'Tele Marketing & Call Centre':['Inbound Support','Outbound Sales','Lead Generation','Customer Retention','Collections','Technical Helpdesk'],'Maintenance & Repair':['Preventive Maintenance','Breakdown Maintenance','Civil Maintenance','Electrical Maintenance','Mechanical Maintenance','AMC Coordination'],'FMCG / Retail':['Store Operations','Inventory Management','Merchandising','Sales Floor','Category Management','Vendor Relations']};
const ALL_SECTIONS = [...new Set(Object.values(DEPT_SECTIONS).flat())].sort();
const REGISTRATIONS_PAGE_SIZE = 10;
const PARTNERS_PAGE_SIZE = 10;
const initialRegistrationFilters = {
  name: '',
  district: '',
  contact: '',
  department: '',
  expectingJob: '',
  forwardStatus: 'all'
};
const initialPrFilters = { search: '', partner: '', month: '', from: '', to: '', status: '' };

// Page numbers to show around the current page, with '...' gaps: 1 ... 4 5 6 ... 12
const getPageNumbers = (current, total) => {
  const pages = [];
  for (let n = 1; n <= total; n += 1) {
    if (n === 1 || n === total || Math.abs(n - current) <= 1) pages.push(n);
    else if (pages[pages.length - 1] !== '...') pages.push('...');
  }
  return pages;
};

const formatMonthLabel = (ym) => {
  const [y, m] = ym.split('-').map(Number);
  return new Date(y, m - 1, 1).toLocaleString('en-IN', { month: 'long', year: 'numeric' });
};

const initialPartnerFilters = {
  search: '',
  district: '',
  status: 'all'
};
const partnerStatusOptions = ['Pending', 'Approved', 'Rejected', 'Contacted'];

const getPhoneDigits = (value) => String(value || '').replace(/\D/g, '');

const getWhatsAppDigits = (value) => {
  const digits = getPhoneDigits(value);
  if (!digits) return '';
  return digits.length === 10 ? `91${digits}` : digits;
};

const ContactLink = ({ value, type = 'call' }) => {
  const label = String(value || '').trim();
  if (!label) return '-';

  const digits = type === 'whatsapp' ? getWhatsAppDigits(label) : getPhoneDigits(label);
  if (!digits) return label;

  const href = type === 'whatsapp' ? `https://wa.me/${digits}` : `tel:${digits}`;

  return (
    <a
      href={href}
      target={type === 'whatsapp' ? '_blank' : undefined}
      rel={type === 'whatsapp' ? 'noreferrer' : undefined}
      className="font-semibold text-blue-600 underline underline-offset-2"
    >
      {label}
    </a>
  );
};



const getPlacementStage = (row) => {
  if (!Number(row.is_forwarded || 0)) return { label: 'Not Forwarded', color: 'bg-gray-100 text-gray-500', step: 0 };
  const interviewStatus = row.rw_interview_status || '';
  if (Number(row.rw_company_offer_sent || 0)) return { label: 'Placed ✓', color: 'bg-emerald-600 text-white', step: 8 };
  if (Number(row.rw_payment_received || 0)) return { label: 'Payment Received', color: 'bg-teal-100 text-teal-800', step: 7 };
  if ((row.rw_member_offer_response || '') === 'Accepted') return { label: 'Offer Accepted', color: 'bg-cyan-100 text-cyan-800', step: 6 };
  if ((row.rw_member_offer_response || '') === 'Rejected') return { label: 'Offer Rejected', color: 'bg-red-100 text-red-700', step: 6 };
  if (Number(row.rw_dani_offer_sent || 0)) return { label: 'Offer Letter Sent', color: 'bg-indigo-100 text-indigo-800', step: 5 };
  if (interviewStatus === 'Selected') return { label: 'Interview Selected', color: 'bg-green-100 text-green-800', step: 4 };
  if (interviewStatus === 'Rejected') return { label: 'Interview Rejected', color: 'bg-red-100 text-red-700', step: 4 };
  if (interviewStatus === 'Completed') return { label: 'Interview Done', color: 'bg-orange-100 text-orange-800', step: 4 };
  if (interviewStatus === 'Scheduled') return { label: 'Interview Scheduled', color: 'bg-amber-100 text-amber-800', step: 3 };
  if (Number(row.rw_is_shortlisted || 0)) return { label: 'Shortlisted', color: 'bg-purple-100 text-purple-800', step: 2 };
  return { label: 'HR Processing', color: 'bg-blue-100 text-blue-700', step: 1 };
};

const PIPELINE_STEPS = ['Forwarded', 'Shortlisted', 'Interview', 'Result', 'Offer', 'Placed'];

const PlacementPipeline = ({ row }) => {
  const stage = getPlacementStage(row);
  if (stage.step === 0) return <span className="inline-block text-xs font-bold px-2 py-1 rounded bg-gray-100 text-gray-500">Not Forwarded</span>;
  const activeStep = Math.min(Math.ceil(stage.step), PIPELINE_STEPS.length - 1);
  return (
    <div className="space-y-1.5 min-w-[140px]">
      <span className={`inline-block text-xs font-extrabold px-2 py-0.5 rounded-full ${stage.color}`}>{stage.label}</span>
      <div className="flex items-center gap-0.5 mt-1">
        {PIPELINE_STEPS.map((s, i) => {
          const stepIndex = i === 0 ? 1 : i === 1 ? 2 : i === 2 ? 3 : i === 3 ? 4 : i === 4 ? 5 : 8;
          const done = stage.step >= stepIndex;
          const active = activeStep === i;
          return (
            <div key={s} className="flex items-center gap-0.5">
              <div
                title={s}
                className={`w-4 h-4 rounded-full flex items-center justify-center text-[8px] font-black transition-all ${
                  done ? 'bg-emerald-500 text-white' : active ? 'border-2 border-blue-400 bg-blue-50 text-blue-600' : 'bg-gray-100 text-gray-400'
                }`}
              >{i + 1}</div>
              {i < PIPELINE_STEPS.length - 1 && <div className={`w-2 h-0.5 ${done ? 'bg-emerald-400' : 'bg-gray-200'}`} />}
            </div>
          );
        })}
      </div>
      <div className="text-[10px] text-gray-500 leading-tight">{row.current_handler_name ? `Handler: ${row.current_handler_name}` : ''}</div>
    </div>
  );
};

const PartnerTag = ({ row }) => Number(row?.via_partner) === 1 ? (
  <span
    className="inline-flex items-center gap-0.5 rounded-full bg-amber-400 border border-amber-500 px-1.5 py-0.5 text-[9px] font-black text-black leading-none whitespace-nowrap"
    title={row.partner_org_name ? `Via Partner: ${row.partner_org_name}` : 'Via Partner'}
  >
    🤝 {row.partner_org_name ? row.partner_org_name : 'Partner Ref'}
  </span>
) : null;

const AdminDashboard = () => {
  // Tab state
  const [activeTab, setActiveTab] = useState('registrations');
  const [changePwOpen, setChangePwOpen] = useState(false);
  const [changePwForm, setChangePwForm] = useState({ current: '', newPw: '', confirm: '' });
  const [changePwMsg, setChangePwMsg] = useState(null); // { type: 'success'|'error', text }
  const [changePwLoading, setChangePwLoading] = useState(false);
  const [registrations, setRegistrations] = useState([]);
  const [registrationsPage, setRegistrationsPage] = useState(1);
  const [showRegistrationFilters, setShowRegistrationFilters] = useState(false);
  const [registrationFilters, setRegistrationFilters] = useState(initialRegistrationFilters);
  const [registrationsLoading, setRegistrationsLoading] = useState(false);
  const [registrationTemplateLoading, setRegistrationTemplateLoading] = useState(false);
  const [registrationImporting, setRegistrationImporting] = useState(false);
  const [registrationExportLoading, setRegistrationExportLoading] = useState(false);
  const [selectedRegistration, setSelectedRegistration] = useState(null);
  const [editRegistrationOpen, setEditRegistrationOpen] = useState(false);
  const [savingRegistration, setSavingRegistration] = useState(false);
  const registrationImportInputRef = useRef(null);
  const [editRegistrationForm, setEditRegistrationForm] = useState({
    id: '',
    name: '',
    email: '',
    place: '',
    contact_number: '',
    whatsapp_number: '',
    district: '',
    highest_qualification: '',
    expecting_job: '',
    department: '',
    section: '',
    resume: null,
    photo: null,
    resume_file: '',
    photo_file: ''
  });
  const [staff, setStaff] = useState([]);
  const [internships, setInternships] = useState([]);
  const [internshipsLoading, setInternshipsLoading] = useState(false);
  const [internshipSearch, setInternshipSearch] = useState('');
  const [internshipExpandedId, setInternshipExpandedId] = useState(null);
  const [internshipForwardModal, setInternshipForwardModal] = useState(null); // { appId, appName }
  const [internshipForwardArId, setInternshipForwardArId] = useState('');
  const [internshipForwarding, setInternshipForwarding] = useState(false);
  const [internshipStatusFilter, setInternshipStatusFilter] = useState('All');
  const [internshipGenderFilter, setInternshipGenderFilter] = useState('All');
  const [internshipPage, setInternshipPage] = useState(1);
  const INTERNSHIP_PER_PAGE = 10;
  const [recruitmentStats, setRecruitmentStats] = useState(null);
  const [recruitmentStatsLoading, setRecruitmentStatsLoading] = useState(false);
  const [partners, setPartners] = useState([]);
  const [partnersLoading, setPartnersLoading] = useState(false);
  const [partnerRegistrations, setPartnerRegistrations] = useState([]);
  const [partnerRegistrationsLoading, setPartnerRegistrationsLoading] = useState(false);
  const [partnerVacancyPending, setPartnerVacancyPending] = useState(null);
  const [prFilters, setPrFilters] = useState(initialPrFilters);
  const [prPage, setPrPage] = useState(1);
  const [prPageSize, setPrPageSize] = useState(10);

  // Partner registrations: filters -> summary -> pagination
  const prPartnerOptions = [...new Set(partnerRegistrations.map((r) => r.partner_name_of_organisation).filter(Boolean))].sort();
  const prMonthOptions = [...new Set(partnerRegistrations.map((r) => String(r.created_at || '').slice(0, 7)).filter(Boolean))].sort().reverse();
  const prSearch = prFilters.search.trim().toLowerCase();
  const filteredPartnerRegistrations = partnerRegistrations.filter((r) => {
    const day = String(r.created_at || '').slice(0, 10);
    if (prFilters.partner && r.partner_name_of_organisation !== prFilters.partner) return false;
    if (prFilters.month && !day.startsWith(prFilters.month)) return false;
    if (prFilters.from && day < prFilters.from) return false;
    if (prFilters.to && day > prFilters.to) return false;
    if (prFilters.status === 'forwarded' && !r.forwarded_to_hr) return false;
    if (prFilters.status === 'pending' && r.forwarded_to_hr) return false;
    if (prFilters.status === 'placed' && !r.is_placed) return false;
    if (prSearch && ![r.name, r.contact_number, r.whatsapp_number, r.place, r.district, r.qualification, r.expecting_job]
      .some((v) => String(v || '').toLowerCase().includes(prSearch))) return false;
    return true;
  });
  const thisMonth = new Date().toISOString().slice(0, 7);
  const prSummary = {
    total: filteredPartnerRegistrations.length,
    forwarded: filteredPartnerRegistrations.filter((r) => r.forwarded_to_hr).length,
    pending: filteredPartnerRegistrations.filter((r) => !r.forwarded_to_hr).length,
    placed: filteredPartnerRegistrations.filter((r) => r.is_placed).length,
    partners: new Set(filteredPartnerRegistrations.map((r) => r.partner_name_of_organisation)).size,
    thisMonth: filteredPartnerRegistrations.filter((r) => String(r.created_at || '').startsWith(thisMonth)).length
  };
  const prTotalPages = Math.max(1, Math.ceil(filteredPartnerRegistrations.length / prPageSize));
  const prSafePage = Math.min(prPage, prTotalPages);
  const pagedPartnerRegistrations = filteredPartnerRegistrations.slice((prSafePage - 1) * prPageSize, prSafePage * prPageSize);
  const prActiveFilterCount = Object.values(prFilters).filter(Boolean).length;
  const handlePrFilterChange = (e) => {
    const { name, value } = e.target;
    // a picked month replaces a date range and vice versa
    const extra = name === 'month' ? { from: '', to: '' } : (name === 'from' || name === 'to') ? { month: '' } : {};
    setPrFilters((prev) => ({ ...prev, ...extra, [name]: value }));
    setPrPage(1);
  };
  const [partnersPage, setPartnersPage] = useState(1);
  const [partnerFilters, setPartnerFilters] = useState(initialPartnerFilters);
  const [savingPartnerId, setSavingPartnerId] = useState(null);
  const [partnerCommissions, setPartnerCommissions] = useState([]);
  const [partnerCommissionsLoading, setPartnerCommissionsLoading] = useState(false);
  const [savingPartnerAccountId, setSavingPartnerAccountId] = useState(null);
  const [editPartnerForm, setEditPartnerForm] = useState(null);
  const [savingPartnerEdit, setSavingPartnerEdit] = useState(false);
  const [staffLoading, setStaffLoading] = useState(false);
  const [staffSaving, setStaffSaving] = useState(false);
  const [staffDeletingId, setStaffDeletingId] = useState(null);
  const [editRoleRow, setEditRoleRow] = useState(null);
  const [editRoleValue, setEditRoleValue] = useState('');
  const [editRoleSaving, setEditRoleSaving] = useState(false);
  const [staffForm, setStaffForm] = useState({
    staff_id: '',
    name: '',
    contact_number: '',
    user_id: '',
    password: '',
    role: ''
  });
  const DEFAULT_STAFF_ROLES = ['HR Assistant', 'HR Executive', 'Data Analyst', 'HR Manager', 'Recruiter', 'Assistant Recruiter', 'Accountant', 'Marketing'];
  const [staffRoles, setStaffRoles] = useState(() => {
    try {
      const saved = localStorage.getItem('dani_staff_roles');
      if (saved) {
        const parsed = JSON.parse(saved);
        if (Array.isArray(parsed) && parsed.length > 0) {
          return [...new Set([...DEFAULT_STAFF_ROLES, ...parsed])];
        }
      }
    } catch {}
    return DEFAULT_STAFF_ROLES;
  });
  const [addingNewRole, setAddingNewRole] = useState(false);
  const [newRoleName, setNewRoleName] = useState('');
  // Jobs state
  const [jobs, setJobs] = useState([]);
  const [jobForm, setJobForm] = useState({
    title: '',
    department: '',
    section: '',
    experience: '',
    salary: '',
    location: '',
    district: '',
    description: '',
    company_firm_organisation: '',
    qualification: '',
    gender: '',
    age_limit: ''
  });
  const [jobError, setJobError] = useState('');
  const [jobSuccess, setJobSuccess] = useState('');
  const [jobLoading, setJobLoading] = useState(false);
  const [showJobForm, setShowJobForm] = useState(false);
  const [editJobId, setEditJobId] = useState(null);
  const [editJobForm, setEditJobForm] = useState({ title: '', department: '', section: '', experience: '', salary: '', location: '', district: '', description: '', company_firm_organisation: '', qualification: '', gender: '', age_limit: '' });
  const [editJobLoading, setEditJobLoading] = useState(false);
  const [editJobError, setEditJobError] = useState('');
  // Member Plans overview
  const [planOverview, setPlanOverview] = useState(null);
  // Fetch jobs
  const fetchJobs = async () => {
    try {
      const token = localStorage.getItem('adminToken');
      const res = await axios.get(`${API_URL}/api/jobs`, { headers: { Authorization: `Bearer ${token}` } });
      setJobs(res.data);
    } catch {
      setJobs([]);
    }
  };

  useEffect(() => { if (activeTab === 'jobs') fetchJobs(); }, [activeTab]);
  useEffect(() => {
    if (activeTab !== 'jobs') {
      setShowJobForm(false);
    }
  }, [activeTab]);

  const fetchRegistrations = async () => {
    setRegistrationsLoading(true);
    try {
      const token = localStorage.getItem('adminToken');
      const res = await axios.get(`${API_URL}/api/admin/registrations`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setRegistrations(res.data || []);
    } catch {
      setRegistrations([]);
    } finally {
      setRegistrationsLoading(false);
    }
  };

  const extractDownloadFilename = (contentDisposition, fallbackName) => {
    const match = /filename="?([^";]+)"?/i.exec(contentDisposition || '');
    return match?.[1] || fallbackName;
  };

  const downloadRegistrationWorkbook = async (endpoint, fallbackName, setLoadingState) => {
    setLoadingState(true);
    try {
      const token = localStorage.getItem('adminToken');
      const res = await axios.get(`${API_URL}${endpoint}`, {
        headers: { Authorization: `Bearer ${token}` },
        responseType: 'blob'
      });

      const blobUrl = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = extractDownloadFilename(res.headers['content-disposition'], fallbackName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (err) {
      alert(err?.response?.data?.error || `Failed to download ${fallbackName}`);
    } finally {
      setLoadingState(false);
    }
  };

  const handleDownloadRegistrationTemplate = async () => {
    await downloadRegistrationWorkbook('/api/admin/registrations/template', 'registration-import-template.xlsx', setRegistrationTemplateLoading);
  };

  const handleExportRegistrations = async () => {
    await downloadRegistrationWorkbook('/api/admin/registrations/export', 'registrations-export.xlsx', setRegistrationExportLoading);
  };

  const triggerRegistrationImport = () => {
    if (!registrationImporting) {
      registrationImportInputRef.current?.click();
    }
  };

  const handleRegistrationImport = async (e) => {
    const file = e.target.files && e.target.files[0] ? e.target.files[0] : null;
    e.target.value = '';

    if (!file) return;

    setRegistrationImporting(true);
    try {
      const token = localStorage.getItem('adminToken');
      const formData = new FormData();
      formData.append('file', file);

      const res = await axios.post(`${API_URL}/api/admin/registrations/import`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });

      await fetchRegistrations();
      alert(res.data?.message || 'Registrations imported successfully.');
    } catch (err) {
      alert(err?.response?.data?.error || 'Failed to import registrations.');
    } finally {
      setRegistrationImporting(false);
    }
  };

  useEffect(() => {
    if (activeTab === 'registrations') {
      setRegistrationsPage(1);
      fetchRegistrations();
      // Fetch member plans overview
      const token = localStorage.getItem('adminToken');
      axios.get(`${API_URL}/api/admin/member-plans/overview`, { headers: { Authorization: `Bearer ${token}` } })
        .then((r) => setPlanOverview(r.data)).catch(() => {});
    }
  }, [activeTab]);

  useEffect(() => {
    if (activeTab !== 'registrations') return undefined;
    const intervalId = setInterval(() => {
      fetchRegistrations();
    }, 10000);
    return () => clearInterval(intervalId);
  }, [activeTab]);

  const fetchStaff = async () => {
    setStaffLoading(true);
    try {
      const token = localStorage.getItem('adminToken');
      const res = await axios.get(`${API_URL}/api/admin/staff`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setStaff(res.data || []);
    } catch {
      setStaff([]);
    } finally {
      setStaffLoading(false);
    }
  };

  useEffect(() => {
    if (activeTab === 'staff') fetchStaff();
  }, [activeTab]);

  const fetchRecruitmentStats = async () => {
    setRecruitmentStatsLoading(true);
    try {
      const token = localStorage.getItem('adminToken');
      const res = await axios.get(`${API_URL}/api/admin/recruitment-stats`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setRecruitmentStats(res.data || null);
    } catch {
      setRecruitmentStats(null);
    } finally {
      setRecruitmentStatsLoading(false);
    }
  };

  useEffect(() => {
    if (activeTab === 'recruitment') fetchRecruitmentStats();
  }, [activeTab]);

  // ── Agent/Telecaller report state ─────────────────────────────────────────
  const [activityReport, setActivityReport]         = useState(null);
  const [activityReportLoading, setActivityReportLoading] = useState(false);
  const [reportDateFrom, setReportDateFrom]         = useState('');
  const [reportDateTo, setReportDateTo]             = useState('');
  const [reportAgentSearch, setReportAgentSearch]   = useState('');
  const [reportTCSearch, setReportTCSearch]         = useState('');

  const [activityReportError, setActivityReportError] = useState('');

  const fetchActivityReport = async () => {
    setActivityReportLoading(true);
    setActivityReportError('');
    try {
      const token = localStorage.getItem('adminToken');
      const res = await axios.get(`${API_URL}/api/admin/agent-telecaller-report`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setActivityReport(res.data || null);
    } catch (err) {
      const msg = err?.response?.data?.error || err?.message || 'Failed to load report';
      setActivityReportError(msg);
      setActivityReport(null);
    } finally {
      setActivityReportLoading(false);
    }
  };

  useEffect(() => {
    if (activeTab === 'analysis') fetchActivityReport();
  }, [activeTab]);

  // ── ID Setup state ────────────────────────────────────────────────────────
  const [idSubTab, setIdSubTab] = useState('staff');
  const [memberAccounts, setMemberAccounts]     = useState([]);
  const [memberAccountsLoading, setMemberAccountsLoading] = useState(false);
  const [memberAccountForm, setMemberAccountForm] = useState({ talent_registration_id: '', user_id: '', email: '', password: '' });
  const [memberAccountSaving, setMemberAccountSaving] = useState(false);
  const [memberAccountSearch, setMemberAccountSearch] = useState('');

  const [companyAccounts, setCompanyAccounts]   = useState([]);
  const [companyAccountsLoading, setCompanyAccountsLoading] = useState(false);
  const [companyAccountForm, setCompanyAccountForm] = useState({ company_name: '', contact_person: '', contact_number: '', email: '', user_id: '', password: '', notes: '' });
  const [companyAccountSaving, setCompanyAccountSaving] = useState(false);

  const [resetRequests, setResetRequests]       = useState([]);
  const [resetRequestsLoading, setResetRequestsLoading] = useState(false);
  const [resolvingResetId, setResolvingResetId] = useState(null);
  const [resolvePasswordMap, setResolvePasswordMap] = useState({});

  const [staffResetPasswordMap, setStaffResetPasswordMap]     = useState({});
  const [staffResetSavingId, setStaffResetSavingId]           = useState(null);
  const [partnerResetPasswordMap, setPartnerResetPasswordMap] = useState({});
  const [partnerResetSavingId, setPartnerResetSavingId]       = useState(null);

  const fetchMemberAccounts = async () => {
    setMemberAccountsLoading(true);
    try {
      const token = localStorage.getItem('adminToken');
      const res = await axios.get(`${API_URL}/api/admin/member-accounts`, { headers: { Authorization: `Bearer ${token}` } });
      setMemberAccounts(res.data || []);
    } catch { setMemberAccounts([]); }
    finally { setMemberAccountsLoading(false); }
  };

  const fetchCompanyAccounts = async () => {
    setCompanyAccountsLoading(true);
    try {
      const token = localStorage.getItem('adminToken');
      const res = await axios.get(`${API_URL}/api/admin/company-accounts`, { headers: { Authorization: `Bearer ${token}` } });
      setCompanyAccounts(res.data || []);
    } catch { setCompanyAccounts([]); }
    finally { setCompanyAccountsLoading(false); }
  };

  const fetchResetRequests = async () => {
    setResetRequestsLoading(true);
    try {
      const token = localStorage.getItem('adminToken');
      const res = await axios.get(`${API_URL}/api/admin/password-reset-requests`, { headers: { Authorization: `Bearer ${token}` } });
      setResetRequests(res.data || []);
    } catch { setResetRequests([]); }
    finally { setResetRequestsLoading(false); }
  };

  useEffect(() => {
    if (activeTab === 'id-setup') {
      if (idSubTab === 'staff') fetchStaff();
      if (idSubTab === 'partners') fetchPartners();
      if (idSubTab === 'members') fetchMemberAccounts();
      if (idSubTab === 'companies') fetchCompanyAccounts();
      if (idSubTab === 'reset-requests') fetchResetRequests();
    }
  }, [activeTab, idSubTab]);

  const handleCreateMemberAccount = async (e) => {
    e.preventDefault();
    setMemberAccountSaving(true);
    try {
      const token = localStorage.getItem('adminToken');
      await axios.post(`${API_URL}/api/admin/member-accounts`, memberAccountForm, { headers: { Authorization: `Bearer ${token}` } });
      setMemberAccountForm({ talent_registration_id: '', user_id: '', email: '', password: '' });
      fetchMemberAccounts();
    } catch (err) { alert(err?.response?.data?.error || 'Failed to create account'); }
    finally { setMemberAccountSaving(false); }
  };

  const handleDeleteMemberAccount = async (id, name) => {
    if (!window.confirm(`Delete account for ${name}?`)) return;
    try {
      const token = localStorage.getItem('adminToken');
      await axios.delete(`${API_URL}/api/admin/member-accounts/${id}`, { headers: { Authorization: `Bearer ${token}` } });
      fetchMemberAccounts();
    } catch (err) { alert(err?.response?.data?.error || 'Failed to delete'); }
  };

  const handleCreateCompanyAccount = async (e) => {
    e.preventDefault();
    setCompanyAccountSaving(true);
    try {
      const token = localStorage.getItem('adminToken');
      await axios.post(`${API_URL}/api/admin/company-accounts`, companyAccountForm, { headers: { Authorization: `Bearer ${token}` } });
      setCompanyAccountForm({ company_name: '', contact_person: '', contact_number: '', email: '', user_id: '', password: '', notes: '' });
      fetchCompanyAccounts();
    } catch (err) { alert(err?.response?.data?.error || 'Failed to create account'); }
    finally { setCompanyAccountSaving(false); }
  };

  const handleDeleteCompanyAccount = async (id, name) => {
    if (!window.confirm(`Delete account for ${name}?`)) return;
    try {
      const token = localStorage.getItem('adminToken');
      await axios.delete(`${API_URL}/api/admin/company-accounts/${id}`, { headers: { Authorization: `Bearer ${token}` } });
      fetchCompanyAccounts();
    } catch (err) { alert(err?.response?.data?.error || 'Failed to delete'); }
  };

  const handleResolveResetRequest = async (requestId) => {
    const pw = (resolvePasswordMap[requestId] || '').trim();
    if (!pw || pw.length < 4) { alert('Enter a new password (min 4 chars)'); return; }
    setResolvingResetId(requestId);
    try {
      const token = localStorage.getItem('adminToken');
      await axios.put(`${API_URL}/api/admin/password-reset-requests/${requestId}/resolve`, { new_password: pw }, { headers: { Authorization: `Bearer ${token}` } });
      setResolvePasswordMap((prev) => { const n = { ...prev }; delete n[requestId]; return n; });
      fetchResetRequests();
    } catch (err) { alert(err?.response?.data?.error || 'Failed to resolve'); }
    finally { setResolvingResetId(null); }
  };

  const handleStaffResetPassword = async (staffRow) => {
    const pw = (staffResetPasswordMap[staffRow.id] || '').trim();
    if (!pw || pw.length < 4) { alert('Enter a new password (min 4 chars)'); return; }
    setStaffResetSavingId(staffRow.id);
    try {
      const token = localStorage.getItem('adminToken');
      await axios.put(`${API_URL}/api/admin/staff/${staffRow.id}/reset-password`, { password: pw }, { headers: { Authorization: `Bearer ${token}` } });
      setStaffResetPasswordMap((prev) => { const n = { ...prev }; delete n[staffRow.id]; return n; });
      alert(`Password updated for ${staffRow.name}`);
    } catch (err) { alert(err?.response?.data?.error || 'Failed to reset password'); }
    finally { setStaffResetSavingId(null); }
  };

  const handlePartnerResetPassword = async (partner) => {
    const pw = (partnerResetPasswordMap[partner.id] || '').trim();
    if (!pw || pw.length < 4) { alert('Enter a new password (min 4 chars)'); return; }
    setPartnerResetSavingId(partner.id);
    try {
      const token = localStorage.getItem('adminToken');
      await axios.put(`${API_URL}/api/admin/partners/${partner.id}/reset-password`, { password: pw }, { headers: { Authorization: `Bearer ${token}` } });
      setPartnerResetPasswordMap((prev) => { const n = { ...prev }; delete n[partner.id]; return n; });
      alert(`Password updated for ${partner.owner_of_organisation}`);
    } catch (err) { alert(err?.response?.data?.error || 'Failed to reset password'); }
    finally { setPartnerResetSavingId(null); }
  };

  // ── Target Setup state ────────────────────────────────────────────────────
  const [targets, setTargets]         = useState([]);
  const [targetsLoading, setTargetsLoading] = useState(false);
  const [targetForm, setTargetForm]   = useState({ target_type: 'Staff', scope: 'role', role_or_user_id: '', metric: '', target_value: '', metric_unit: 'count', period: 'monthly', description: '' });
  const [targetSaving, setTargetSaving] = useState(false);
  const [editingTarget, setEditingTarget] = useState(null);
  const [targetDeletingId, setTargetDeletingId] = useState(null);
  const [showNewTargetForm, setShowNewTargetForm] = useState(false);
  const [targetProgress, setTargetProgress] = useState([]);
  const [targetProgressLoading, setTargetProgressLoading] = useState(false);
  // role → staff picker
  const [targetSelectedRole, setTargetSelectedRole] = useState('');
  const [targetSelectedStaff, setTargetSelectedStaff] = useState(''); // user_id of picked staff
  const [staffByRole, setStaffByRole]   = useState([]); // [{user_id, name}]
  const [staffByRoleLoading, setStaffByRoleLoading] = useState(false);
  const [targetScope, setTargetScope]   = useState('role'); // 'role' | 'individual'

  const TARGET_ROLE_OPTIONS = ['HR Assistant', 'Recruiter', 'Assistant Recruiter', 'Data Analyst', 'HR Manager', 'Accountant', 'Telecaller', 'Agent', 'Partner'];
  const METRIC_PRESETS = {
    'HR Assistant': ['Registrations Paid', 'Registrations Forwarded', 'Interviews Arranged', 'Placements Completed'],
    'Recruiter': ['Interviews Scheduled', 'Placements Completed', 'Candidates Shortlisted'],
    'Assistant Recruiter': ['Companies Visited', 'Vacancies Added', 'Interviews Confirmed'],
    'Data Analyst': ['Companies Added'],
    'Telecaller': ['Calls Made', 'Leads Converted'],
    'Agent': ['Member Leads Submitted', 'Company Leads Submitted'],
    'Partner': ['Member Registrations Uploaded'],
  };

  const fetchStaffByRole = async (role) => {
    if (!role) { setStaffByRole([]); return; }
    setStaffByRoleLoading(true);
    try {
      const token = localStorage.getItem('adminToken');
      const res = await axios.get(`${API_URL}/api/admin/staff`, { headers: { Authorization: `Bearer ${token}` } });
      const all = res.data || [];
      setStaffByRole(all.filter((s) => s.role === role).map((s) => ({ user_id: s.user_id, name: s.name })));
    } catch { setStaffByRole([]); }
    finally { setStaffByRoleLoading(false); }
  };

  const handleTargetRoleChange = (role) => {
    setTargetSelectedRole(role);
    setTargetSelectedStaff('');
    setStaffByRole([]);
    setTargetForm((p) => ({ ...p, role_or_user_id: role, metric: '' }));
    if (role) fetchStaffByRole(role);
  };

  const handleTargetStaffChange = (userId) => {
    setTargetSelectedStaff(userId);
    setTargetForm((p) => ({
      ...p,
      role_or_user_id: userId || targetSelectedRole,
      scope: userId ? 'individual' : 'role',
    }));
  };

  const resetTargetForm = () => {
    setTargetForm({ target_type: 'Staff', scope: 'role', role_or_user_id: '', metric: '', target_value: '', metric_unit: 'count', period: 'monthly', description: '' });
    setTargetSelectedRole('');
    setTargetSelectedStaff('');
    setStaffByRole([]);
    setTargetScope('role');
  };

  const fetchTargets = async () => {
    setTargetsLoading(true);
    try {
      const token = localStorage.getItem('adminToken');
      const res = await axios.get(`${API_URL}/api/admin/targets`, { headers: { Authorization: `Bearer ${token}` } });
      setTargets(res.data || []);
    } catch { setTargets([]); }
    finally { setTargetsLoading(false); }
  };

  const fetchTargetProgress = async () => {
    setTargetProgressLoading(true);
    try {
      const token = localStorage.getItem('adminToken');
      const res = await axios.get(`${API_URL}/api/admin/targets/progress`, { headers: { Authorization: `Bearer ${token}` } });
      setTargetProgress(res.data || []);
    } catch { setTargetProgress([]); }
    finally { setTargetProgressLoading(false); }
  };

  useEffect(() => {
    if (activeTab === 'target-setup') { fetchTargets(); fetchTargetProgress(); }
  }, [activeTab]);

  const handleTargetSubmit = async (e) => {
    e.preventDefault();
    const metricVal = (targetForm.metric || '').trim();
    if (!metricVal || metricVal === '__custom__') {
      alert('Please select or enter a metric before saving.');
      return;
    }
    setTargetSaving(true);
    try {
      const token = localStorage.getItem('adminToken');
      if (editingTarget) {
        await axios.put(`${API_URL}/api/admin/targets/${editingTarget.id}`, targetForm, { headers: { Authorization: `Bearer ${token}` } });
        setEditingTarget(null);
      } else {
        await axios.post(`${API_URL}/api/admin/targets`, targetForm, { headers: { Authorization: `Bearer ${token}` } });
      }
      resetTargetForm();
      setShowNewTargetForm(false);
      fetchTargets();
      fetchTargetProgress();
    } catch (err) { alert(err?.response?.data?.error || 'Failed to save target'); }
    finally { setTargetSaving(false); }
  };

  const handleDeleteTarget = async (id) => {
    if (!window.confirm('Delete this target?')) return;
    setTargetDeletingId(id);
    try {
      const token = localStorage.getItem('adminToken');
      await axios.delete(`${API_URL}/api/admin/targets/${id}`, { headers: { Authorization: `Bearer ${token}` } });
      fetchTargets();
      fetchTargetProgress();
    } catch (err) { alert(err?.response?.data?.error || 'Failed to delete'); }
    finally { setTargetDeletingId(null); }
  };

  const handleEditTarget = (t) => {
    setEditingTarget(t);
    setShowNewTargetForm(false);
    const isIndividual = TARGET_ROLE_OPTIONS.indexOf(t.role_or_user_id) === -1;
    const staffMember  = isIndividual ? (staff || []).find((s) => s.user_id === t.role_or_user_id) : null;
    const role         = staffMember ? staffMember.role : (isIndividual ? '' : t.role_or_user_id);
    setTargetSelectedRole(role || t.role_or_user_id);
    setTargetScope(isIndividual ? 'individual' : 'role');
    setTargetSelectedStaff(isIndividual ? t.role_or_user_id : '');
    if (role) fetchStaffByRole(role);
    setTargetForm({
      target_type: t.target_type, scope: t.scope, role_or_user_id: t.role_or_user_id,
      metric: t.metric, target_value: String(t.target_value), metric_unit: t.metric_unit,
      period: t.period, description: t.description || ''
    });
  };

  // ── Field Agent Leads ─────────────────────────────────────────────────────
  const [fieldAgentLeads, setFieldAgentLeads]           = useState([]);
  const [fieldAgentLeadsLoading, setFieldAgentLeadsLoading] = useState(false);
  const [faLeadStatusSaving, setFaLeadStatusSaving]     = useState(null);
  const [faLeadFilter, setFaLeadFilter]                 = useState('all'); // 'all' | 'Pending' | 'Accepted' | 'Rejected'
  const [faLeadAgentFilter, setFaLeadAgentFilter]       = useState('');
  const [faLeadSearch, setFaLeadSearch]                 = useState('');
  const [faLeadDetailModal, setFaLeadDetailModal]       = useState(null);
  const [faCommissionModal, setFaCommissionModal]       = useState(null); // { agentUserId, agentName }
  const [faCommissionData, setFaCommissionData]         = useState(null);
  const [faCommissionLoading, setFaCommissionLoading]   = useState(false);
  const [faCommissionAmount, setFaCommissionAmount]     = useState('');
  const [faCommissionNote, setFaCommissionNote]         = useState('');
  const [faCommissionSaving, setFaCommissionSaving]     = useState(false);

  const fetchFieldAgentLeads = async () => {
    setFieldAgentLeadsLoading(true);
    try {
      const token = localStorage.getItem('adminToken');
      const res = await axios.get(`${API_URL}/api/admin/field-agent-leads`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setFieldAgentLeads(res.data || []);
    } catch { setFieldAgentLeads([]); }
    finally { setFieldAgentLeadsLoading(false); }
  };

  useEffect(() => {
    if (activeTab === 'field-agents') fetchFieldAgentLeads();
  }, [activeTab]);

  const fetchInternships = async () => {
    setInternshipsLoading(true);
    try {
      const token = localStorage.getItem('adminToken');
      const res = await axios.get(`${API_URL}/api/admin/internship`, { headers: { Authorization: `Bearer ${token}` } });
      setInternships(res.data || []);
      await axios.put(`${API_URL}/api/admin/internship/mark-seen`, {}, { headers: { Authorization: `Bearer ${token}` } });
    } catch { setInternships([]); }
    finally { setInternshipsLoading(false); }
  };

  useEffect(() => {
    if (activeTab === 'internship') {
      fetchInternships();
      if (staff.length === 0) fetchStaff();
    }
  }, [activeTab]);

  const handleFaLeadStatus = async (leadId, status) => {
    setFaLeadStatusSaving(leadId);
    try {
      const token = localStorage.getItem('adminToken');
      await axios.put(
        `${API_URL}/api/admin/field-agent-leads/${leadId}/status`,
        { status },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setFieldAgentLeads((prev) => prev.map((l) => l.id === leadId ? { ...l, status } : l));
      if (faLeadDetailModal && faLeadDetailModal.id === leadId) {
        setFaLeadDetailModal((prev) => ({ ...prev, status }));
      }
    } catch (err) { alert(err?.response?.data?.error || 'Failed to update status'); }
    finally { setFaLeadStatusSaving(null); }
  };

  const openFaCommissionModal = async (agentUserId, agentName) => {
    setFaCommissionModal({ agentUserId, agentName });
    setFaCommissionAmount('');
    setFaCommissionNote('');
    setFaCommissionLoading(true);
    try {
      const token = localStorage.getItem('adminToken');
      const res = await axios.get(`${API_URL}/api/admin/field-agent-commission/${agentUserId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setFaCommissionData(res.data);
    } catch { setFaCommissionData(null); }
    finally { setFaCommissionLoading(false); }
  };

  const handleFaAddCommission = async (e) => {
    e.preventDefault();
    if (!faCommissionModal) return;
    setFaCommissionSaving(true);
    try {
      const token = localStorage.getItem('adminToken');
      await axios.post(
        `${API_URL}/api/admin/field-agent-commission/${faCommissionModal.agentUserId}`,
        { amount: faCommissionAmount, note: faCommissionNote },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      // Refresh commission data
      const res = await axios.get(
        `${API_URL}/api/admin/field-agent-commission/${faCommissionModal.agentUserId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setFaCommissionData(res.data);
      setFaCommissionAmount('');
      setFaCommissionNote('');
    } catch (err) { alert(err?.response?.data?.error || 'Failed to record payment'); }
    finally { setFaCommissionSaving(false); }
  };

  const fetchPartners = async () => {
    setPartnersLoading(true);
    try {
      const token = localStorage.getItem('adminToken');
      const res = await axios.get(`${API_URL}/api/admin/partners`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setPartners(res.data || []);
    } catch {
      setPartners([]);
    } finally {
      setPartnersLoading(false);
    }
  };

  const fetchPartnerRegistrations = async () => {
    setPartnerRegistrationsLoading(true);
    try {
      const token = localStorage.getItem('adminToken');
      const res = await axios.get(`${API_URL}/api/admin/partner-registrations`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setPartnerRegistrations(res.data || []);
    } catch {
      setPartnerRegistrations([]);
    } finally {
      setPartnerRegistrationsLoading(false);
    }
  };

  useEffect(() => {
    fetchPartners();
    fetchPartnerRegistrations();
    axios.get(`${API_URL}/api/admin/partner-vacancies`, { headers: { Authorization: `Bearer ${localStorage.getItem('adminToken')}` } })
      .then((res) => setPartnerVacancyPending((res.data || []).filter((v) => v.status === 'Pending').length))
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (activeTab === 'partners' || activeTab === 'partner-registrations') {
      fetchPartners();
    }
    if (activeTab === 'partner-registrations') {
      fetchPartnerRegistrations();
    }
  }, [activeTab]);

  useEffect(() => {
    if (activeTab === 'partners') {
      setPartnersPage(1);
    }
  }, [activeTab, partnerFilters]);

  useEffect(() => {
    if (activeTab === 'partner-commissions') fetchAdminCommissions();
  }, [activeTab]);

  const fetchAdminCommissions = async () => {
    setPartnerCommissionsLoading(true);
    try {
      const token = localStorage.getItem('adminToken');
      const res = await axios.get(`${API_URL}/api/admin/partner-commissions`, { headers: { Authorization: `Bearer ${token}` } });
      setPartnerCommissions(res.data || []);
    } catch {
      setPartnerCommissions([]);
    } finally {
      setPartnerCommissionsLoading(false);
    }
  };

  const handleMarkCommissionPaid = async (commissionId) => {
    if (!window.confirm('Mark this commission as Paid? (No screenshot — use Accountant Dashboard to attach a receipt.)')) return;
    try {
      const token = localStorage.getItem('adminToken');
      const fd = new FormData();
      await axios.put(`${API_URL}/api/admin/partner-commissions/${commissionId}/mark-paid`, fd, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' },
      });
      setPartnerCommissions((prev) => prev.map((c) => c.id === commissionId ? { ...c, status: 'Paid', paid_at: new Date().toISOString().slice(0, 10) } : c));
    } catch (err) {
      alert(err?.response?.data?.error || 'Failed to mark commission as paid.');
    }
  };

  const handleRecalculateCommissions = async () => {
    if (!window.confirm('This will scan all placed partner members and create any missing commission records. Continue?')) return;
    try {
      const token = localStorage.getItem('adminToken');
      const res = await axios.post(`${API_URL}/api/admin/partner-commissions/recalculate`, {}, { headers: { Authorization: `Bearer ${token}` } });
      const { created, skipped, total_checked } = res.data;
      alert(`Done. Checked: ${total_checked} | Created: ${created} | Skipped (no partner record): ${skipped}`);
      fetchAdminCommissions();
    } catch (err) {
      alert(err?.response?.data?.error || 'Failed to recalculate commissions.');
    }
  };

  const handleStaffChange = (e) => {
    const { name, value } = e.target;
    if (name === 'contact_number') {
      const digitsOnly = value.replace(/\D/g, '').slice(0, 13);
      setStaffForm((prev) => ({ ...prev, [name]: digitsOnly }));
      return;
    }
    setStaffForm((prev) => ({ ...prev, [name]: value }));
  };

  const handlePartnerFilterChange = (e) => {
    const { name, value } = e.target;
    setPartnerFilters((prev) => ({ ...prev, [name]: value }));
  };

  const clearPartnerFilters = () => {
    setPartnerFilters(initialPartnerFilters);
  };

  const handlePartnerFieldChange = (partnerId, field, value) => {
    setPartners((prev) => prev.map((partner) => (
      partner.id === partnerId ? { ...partner, [field]: value } : partner
    )));
  };

  const handlePartnerStatusUpdate = async (partnerId, partnershipStatus, adminNote) => {
    setSavingPartnerId(partnerId);
    try {
      const token = localStorage.getItem('adminToken');
      const res = await axios.put(
        `${API_URL}/api/admin/partners/${partnerId}/status`,
        { partnership_status: partnershipStatus, admin_note: adminNote },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setPartners((prev) => prev.map((partner) => (
        partner.id === partnerId ? res.data.partner : partner
      )));
    } catch (err) {
      alert(err?.response?.data?.error || 'Failed to update partner status.');
    } finally {
      setSavingPartnerId(null);
    }
  };

  const handleDeletePartner = async (partnerId, orgName) => {
    if (!window.confirm(`Delete "${orgName}"? This will permanently remove the partner submission and their account. This cannot be undone.`)) return;
    try {
      const token = localStorage.getItem('adminToken');
      await axios.delete(`${API_URL}/api/admin/partners/${partnerId}`, { headers: { Authorization: `Bearer ${token}` } });
      setPartners((prev) => prev.filter((p) => p.id !== partnerId));
    } catch (err) {
      alert(err?.response?.data?.error || 'Failed to delete partner.');
    }
  };

  const openEditPartner = (partner) => {
    setEditPartnerForm({
      id: partner.id,
      name_of_organisation: partner.name_of_organisation || '',
      owner_of_organisation: partner.owner_of_organisation || '',
      place: partner.place || '',
      district: partner.district || '',
      location_map: partner.location_map || '',
      years_of_experience: partner.years_of_experience || '',
      contact_number: partner.contact_number || '',
      whatsapp_number: partner.whatsapp_number || '',
      email_id: partner.email_id || '',
      website: partner.website || '',
      // current stored files, the newly chosen file, and "remove" flags per upload
      current: {
        organisation_license: partner.organisation_license_file || '',
        organisation_photo: partner.organisation_photo_file || '',
        organisation_name_board_photo: partner.organisation_name_board_photo_file || ''
      },
      files: {},
      remove: {}
    });
  };

  const handleEditPartnerChange = (e) => {
    const { name, value } = e.target;
    const nextValue = (name === 'contact_number' || name === 'whatsapp_number')
      ? value.replace(/\D/g, '').slice(0, 13)
      : value;
    setEditPartnerForm((prev) => ({ ...prev, [name]: nextValue }));
  };

  const handleEditPartnerFile = (field, file) => {
    setEditPartnerForm((prev) => ({
      ...prev,
      files: { ...prev.files, [field]: file || undefined },
      remove: { ...prev.remove, [field]: false }
    }));
  };

  const toggleRemovePartnerFile = (field) => {
    setEditPartnerForm((prev) => ({
      ...prev,
      files: { ...prev.files, [field]: undefined },
      remove: { ...prev.remove, [field]: !prev.remove[field] }
    }));
  };

  const handleEditPartnerSubmit = async (e) => {
    e.preventDefault();
    setSavingPartnerEdit(true);
    try {
      const token = localStorage.getItem('adminToken');
      const formData = new FormData();
      ['name_of_organisation', 'owner_of_organisation', 'place', 'district', 'location_map', 'years_of_experience',
        'contact_number', 'whatsapp_number', 'email_id', 'website'].forEach((key) => formData.append(key, editPartnerForm[key]));
      Object.entries(editPartnerForm.files).forEach(([field, file]) => { if (file) formData.append(field, file); });
      Object.entries(editPartnerForm.remove).forEach(([field, flag]) => { if (flag) formData.append(`remove_${field}`, '1'); });

      const res = await axios.put(`${API_URL}/api/admin/partners/${editPartnerForm.id}`, formData, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setPartners((prev) => prev.map((row) => (
        row.id === editPartnerForm.id ? { ...res.data.partner, partner_password: '' } : row
      )));
      setEditPartnerForm(null);
    } catch (err) {
      alert(err?.response?.data?.error || 'Failed to update partner details.');
    } finally {
      setSavingPartnerEdit(false);
    }
  };

  const handlePartnerAccountSave = async (partner) => {
    setSavingPartnerAccountId(partner.id);
    try {
      const token = localStorage.getItem('adminToken');
      const res = await axios.post(
        `${API_URL}/api/admin/partners/${partner.id}/account`,
        {
          partner_user_id: partner.partner_user_id || '',
          password: partner.partner_password || '',
          commission_percentage: partner.commission_percentage || ''
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setPartners((prev) => prev.map((row) => (
        row.id === partner.id ? { ...res.data.partner, partner_password: '' } : row
      )));
      alert(res.data?.message || 'Partner account saved successfully.');
    } catch (err) {
      alert(err?.response?.data?.error || 'Failed to save partner account.');
    } finally {
      setSavingPartnerAccountId(null);
    }
  };

  const handleStaffSubmit = async (e) => {
    e.preventDefault();
    setStaffSaving(true);
    try {
      const token = localStorage.getItem('adminToken');
      await axios.post(`${API_URL}/api/admin/staff`, staffForm, {
        headers: { Authorization: `Bearer ${token}` }
      });
      alert('Staff created successfully.');
      setStaffForm({ staff_id: '', name: '', contact_number: '', user_id: '', password: '', role: '' });
      fetchStaff();
    } catch (err) {
      alert(err?.response?.data?.error || 'Failed to create staff.');
    } finally {
      setStaffSaving(false);
    }
  };

  const handleDeleteStaff = async (row) => {
    if (!window.confirm(`Delete staff user ${row.name}? This will also remove their forwarded registrations.`)) return;

    setStaffDeletingId(row.id);
    try {
      const token = localStorage.getItem('adminToken');
      await axios.delete(`${API_URL}/api/admin/staff/${row.id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setStaff((prev) => prev.filter((staffMember) => staffMember.id !== row.id));
      alert('Staff deleted successfully.');
    } catch (err) {
      alert(err?.response?.data?.error || 'Failed to delete staff.');
    } finally {
      setStaffDeletingId(null);
    }
  };

  const handleEditRoleSave = async () => {
    if (!editRoleValue.trim()) return;
    setEditRoleSaving(true);
    try {
      const token = localStorage.getItem('adminToken');
      await axios.put(`${API_URL}/api/admin/staff/${editRoleRow.id}/role`, { role: editRoleValue }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setStaff(prev => prev.map(s => s.id === editRoleRow.id ? { ...s, role: editRoleValue } : s));
      setEditRoleRow(null);
    } catch (err) {
      alert(err?.response?.data?.error || 'Failed to update role.');
    } finally {
      setEditRoleSaving(false);
    }
  };

  const handleEditRegistration = (row) => {
    setEditRegistrationForm({
      id: row.id,
      name: row.name || '',
      email: row.email || '',
      place: row.place || '',
      contact_number: row.contact_number || '',
      whatsapp_number: row.whatsapp_number || '',
      district: row.district || '',
      highest_qualification: row.highest_qualification || '',
      expecting_job: row.expecting_job || '',
      department: row.department || '',
      section: row.section || '',
      resume: null,
      photo: null,
      resume_file: row.resume_file || '',
      photo_file: row.photo_file || ''
    });
    setEditRegistrationOpen(true);
  };

  const handleViewRegistration = (row) => {
    setSelectedRegistration(row);
  };

  const handleEditRegistrationChange = (e) => {
    const { name, value, files, type } = e.target;
    if (type === 'file') {
      const file = files && files[0] ? files[0] : null;
      setEditRegistrationForm((prev) => ({ ...prev, [name]: file }));
      return;
    }
    if (name === 'contact_number' || name === 'whatsapp_number') {
      const digitsOnly = value.replace(/\D/g, '').slice(0, 13);
      setEditRegistrationForm((prev) => ({ ...prev, [name]: digitsOnly }));
      return;
    }
    setEditRegistrationForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleUpdateRegistration = async (e) => {
    e.preventDefault();
    setSavingRegistration(true);
    try {
      const token = localStorage.getItem('adminToken');
      const formData = new FormData();
      formData.append('name', editRegistrationForm.name);
      formData.append('email', editRegistrationForm.email);
      formData.append('place', editRegistrationForm.place);
      formData.append('contact_number', editRegistrationForm.contact_number);
      formData.append('whatsapp_number', editRegistrationForm.whatsapp_number);
      formData.append('district', editRegistrationForm.district);
      formData.append('highest_qualification', editRegistrationForm.highest_qualification);
      formData.append('expecting_job', editRegistrationForm.expecting_job);
      formData.append('department', editRegistrationForm.department);
      formData.append('section', editRegistrationForm.section);
      if (editRegistrationForm.resume) formData.append('resume', editRegistrationForm.resume);
      if (editRegistrationForm.photo) formData.append('photo', editRegistrationForm.photo);

      await axios.put(`${API_URL}/api/admin/registrations/${editRegistrationForm.id}`, formData, {
        headers: { Authorization: `Bearer ${token}` }
      });

      setEditRegistrationOpen(false);
      fetchRegistrations();
      alert('Registration updated successfully.');
    } catch (err) {
      alert(err?.response?.data?.error || 'Failed to update registration.');
    } finally {
      setSavingRegistration(false);
    }
  };

  const handleDeleteRegistration = async (id) => {
    if (!window.confirm('Delete this registration?')) return;
    try {
      const token = localStorage.getItem('adminToken');
      await axios.delete(`${API_URL}/api/admin/registrations/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchRegistrations();
      alert('Registration deleted successfully.');
    } catch (err) {
      alert(err?.response?.data?.error || 'Failed to delete registration.');
    }
  };

  const handleForwardRegistration = async (registrationId, isAlreadyForwarded) => {
    if (isAlreadyForwarded) {
      alert('This registration has already been forwarded and cannot be forwarded again.');
      return;
    }
    try {
      const token = localStorage.getItem('adminToken');
      const staffRes = await axios.get(`${API_URL}/api/admin/staff`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      const hrAssistants = (staffRes.data || []).filter((staffMember) => staffMember.role === 'HR Assistant');
      if (hrAssistants.length === 0) {
        alert('No HR Assistant staff found to forward this registration.');
        return;
      }

      const promptText = `Forward to whom?\n${hrAssistants
        .map((staffMember, index) => `${index + 1}. ${staffMember.name} (${staffMember.user_id})`)
        .join('\n')}\n\nEnter number or User ID:`;

      const selectedValue = window.prompt(promptText);
      if (!selectedValue) return;

      const numericChoice = Number(selectedValue);
      let selectedStaff;
      if (!Number.isNaN(numericChoice) && numericChoice >= 1 && numericChoice <= hrAssistants.length) {
        selectedStaff = hrAssistants[numericChoice - 1];
      } else {
        selectedStaff = hrAssistants.find((staffMember) => staffMember.user_id === selectedValue.trim());
      }

      if (!selectedStaff) {
        alert('Invalid selection. Please enter a valid number or User ID from the list.');
        return;
      }

      await axios.post(
        `${API_URL}/api/admin/registrations/${registrationId}/forward`,
        { forwarded_to_user_id: selectedStaff.user_id },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      fetchRegistrations();
      alert(`Registration forwarded to ${selectedStaff.name}.`);
    } catch (err) {
      alert(err?.response?.data?.error || 'Failed to forward registration.');
    }
  };
  // Forward a partner registration to an HR Assistant
  const handleForwardPartnerRegistration = async (regId, isAlreadyForwarded) => {
    if (isAlreadyForwarded) {
      alert('This registration has already been forwarded to HR.');
      return;
    }
    try {
      const token = localStorage.getItem('adminToken');
      const staffRes = await axios.get(`${API_URL}/api/admin/staff`, { headers: { Authorization: `Bearer ${token}` } });
      const hrAssistants = (staffRes.data || []).filter((s) => s.role === 'HR Assistant');
      if (hrAssistants.length === 0) {
        alert('No HR Assistant staff found.');
        return;
      }
      const promptText = `Forward to which HR Assistant?\n${hrAssistants.map((s, i) => `${i + 1}. ${s.name} (${s.user_id})`).join('\n')}\n\nEnter number:`;
      const selected = window.prompt(promptText);
      if (!selected) return;
      const idx = Number(selected);
      const staff = (!Number.isNaN(idx) && idx >= 1 && idx <= hrAssistants.length) ? hrAssistants[idx - 1] : hrAssistants.find((s) => s.user_id === selected.trim());
      if (!staff) { alert('Invalid selection.'); return; }
      await axios.post(`${API_URL}/api/admin/partner-registrations/${regId}/forward-to-hr`, { forwarded_to_user_id: staff.user_id }, { headers: { Authorization: `Bearer ${token}` } });
      setPartnerRegistrations((prev) => prev.map((r) => r.id === regId ? { ...r, forwarded_to_hr: 1 } : r));
      alert(`Forwarded to ${staff.name}.`);
    } catch (err) {
      alert(err?.response?.data?.error || 'Failed to forward registration.');
    }
  };

  // Handle job form change
  const handleJobChange = (e) => {
    setJobForm(f => ({ ...f, [e.target.name]: e.target.value }));
    setJobError('');
    setJobSuccess('');
  };

  // Handle job submit
  const handleJobSubmit = async (e) => {
    e.preventDefault();
    setJobLoading(true);
    setJobError('');
    setJobSuccess('');
    const { title, department, section, experience, salary, location, district, description, company_firm_organisation } = jobForm;
    if (!title || !department || !section || !experience || !salary || !location || !district || !description || !company_firm_organisation) {
      setJobError('All fields are required.');
      setJobLoading(false);
      return;
    }
    try {
      const token = localStorage.getItem('adminToken');
      await axios.post(`${API_URL}/api/jobs`, jobForm, { headers: { Authorization: `Bearer ${token}` } });
      setJobSuccess('Job added successfully!');
      setJobForm({ title: '', department: '', section: '', experience: '', salary: '', location: '', district: '', description: '', company_firm_organisation: '', qualification: '', gender: '', age_limit: '' });
      setShowJobForm(false);
      fetchJobs();
    } catch {
      setJobError('Failed to add job.');
    } finally {
      setJobLoading(false);
    }
  };

  // Handle job delete
  const handleDeleteJob = async (id) => {
    if (!window.confirm('Delete this job?')) return;
    try {
      const token = localStorage.getItem('adminToken');
      await axios.delete(`${API_URL}/api/jobs/${id}`, { headers: { Authorization: `Bearer ${token}` } });
      fetchJobs();
    } catch {
      alert('Failed to delete job.');
    }
  };

  // Handle job edit
  const handleEditJobClick = (job) => {
    setEditJobId(job.id);
    setEditJobForm({
      title: job.title || '',
      department: job.department || '',
      section: job.section || '',
      experience: job.experience || '',
      salary: job.salary || '',
      location: job.location || '',
      district: job.district || '',
      description: job.description || '',
      company_firm_organisation: job.company_firm_organisation || job.company || '',
      qualification: job.qualification || '',
      gender: job.gender || '',
      age_limit: job.age_limit || '',
    });
    setEditJobError('');
  };

  const handleEditJobChange = (e) => {
    setEditJobForm(f => ({ ...f, [e.target.name]: e.target.value }));
    setEditJobError('');
  };

  const handleEditJobSave = async () => {
    const { title, department, section, experience, salary, location, district, description, company_firm_organisation } = editJobForm;
    if (!title || !department || !section || !experience || !salary || !location || !district || !description || !company_firm_organisation) {
      setEditJobError('All fields are required.');
      return;
    }
    setEditJobLoading(true);
    setEditJobError('');
    try {
      const token = localStorage.getItem('adminToken');
      await axios.put(`${API_URL}/api/jobs/${editJobId}`, editJobForm, { headers: { Authorization: `Bearer ${token}` } });
      setEditJobId(null);
      fetchJobs();
    } catch {
      setEditJobError('Failed to update job.');
    } finally {
      setEditJobLoading(false);
    }
  };

  // Banner upload state
  const [bannerFiles, setBannerFiles] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [uploadError, setUploadError] = useState('');
  const [uploadSuccess, setUploadSuccess] = useState('');
  const [previews, setPreviews] = useState([]);
  const [banners, setBanners] = useState([]);
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

  // Scrolling text state
  const [scrollingText, setScrollingText] = useState('');
  const [scrollingTextSaving, setScrollingTextSaving] = useState(false);
  const [scrollingTextMsg, setScrollingTextMsg] = useState('');

  // Poster Creation state
  const PLATFORM_OPTIONS = [
    { id: 'instagram', label: 'Instagram Post', ratio: '1080 × 1080' },
    { id: 'facebook', label: 'Facebook Post', ratio: '1200 × 630' },
    { id: 'whatsapp', label: 'WhatsApp Status', ratio: '1080 × 1920' },
    { id: 'google', label: 'Google Display Ad', ratio: '1200 × 628' }
  ];
  const COLOR_THEME_OPTIONS = [
    { id: 'auto', label: 'Auto (by department)' },
    { id: 'navy_gold', label: 'Navy & Gold' },
    { id: 'maroon_red', label: 'Maroon & Red' },
    { id: 'charcoal_amber', label: 'Charcoal & Amber' },
    { id: 'midnight_blue', label: 'Midnight Blue' },
    { id: 'plum_purple', label: 'Plum & Purple' },
    { id: 'forest_green', label: 'Forest Green' },
    { id: 'teal', label: 'Deep Teal' },
    { id: 'brown_earth', label: 'Earthy Brown' },
    { id: 'slate_admin', label: 'Slate Plum' },
    { id: 'black_gold', label: 'Black & Gold' }
  ];
  const FONT_OPTIONS = [
    { id: 'Poppins', label: 'Poppins (Modern)' },
    { id: 'Montserrat', label: 'Montserrat (Clean)' },
    { id: 'Oswald', label: 'Oswald (Bold Condensed)' },
    { id: 'Merriweather', label: 'Merriweather (Elegant Serif)' }
  ];
  const initialPosterForm = {
    jobId: '', title: '', department: '', description: '',
    salary: '', location: '', experience: '', qualification: '',
    contactPhone: '', contactEmail: '', platform: 'instagram',
    colorTheme: 'auto', fontFamily: 'Poppins'
  };
  const [posterForm, setPosterForm] = useState(initialPosterForm);
  const [posterAdditionalFields, setPosterAdditionalFields] = useState([]); // [{label, value}]
  const [posterSeed, setPosterSeed] = useState(null);
  const [posterGenerating, setPosterGenerating] = useState(false);
  const [posterError, setPosterError] = useState('');
  const [posterResult, setPosterResult] = useState(null); // { id, image_url, seed }
  const [posterHistory, setPosterHistory] = useState([]);
  const [posterHistoryLoading, setPosterHistoryLoading] = useState(false);
  const [posterDeletingId, setPosterDeletingId] = useState(null);
  const [posterPhotoFile, setPosterPhotoFile] = useState(null);
  const [posterPhotoPreview, setPosterPhotoPreview] = useState('');
  const [posterLogoFile, setPosterLogoFile] = useState(null);
  const [posterLogoPreview, setPosterLogoPreview] = useState('');

  const handlePosterPhotoChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setPosterPhotoFile(file);
    setPosterPhotoPreview(URL.createObjectURL(file));
  };
  const clearPosterPhoto = () => { setPosterPhotoFile(null); setPosterPhotoPreview(''); };

  const handlePosterLogoChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setPosterLogoFile(file);
    setPosterLogoPreview(URL.createObjectURL(file));
  };
  const clearPosterLogo = () => { setPosterLogoFile(null); setPosterLogoPreview(''); };

  const fetchPosterHistory = async () => {
    setPosterHistoryLoading(true);
    try {
      const token = localStorage.getItem('adminToken');
      const res = await axios.get(`${API_URL}/api/posters`, { headers: { Authorization: `Bearer ${token}` } });
      setPosterHistory(res.data);
    } catch {
      setPosterHistory([]);
    } finally {
      setPosterHistoryLoading(false);
    }
  };
  useEffect(() => {
    if (activeTab === 'poster-creation') {
      fetchPosterHistory();
      if (jobs.length === 0) fetchJobs();
    }
  }, [activeTab]);

  const handlePosterFieldChange = (e) => {
    const { name, value } = e.target;
    setPosterForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleLoadFromJob = (e) => {
    const jobId = e.target.value;
    if (!jobId) {
      setPosterForm((prev) => ({ ...initialPosterForm, platform: prev.platform, contactPhone: prev.contactPhone, contactEmail: prev.contactEmail }));
      return;
    }
    const job = jobs.find((j) => String(j.id) === String(jobId));
    if (!job) return;
    setPosterForm((prev) => ({
      ...prev,
      jobId,
      title: job.title || '',
      department: job.department || '',
      description: job.description || '',
      salary: job.salary || '',
      location: job.location || job.district || '',
      experience: job.experience || '',
      qualification: job.qualification || ''
    }));
  };

  const handleAddPosterField = () => {
    setPosterAdditionalFields((prev) => [...prev, { label: '', value: '' }]);
  };
  const handlePosterFieldRowChange = (index, key, value) => {
    setPosterAdditionalFields((prev) => prev.map((f, i) => (i === index ? { ...f, [key]: value } : f)));
  };
  const handleRemovePosterField = (index) => {
    setPosterAdditionalFields((prev) => prev.filter((_, i) => i !== index));
  };

  const generatePoster = async (seedOverride) => {
    if (!posterForm.department || !posterForm.description) {
      setPosterError('Please choose a department and enter a description.');
      return;
    }
    setPosterGenerating(true);
    setPosterError('');
    try {
      const token = localStorage.getItem('adminToken');
      const formData = new FormData();
      formData.append('title', posterForm.title);
      formData.append('department', posterForm.department);
      formData.append('description', posterForm.description);
      formData.append('salary', posterForm.salary);
      formData.append('location', posterForm.location);
      formData.append('experience', posterForm.experience);
      formData.append('qualification', posterForm.qualification);
      formData.append('contactPhone', posterForm.contactPhone);
      formData.append('contactEmail', posterForm.contactEmail);
      formData.append('platform', posterForm.platform);
      if (posterForm.colorTheme && posterForm.colorTheme !== 'auto') formData.append('colorTheme', posterForm.colorTheme);
      formData.append('fontFamily', posterForm.fontFamily);
      const validFields = posterAdditionalFields.filter((f) => f.label.trim() && f.value.trim());
      if (validFields.length) formData.append('additionalFields', JSON.stringify(validFields));
      if (seedOverride !== undefined) formData.append('seed', seedOverride);
      if (posterPhotoFile) formData.append('photo', posterPhotoFile);
      if (posterLogoFile) formData.append('logo', posterLogoFile);
      const res = await axios.post(`${API_URL}/api/posters/generate`, formData, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' }
      });
      setPosterResult(res.data);
      setPosterSeed(res.data.seed);
      fetchPosterHistory();
    } catch (err) {
      setPosterError(err?.response?.data?.error || 'Failed to generate poster.');
    } finally {
      setPosterGenerating(false);
    }
  };

  const handleGeneratePoster = (e) => {
    e.preventDefault();
    generatePoster(undefined);
  };

  const handleShuffleTheme = () => {
    const nextSeed = Math.floor(Math.random() * 1_000_000);
    generatePoster(nextSeed);
  };

  const handleDeletePoster = async (id) => {
    if (!window.confirm('Delete this poster?')) return;
    setPosterDeletingId(id);
    try {
      const token = localStorage.getItem('adminToken');
      await axios.delete(`${API_URL}/api/posters/${id}`, { headers: { Authorization: `Bearer ${token}` } });
      setPosterHistory((prev) => prev.filter((p) => p.id !== id));
      if (posterResult?.id === id) setPosterResult(null);
    } catch {
      alert('Failed to delete poster.');
    } finally {
      setPosterDeletingId(null);
    }
  };

  // Prime Members filtered list
  const primeMembers = registrations.filter((row) => row.plan_type === 'prime');

  const dashboardSections = [
    {
      id: 'prime-members',
      title: 'Prime Members',
      shortTitle: 'Prime Members',
      description: 'List and manage all Prime Members. Create user IDs and passwords, and send credentials.',
      metric: primeMembers.length,
      accent: 'from-yellow-100 via-white to-yellow-50'
    },

    {
      id: 'registrations',
      title: 'Talent Pipeline',
      shortTitle: 'Registrations',
      description: 'Review registrations, edit profiles, and forward leads.',
      metric: registrations.length,
      accent: 'from-emerald-100 via-white to-lime-50'
    },
    {
      id: 'jobs',
      title: 'Job Desk',
      shortTitle: 'Jobs',
      description: 'Create, publish, and review active job posts.',
      metric: jobs.length,
      accent: 'from-sky-100 via-white to-cyan-50'
    },
    {
      id: 'partner-registrations',
      title: 'Partner Registrations',
      shortTitle: 'Partner Registrations',
      description: 'Review member details submitted by partner consultancies.',
      metric: partnerRegistrations.length,
      accent: 'from-amber-100 via-white to-orange-50'
    },
    {
      id: 'partners',
      title: 'Partners Desk',
      shortTitle: 'Partners',
      description: 'Track consultancy partnership submissions and attached proof files.',
      metric: partners.length,
      accent: 'from-violet-100 via-white to-fuchsia-50'
    },
    {
      id: 'partner-vacancies',
      title: 'Partner Shared Vacancies',
      shortTitle: 'Shared Vacancies',
      description: 'Vacancies reported by partners. Verify, accept and forward to an Assistant Recruiter.',
      metric: partnerVacancyPending === null ? '—' : partnerVacancyPending,
      accent: 'from-sky-100 via-white to-blue-50'
    },
    {
      id: 'partner-commissions',
      title: 'Partner Commissions',
      shortTitle: 'Commissions',
      description: 'View all partner commissions and mark them as paid.',
      metric: partnerCommissions.filter((c) => c.status === 'Pending').length || '—',
      accent: 'from-purple-100 via-white to-violet-50'
    },
    {
      id: 'banners',
      title: 'Banner Studio',
      shortTitle: 'Banners',
      description: 'Manage homepage visuals and upload sequence.',
      metric: banners.length,
      accent: 'from-amber-100 via-white to-yellow-50'
    },
    {
      id: 'poster-creation',
      title: 'Poster Creation',
      shortTitle: 'Posters',
      description: 'Generate Instagram, Facebook, WhatsApp & Google posters for jobs and announcements — a new theme every time.',
      metric: posterHistory.length || '—',
      accent: 'from-fuchsia-100 via-white to-pink-50'
    },
    {
      id: 'staff',
      title: 'Staff Control',
      shortTitle: 'Staff',
      description: 'Create staff accounts and control role access.',
      metric: staff.length,
      accent: 'from-rose-100 via-white to-orange-50'
    },
    {
      id: 'recruitment',
      title: 'Recruitment Activity',
      shortTitle: 'Recruitment',
      description: 'Live stats: shortlisted candidates, scheduled interviews, placements, and pending approvals.',
      metric: recruitmentStats ? recruitmentStats.shortlisted : '—',
      accent: 'from-indigo-100 via-white to-cyan-50'
    },
    {
      id: 'analysis',
      title: 'Agent & Telecaller Analysis',
      shortTitle: 'Analysis',
      description: 'Leads generated by each agent, calls made by telecallers, conversions, and daily trends.',
      metric: activityReport ? (activityReport.agentStats?.length ?? '—') : '—',
      accent: 'from-yellow-100 via-white to-amber-50'
    },
    {
      id: 'id-setup',
      title: 'ID Setup',
      shortTitle: 'ID Setup',
      description: 'Issue user IDs and passwords to Staff, Partners, Members, and Companies.',
      metric: resetRequests.filter((r) => r.status === 'Pending').length || '—',
      accent: 'from-blue-100 via-white to-indigo-50'
    },
    {
      id: 'target-setup',
      title: 'Target Setup',
      shortTitle: 'Targets',
      description: 'Set performance targets for staff and partner roles.',
      metric: targets.filter((t) => t.is_active).length || '—',
      accent: 'from-green-100 via-white to-emerald-50'
    },
    {
      id: 'field-agents',
      title: 'Field Agent Control',
      shortTitle: 'Field Agents',
      description: 'Review leads submitted by field agents, accept or reject them, and manage commission payments.',
      metric: fieldAgentLeads.filter((l) => l.status === 'Pending').length || '—',
      accent: 'from-orange-100 via-white to-amber-50'
    },
    {
      id: 'internship',
      title: 'Internship Applications',
      shortTitle: 'Internship',
      description: 'Review internship applications submitted by students and graduates.',
      metric: internships.filter(r => !r.is_seen).length || internships.length || '—',
      accent: 'from-blue-100 via-white to-indigo-50'
    }
  ];

  const activeSection = dashboardSections.find((section) => section.id === activeTab) || dashboardSections[0];
  const normalizedFilterValue = (value) => String(value || '').toLowerCase().trim();
  const filteredRegistrations = registrations.filter((row) => {
    const matchesName = normalizedFilterValue(row.name).includes(normalizedFilterValue(registrationFilters.name));
    const matchesDistrict = normalizedFilterValue(row.district).includes(normalizedFilterValue(registrationFilters.district));
    const matchesContact = normalizedFilterValue(row.contact_number).includes(normalizedFilterValue(registrationFilters.contact));
    const matchesDepartment = normalizedFilterValue(row.department).includes(normalizedFilterValue(registrationFilters.department));
    const matchesExpectingJob = normalizedFilterValue(row.expecting_job).includes(normalizedFilterValue(registrationFilters.expectingJob));
    const matchesForwardStatus = registrationFilters.forwardStatus === 'all'
      ? true
      : registrationFilters.forwardStatus === 'forwarded'
        ? Number(row.is_forwarded || 0) > 0
        : Number(row.is_forwarded || 0) === 0;

    return matchesName && matchesDistrict && matchesContact && matchesDepartment && matchesExpectingJob && matchesForwardStatus;
  });
  const totalRegistrationPages = Math.max(1, Math.ceil(filteredRegistrations.length / REGISTRATIONS_PAGE_SIZE));
  const safeRegistrationsPage = Math.min(registrationsPage, totalRegistrationPages);
  const paginatedRegistrations = filteredRegistrations.slice(
    (safeRegistrationsPage - 1) * REGISTRATIONS_PAGE_SIZE,
    safeRegistrationsPage * REGISTRATIONS_PAGE_SIZE
  );
  const filteredPartners = partners.filter((partner) => {
    const searchValue = normalizedFilterValue(partnerFilters.search);
    const districtValue = normalizedFilterValue(partnerFilters.district);
    const statusValue = normalizedFilterValue(partnerFilters.status);
    const matchesSearch = !searchValue || [
      partner.name_of_organisation,
      partner.owner_of_organisation,
      partner.contact_number,
      partner.whatsapp_number,
      partner.email_id,
      partner.partner_user_id
    ].some((value) => normalizedFilterValue(value).includes(searchValue));
    const matchesDistrict = normalizedFilterValue(partner.district).includes(districtValue);
    const matchesStatus = statusValue === 'all' || normalizedFilterValue(partner.partnership_status) === statusValue;
    return matchesSearch && matchesDistrict && matchesStatus;
  });
  const totalPartnerPages = Math.max(1, Math.ceil(filteredPartners.length / PARTNERS_PAGE_SIZE));
  const safePartnersPage = Math.min(partnersPage, totalPartnerPages);
  const paginatedPartners = filteredPartners.slice(
    (safePartnersPage - 1) * PARTNERS_PAGE_SIZE,
    safePartnersPage * PARTNERS_PAGE_SIZE
  );

  useEffect(() => {
    if (partnersPage > totalPartnerPages) {
      setPartnersPage(totalPartnerPages);
    }
  }, [partnersPage, totalPartnerPages]);

  useEffect(() => {
    if (registrationsPage > totalRegistrationPages) {
      setRegistrationsPage(totalRegistrationPages);
    }
  }, [registrationsPage, totalRegistrationPages]);

  useEffect(() => {
    setRegistrationsPage(1);
  }, [registrationFilters]);

  const handleRegistrationFilterChange = (e) => {
    const { name, value } = e.target;
    setRegistrationFilters((prev) => ({ ...prev, [name]: value }));
  };

  const clearRegistrationFilters = () => {
    setRegistrationFilters(initialRegistrationFilters);
  };

  // Fetch banners on mount and after upload/delete
  const fetchBanners = async () => {
    try {
      const res = await axios.get(`${API_URL}/api/banners`);
      setBanners(res.data);
    } catch {
      setBanners([]);
    }
  };
  useEffect(() => { fetchBanners(); }, []);

  // Fetch scrolling text on banner tab open
  useEffect(() => {
    if (activeTab === 'banners') {
      axios.get(`${API_URL}/api/scrolling-text`).then(r => setScrollingText(r.data.text || '')).catch(() => {});
    }
  }, [activeTab]);

  const handleSaveScrollingText = async () => {
    setScrollingTextSaving(true);
    setScrollingTextMsg('');
    try {
      const token = localStorage.getItem('adminToken');
      await axios.put(`${API_URL}/api/scrolling-text`, { text: scrollingText }, { headers: { Authorization: `Bearer ${token}` } });
      setScrollingTextMsg('Saved successfully!');
    } catch {
      setScrollingTextMsg('Failed to save.');
    } finally {
      setScrollingTextSaving(false);
    }
  };

  // Handle file selection
  const handleBannerChange = (e) => {
    const files = Array.from(e.target.files).slice(0, 5);
    setBannerFiles(files);
    setPreviews(files.map(file => URL.createObjectURL(file)));
    setUploadError('');
    setUploadSuccess('');
  };

  // Handle upload
  const handleBannerUpload = async (e) => {
    e.preventDefault();
    setUploading(true);
    setUploadError('');
    setUploadSuccess('');
    try {
      const formData = new FormData();
      bannerFiles.forEach(file => formData.append('banners', file));
      const token = localStorage.getItem('adminToken');
      await axios.post(`${API_URL}/api/banners`, formData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      });
      setUploadSuccess('Banners uploaded successfully!');
      setBannerFiles([]);
      setPreviews([]);
      fetchBanners();
    } catch (err) {
      const status = err?.response?.status;
      const msg = err?.response?.data?.error;
      if (status === 413) setUploadError('Upload failed: File too large. Keep each image under 5MB.');
      else if (status === 401 || status === 403) setUploadError('Upload failed: Not authorized. Please log in again.');
      else if (status === 400) setUploadError(`Upload failed: ${msg || 'No file selected.'}`);
      else setUploadError(`Upload failed: ${msg || err?.message || 'Server error. Check your connection.'}`);
    } finally {
      setUploading(false);
    }
  };

  // Delete a banner by id
  const handleDeleteBanner = async (id) => {
    if (!window.confirm('Are you sure you want to delete this banner?')) return;
    try {
      const token = localStorage.getItem('adminToken');
      await axios.delete(`${API_URL}/api/banners/${id}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      fetchBanners();
    } catch {
      alert('Failed to delete banner.');
    }
  };

  const handleChangePassword = async () => {
    setChangePwMsg(null);
    if (!changePwForm.current || !changePwForm.newPw || !changePwForm.confirm) {
      setChangePwMsg({ type: 'error', text: 'Please fill all fields.' }); return;
    }
    if (changePwForm.newPw !== changePwForm.confirm) {
      setChangePwMsg({ type: 'error', text: 'New passwords do not match.' }); return;
    }
    if (changePwForm.newPw.length < 4) {
      setChangePwMsg({ type: 'error', text: 'New password must be at least 4 characters.' }); return;
    }
    setChangePwLoading(true);
    try {
      await axios.put(`${API_URL}/api/admin/change-password`,
        { current_password: changePwForm.current, new_password: changePwForm.newPw },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setChangePwMsg({ type: 'success', text: 'Password changed successfully!' });
      setChangePwForm({ current: '', newPw: '', confirm: '' });
    } catch (err) {
      setChangePwMsg({ type: 'error', text: err.response?.data?.error || 'Failed to change password.' });
    } finally {
      setChangePwLoading(false);
    }
  };

  return (
    <div style={{ zoom: '0.9' }} className="min-h-screen bg-gray-50 font-official">
      <div className="w-full">

        {/* ── Top header bar ────────────────────────────────────────────── */}
        <div className="sticky top-0 z-30 bg-[#111] px-5 py-3 shadow-lg">
          <div className="flex items-center justify-between">
            {/* Brand */}
            <div className="flex items-center gap-3">
              <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-yellow-400">
                <span className="text-lg font-black text-black">D</span>
              </div>
              <div>
                <p className="text-[10px] font-extrabold uppercase tracking-widest text-yellow-400">Admin</p>
                <p className="text-sm font-black leading-none text-white">Dani Job Club</p>
              </div>
            </div>

            {/* Metric pills — all sections at a glance */}
            <div className="hidden lg:flex min-w-0 flex-1 items-center gap-1.5 overflow-x-auto scrollbar-none">
              {dashboardSections.map((s) => (
                <button key={s.id} type="button" onClick={() => setActiveTab(s.id)}
                  className={`flex shrink-0 items-center gap-1.5 rounded-full px-3 py-1 text-[11px] font-bold transition ${
                    activeTab === s.id
                      ? 'bg-yellow-400 text-black'
                      : 'bg-white/10 text-white/80 hover:bg-white/20'
                  }`}>
                  {s.shortTitle}
                  {s.metric !== '—' && <span className={`rounded-full px-1.5 text-[10px] font-extrabold ${activeTab === s.id ? 'bg-black/20 text-black' : 'bg-white/20 text-white'}`}>{s.metric}</span>}
                </button>
              ))}
            </div>

            {/* Right side — Change Password button */}
            <div className="flex items-center gap-2 shrink-0">
              <span className="hidden lg:block text-[11px] text-white/50">Admin</span>
              <button
                onClick={() => { setChangePwOpen(true); setChangePwMsg(null); setChangePwForm({ current: '', newPw: '', confirm: '' }); }}
                className="flex items-center gap-1.5 rounded-full bg-white/10 px-3 py-1.5 text-xs font-bold text-white/80 hover:bg-yellow-400 hover:text-black transition"
                title="Change Password"
              >
                🔒 <span className="hidden sm:inline">Change Password</span>
              </button>
            </div>

            {/* Active section label (mobile) */}
            <div className="lg:hidden">
              <span className="rounded-full bg-yellow-400 px-3 py-1 text-xs font-black text-black">{activeSection.shortTitle}</span>
            </div>
          </div>
        </div>

        {/* ── Mobile / tablet tab scroll bar ──────────────────────────────── */}
        <div className="flex gap-1 overflow-x-auto bg-white border-b border-gray-200 px-4 py-2 scrollbar-none lg:hidden">
          {dashboardSections.map((s) => (
            <button key={s.id} type="button" onClick={() => setActiveTab(s.id)}
              className={`flex-shrink-0 rounded-full px-3 py-1.5 text-xs font-bold transition ${
                activeTab === s.id ? 'bg-black text-yellow-300' : 'border border-gray-200 bg-white text-gray-600 hover:border-gray-400'
              }`}>
              {s.shortTitle}
              {s.metric !== '—' && <span className={`ml-1 text-[10px] font-extrabold ${activeTab === s.id ? 'text-yellow-400' : 'text-gray-400'}`}>{s.metric}</span>}
            </button>
          ))}
        </div>

        {/* ── Page content area ─────────────────────────────────────────── */}
        <div className="px-4 py-4 md:px-6">
          {/* Section title + description */}
          <div className="mb-4 flex items-center justify-between">
            <div>
              <h1 className="text-xl font-black text-gray-900">{activeSection.title}</h1>
              <p className="mt-0.5 text-xs text-gray-400">{activeSection.description}</p>
            </div>
            <div className="hidden sm:flex items-center gap-2">
              <span className="rounded-xl bg-black px-4 py-1.5 text-sm font-black text-yellow-300">{activeSection.metric !== '—' ? activeSection.metric : '—'}</span>
            </div>
          </div>

          <div>


      {/* Tab content */}
      {activeTab === 'prime-members' && (
        <div className="rounded-[28px] border border-yellow-200 bg-white p-5 shadow-sm">
          <h2 className="mb-4 text-xl font-black text-yellow-700">Prime Members</h2>
          <div className="overflow-x-auto">
            <table className="min-w-full rounded-2xl bg-white shadow-sm">
              <thead>
                <tr>
                  <th className="px-3 py-2 border">Name</th>
                  <th className="px-3 py-2 border">Contact</th>
                  <th className="px-3 py-2 border">User ID</th>
                  <th className="px-3 py-2 border">Password</th>
                  <th className="px-3 py-2 border">Actions</th>
                </tr>
              </thead>
              <tbody>
                {primeMembers.length === 0 && (
                  <tr>
                    <td colSpan="5" className="text-center text-gray-500 px-3 py-3 border">No prime members found.</td>
                  </tr>
                )}
                {primeMembers.map((member) => {
                  // Assume user_id and password fields are present or can be checked
                  const hasAccount = !!member.user_id;
                  return (
                    <tr key={member.id}>
                      <td className="px-3 py-2 border font-semibold">{member.name}</td>
                      <td className="px-3 py-2 border">{member.contact_number || '-'}</td>
                      <td className="px-3 py-2 border">{member.user_id || <span className="text-gray-400">Not created</span>}</td>
                      <td className="px-3 py-2 border">{hasAccount ? '********' : <span className="text-gray-400">Not set</span>}</td>
                      <td className="px-3 py-2 border">
                        {!hasAccount ? (
                          <button className="rounded bg-yellow-400 px-3 py-1 text-xs font-bold text-black hover:bg-yellow-500" onClick={() => {/* TODO: trigger account creation modal/flow */}}>Create Account</button>
                        ) : (
                          <>
                            <button className="rounded bg-emerald-500 px-3 py-1 text-xs font-bold text-white hover:bg-emerald-600 mr-2" onClick={() => {/* TODO: trigger send credentials flow */}}>Send Credentials</button>
                          </>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {activeTab === 'banners' && (
        <div className="space-y-6">
          <div className="rounded-[28px] border border-gray-200 bg-white p-5 shadow-sm">
            <h2 className="mb-4 text-xl font-black text-black">Banner Settings</h2>
            <form onSubmit={handleBannerUpload} className="flex flex-col gap-4">
              <input
                type="file"
                accept="image/*"
                multiple
                onChange={handleBannerChange}
                disabled={uploading}
                className="rounded-2xl border border-gray-300 bg-gray-50 px-3 py-2.5"
              />
              <div className="flex gap-2 flex-wrap">
                {previews.map((src, idx) => (
                  <img key={idx} src={src} alt={`Banner Preview ${idx+1}`} className="h-16 w-24 rounded-xl border object-cover" />
                ))}
              </div>
              <button type="submit" className="rounded-xl bg-yellow-400 px-4 py-2.5 font-extrabold text-black transition hover:bg-yellow-500" disabled={uploading || bannerFiles.length === 0}>
                {uploading ? 'Uploading...' : 'Upload Banners'}
              </button>
              {uploadError && <div className="text-red-600">{uploadError}</div>}
              {uploadSuccess && <div className="text-green-600">{uploadSuccess}</div>}
            </form>
          </div>
          <div>
            <h3 className="mb-3 text-lg font-black text-black">Current Banners (Home Page Order)</h3>
            <div className="flex flex-wrap gap-4">
              {banners.length === 0 && <div className="text-gray-500">No banners uploaded.</div>}
              {banners.map((banner, idx) => (
                <div key={banner.id} className="flex flex-col items-center rounded-[22px] border border-gray-200 bg-gray-50 p-3 shadow-sm">
                  <img
                    src={banner.image_url.startsWith('http') ? banner.image_url : `${API_URL}${banner.image_url}`}
                    alt={banner.title || `Banner ${idx+1}`}
                    className="mb-2 h-24 w-40 rounded-xl object-cover"
                    onError={e => { e.target.onerror = null; e.target.src = logo; }}
                  />
                  <div className="text-xs text-gray-700 mb-1 truncate w-36" title={banner.title}>{banner.title}</div>
                  <div className="text-xs text-gray-400 mb-1">#{idx+1} {idx === 0 && <span className="font-bold text-green-600">(First)</span>}</div>
                  <button
                    className="rounded-lg border border-red-400 px-3 py-1 text-xs font-bold text-red-600 hover:bg-red-100"
                    onClick={() => handleDeleteBanner(banner.id)}
                  >Delete</button>
                </div>
              ))}
            </div>
          </div>

          {/* Scrolling Text */}
          <div className="rounded-[28px] border border-yellow-200 bg-white p-5 shadow-sm">
            <h2 className="mb-1 text-xl font-black text-black">Scrolling Text</h2>
            <p className="mb-4 text-sm text-gray-500">This text scrolls across the home page between the banner and contact section.</p>
            <textarea
              rows={3}
              value={scrollingText}
              onChange={e => { setScrollingText(e.target.value); setScrollingTextMsg(''); }}
              placeholder="e.g. Now hiring in Kochi, Thrissur and Kozhikode — Register today! | Walk-in interviews every Saturday"
              className="w-full rounded-2xl border border-gray-300 bg-gray-50 px-4 py-3 text-sm text-black outline-none focus:border-yellow-400 focus:ring-2 focus:ring-yellow-200 resize-none"
            />
            <div className="mt-3 flex items-center gap-4">
              <button
                onClick={handleSaveScrollingText}
                disabled={scrollingTextSaving}
                className="rounded-xl bg-black px-5 py-2.5 text-sm font-extrabold text-yellow-400 hover:bg-gray-900 transition disabled:opacity-60"
              >
                {scrollingTextSaving ? 'Saving...' : 'Save Scrolling Text'}
              </button>
              {scrollingTextMsg && (
                <span className={`text-sm font-bold ${scrollingTextMsg.includes('success') ? 'text-green-600' : 'text-red-600'}`}>
                  {scrollingTextMsg}
                </span>
              )}
            </div>
          </div>
        </div>
      )}

      {activeTab === 'poster-creation' && (
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)]">
          {/* Form */}
          <div className="rounded-[28px] border border-gray-200 bg-white p-5 shadow-sm">
            <h2 className="mb-1 text-xl font-black text-black">Poster Creation</h2>
            <p className="mb-4 text-sm text-gray-500">Pick a department, describe the opportunity, and generate a ready-to-share poster. Each generation picks its own theme, colors, and layout.</p>
            <form onSubmit={handleGeneratePoster} className="flex flex-col gap-3">
              <label className="text-sm font-semibold text-gray-700">Load from an existing job (optional)
                <select
                  value={posterForm.jobId}
                  onChange={handleLoadFromJob}
                  className="mt-1 w-full rounded-2xl border border-gray-300 bg-gray-50 p-2.5 text-sm"
                >
                  <option value="">— Start from scratch —</option>
                  {jobs.map((j) => (
                    <option key={j.id} value={j.id}>{j.title} · {j.department}</option>
                  ))}
                </select>
              </label>

              <label className="text-sm font-semibold text-gray-700">Title
                <input
                  name="title"
                  value={posterForm.title}
                  onChange={handlePosterFieldChange}
                  placeholder="e.g. We're Hiring: Accountant"
                  className="mt-1 w-full rounded-2xl border border-gray-300 bg-gray-50 p-2.5 text-sm"
                />
              </label>

              <label className="text-sm font-semibold text-gray-700">Department <span className="text-red-500">*</span>
                <input
                  name="department"
                  list="dl-poster-department"
                  autoComplete="off"
                  value={posterForm.department}
                  onChange={handlePosterFieldChange}
                  placeholder="Choose the department — sets the poster's theme"
                  className="mt-1 w-full rounded-2xl border border-gray-300 bg-gray-50 p-2.5 text-sm"
                  required
                />
                <datalist id="dl-poster-department">{DEPARTMENTS.map((d) => <option key={d} value={d} />)}</datalist>
              </label>

              <label className="text-sm font-semibold text-gray-700">Describe the opportunity <span className="text-red-500">*</span>
                <textarea
                  name="description"
                  rows={4}
                  value={posterForm.description}
                  onChange={handlePosterFieldChange}
                  placeholder={'One point per line works best, e.g.\nMust know Tally and GST\nGood communication skills\nImmediate joining preferred'}
                  className="mt-1 w-full resize-none rounded-2xl border border-gray-300 bg-gray-50 p-2.5 text-sm"
                  required
                />
                <span className="text-xs font-normal text-gray-400">Each line (or sentence) becomes a bullet point on the poster.</span>
              </label>

              <div className="grid grid-cols-2 gap-3">
                <label className="text-sm font-semibold text-gray-700">Salary
                  <input name="salary" value={posterForm.salary} onChange={handlePosterFieldChange} placeholder="e.g. 25,000 - 30,000" className="mt-1 w-full rounded-2xl border border-gray-300 bg-gray-50 p-2.5 text-sm" />
                </label>
                <label className="text-sm font-semibold text-gray-700">Location
                  <input name="location" value={posterForm.location} onChange={handlePosterFieldChange} placeholder="e.g. Kochi" className="mt-1 w-full rounded-2xl border border-gray-300 bg-gray-50 p-2.5 text-sm" />
                </label>
                <label className="text-sm font-semibold text-gray-700">Experience
                  <input name="experience" value={posterForm.experience} onChange={handlePosterFieldChange} placeholder="e.g. 2+ years" className="mt-1 w-full rounded-2xl border border-gray-300 bg-gray-50 p-2.5 text-sm" />
                </label>
                <label className="text-sm font-semibold text-gray-700">Qualification
                  <input name="qualification" value={posterForm.qualification} onChange={handlePosterFieldChange} placeholder="e.g. B.Com" className="mt-1 w-full rounded-2xl border border-gray-300 bg-gray-50 p-2.5 text-sm" />
                </label>
                <label className="text-sm font-semibold text-gray-700">Contact Phone
                  <input name="contactPhone" value={posterForm.contactPhone} onChange={handlePosterFieldChange} placeholder="e.g. +91 95608 04666" className="mt-1 w-full rounded-2xl border border-gray-300 bg-gray-50 p-2.5 text-sm" />
                </label>
                <label className="text-sm font-semibold text-gray-700">Contact Email
                  <input name="contactEmail" value={posterForm.contactEmail} onChange={handlePosterFieldChange} placeholder="e.g. job@danijobclub.com" className="mt-1 w-full rounded-2xl border border-gray-300 bg-gray-50 p-2.5 text-sm" />
                </label>
              </div>

              <div className="grid grid-cols-2 gap-3">
                <div>
                  <span className="mb-1.5 block text-sm font-semibold text-gray-700">Photo (optional)</span>
                  {posterPhotoPreview ? (
                    <div className="flex items-center gap-2">
                      <img src={posterPhotoPreview} alt="Photo preview" className="h-14 w-14 rounded-xl border object-cover" />
                      <button type="button" onClick={clearPosterPhoto} className="rounded-lg border border-red-400 px-2 py-1 text-[11px] font-bold text-red-600 hover:bg-red-100">Remove</button>
                    </div>
                  ) : (
                    <input type="file" accept="image/*" onChange={handlePosterPhotoChange} className="w-full rounded-2xl border border-gray-300 bg-gray-50 p-2 text-xs" />
                  )}
                  <span className="mt-1 block text-[11px] font-normal text-gray-400">Shown in a photo panel on the poster.</span>
                </div>
                <div>
                  <span className="mb-1.5 block text-sm font-semibold text-gray-700">Custom Logo (optional)</span>
                  {posterLogoPreview ? (
                    <div className="flex items-center gap-2">
                      <img src={posterLogoPreview} alt="Logo preview" className="h-14 w-14 rounded-xl border object-contain bg-white" />
                      <button type="button" onClick={clearPosterLogo} className="rounded-lg border border-red-400 px-2 py-1 text-[11px] font-bold text-red-600 hover:bg-red-100">Remove</button>
                    </div>
                  ) : (
                    <input type="file" accept="image/*" onChange={handlePosterLogoChange} className="w-full rounded-2xl border border-gray-300 bg-gray-50 p-2 text-xs" />
                  )}
                  <span className="mt-1 block text-[11px] font-normal text-gray-400">Defaults to the Dani Job Club logo.</span>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-3">
                <label className="text-sm font-semibold text-gray-700">Color Theme
                  <select name="colorTheme" value={posterForm.colorTheme} onChange={handlePosterFieldChange} className="mt-1 w-full rounded-2xl border border-gray-300 bg-gray-50 p-2.5 text-sm">
                    {COLOR_THEME_OPTIONS.map((t) => <option key={t.id} value={t.id}>{t.label}</option>)}
                  </select>
                </label>
                <label className="text-sm font-semibold text-gray-700">Font
                  <select name="fontFamily" value={posterForm.fontFamily} onChange={handlePosterFieldChange} className="mt-1 w-full rounded-2xl border border-gray-300 bg-gray-50 p-2.5 text-sm">
                    {FONT_OPTIONS.map((f) => <option key={f.id} value={f.id}>{f.label}</option>)}
                  </select>
                </label>
              </div>

              <div>
                <div className="mb-1.5 flex items-center justify-between">
                  <span className="text-sm font-semibold text-gray-700">Additional Details (optional)</span>
                  <button type="button" onClick={handleAddPosterField} className="rounded-lg bg-gray-900 px-2.5 py-1 text-[11px] font-bold text-yellow-300 hover:bg-black">+ Add Field</button>
                </div>
                {posterAdditionalFields.length === 0 && (
                  <span className="text-[11px] font-normal text-gray-400">Add any extra badge, e.g. "Shift: Day Only" or "Openings: 5 Positions".</span>
                )}
                <div className="flex flex-col gap-2">
                  {posterAdditionalFields.map((f, idx) => (
                    <div key={idx} className="flex items-center gap-2">
                      <input
                        value={f.label}
                        onChange={(e) => handlePosterFieldRowChange(idx, 'label', e.target.value)}
                        placeholder="Label (e.g. Shift)"
                        className="w-1/2 rounded-2xl border border-gray-300 bg-gray-50 p-2 text-sm"
                      />
                      <input
                        value={f.value}
                        onChange={(e) => handlePosterFieldRowChange(idx, 'value', e.target.value)}
                        placeholder="Value (e.g. Day Only)"
                        className="w-1/2 rounded-2xl border border-gray-300 bg-gray-50 p-2 text-sm"
                      />
                      <button type="button" onClick={() => handleRemovePosterField(idx)} className="shrink-0 rounded-lg border border-red-400 px-2 py-1.5 text-[11px] font-bold text-red-600 hover:bg-red-100">✕</button>
                    </div>
                  ))}
                </div>
              </div>

              <div className="mt-1">
                <span className="mb-1.5 block text-sm font-semibold text-gray-700">Platform</span>
                <div className="flex flex-wrap gap-2">
                  {PLATFORM_OPTIONS.map((p) => (
                    <button
                      key={p.id}
                      type="button"
                      onClick={() => setPosterForm((prev) => ({ ...prev, platform: p.id }))}
                      className={`rounded-2xl border px-3 py-2 text-left text-xs font-bold transition ${
                        posterForm.platform === p.id ? 'border-black bg-black text-yellow-300' : 'border-gray-200 bg-gray-50 text-gray-600 hover:border-gray-400'
                      }`}
                    >
                      {p.label}
                      <div className="text-[10px] font-normal opacity-70">{p.ratio}</div>
                    </button>
                  ))}
                </div>
              </div>

              {posterError && <div className="text-sm font-semibold text-red-600">{posterError}</div>}

              <div className="mt-2 flex gap-2">
                <button
                  type="submit"
                  disabled={posterGenerating}
                  className="flex-1 rounded-xl bg-yellow-400 px-4 py-2.5 font-extrabold text-black transition hover:bg-yellow-500 disabled:opacity-60"
                >
                  {posterGenerating ? 'Generating…' : 'Generate Poster'}
                </button>
                {posterResult && (
                  <button
                    type="button"
                    onClick={handleShuffleTheme}
                    disabled={posterGenerating}
                    className="rounded-xl bg-black px-4 py-2.5 font-extrabold text-yellow-300 transition hover:bg-gray-900 disabled:opacity-60"
                    title="Regenerate with a different theme, palette & layout"
                  >
                    🔀 Shuffle Theme
                  </button>
                )}
              </div>
            </form>
          </div>

          {/* Preview */}
          <div className="rounded-[28px] border border-gray-200 bg-white p-5 shadow-sm">
            <h2 className="mb-4 text-xl font-black text-black">Preview</h2>
            {!posterResult && !posterGenerating && (
              <div className="flex h-64 items-center justify-center rounded-2xl border border-dashed border-gray-300 text-sm text-gray-400">
                Your generated poster will appear here.
              </div>
            )}
            {posterGenerating && (
              <div className="flex h-64 items-center justify-center rounded-2xl border border-dashed border-gray-300 text-sm text-gray-400">
                Generating your poster…
              </div>
            )}
            {posterResult && !posterGenerating && (
              <div className="flex flex-col items-center gap-3">
                <img
                  src={`${API_URL}${posterResult.image_url}`}
                  alt="Generated poster"
                  className="max-h-[520px] rounded-2xl border border-gray-200 object-contain shadow-sm"
                />
                <a
                  href={`${API_URL}${posterResult.image_url}`}
                  download
                  target="_blank"
                  rel="noreferrer"
                  className="rounded-xl bg-emerald-500 px-4 py-2 text-sm font-bold text-white hover:bg-emerald-600"
                >
                  ⬇ Download Poster
                </a>
              </div>
            )}

            <h3 className="mb-3 mt-6 text-lg font-black text-black">Recent Posters</h3>
            {posterHistoryLoading && <div className="text-sm text-gray-400">Loading…</div>}
            {!posterHistoryLoading && posterHistory.length === 0 && (
              <div className="text-sm text-gray-400">No posters generated yet.</div>
            )}
            <div className="flex flex-wrap gap-3">
              {posterHistory.map((p) => (
                <div key={p.id} className="flex flex-col items-center rounded-[18px] border border-gray-200 bg-gray-50 p-2 shadow-sm">
                  <img
                    src={`${API_URL}${p.image_url}`}
                    alt={p.title || p.department}
                    className="mb-1.5 h-24 w-24 rounded-xl object-cover"
                  />
                  <div className="w-24 truncate text-center text-[10px] text-gray-600" title={p.title || p.department}>{p.title || p.department}</div>
                  <button
                    className="mt-1 rounded-lg border border-red-400 px-2 py-0.5 text-[10px] font-bold text-red-600 hover:bg-red-100 disabled:opacity-50"
                    onClick={() => handleDeletePoster(p.id)}
                    disabled={posterDeletingId === p.id}
                  >
                    {posterDeletingId === p.id ? '…' : 'Delete'}
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {activeTab === 'jobs' && (
        <>
        <div className="space-y-6">
          <div className="rounded-[28px] border border-gray-200 bg-white p-5 shadow-sm">
            <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
              <div>
                <h2 className="text-xl font-black text-black">Add New Job</h2>
                <p className="mt-1 text-sm text-gray-600">Open the form only when you need to create a new job post.</p>
              </div>
              <button
                type="button"
                onClick={() => {
                  setShowJobForm((prev) => !prev);
                  setJobError('');
                  setJobSuccess('');
                }}
                className="rounded-xl bg-yellow-400 px-5 py-3 text-sm font-extrabold text-black transition hover:bg-yellow-500"
              >
                {showJobForm ? 'Hide Form' : 'Add Job'}
              </button>
            </div>

            {showJobForm && (
              <form onSubmit={handleJobSubmit} className="mt-5 grid grid-cols-1 gap-4 md:grid-cols-2">
                <input name="title" value={jobForm.title} onChange={handleJobChange} placeholder="Title" className="rounded-2xl border border-gray-300 bg-gray-50 p-3" />
                <input name="department" value={jobForm.department} onChange={handleJobChange} placeholder="Department" className="rounded-2xl border border-gray-300 bg-gray-50 p-3" />
                <input name="section" value={jobForm.section} onChange={handleJobChange} placeholder="Section" className="rounded-2xl border border-gray-300 bg-gray-50 p-3" />
                <input name="qualification" value={jobForm.qualification} onChange={handleJobChange} placeholder="Qualification" className="rounded-2xl border border-gray-300 bg-gray-50 p-3" />
                <select name="gender" value={jobForm.gender} onChange={handleJobChange} className="rounded-2xl border border-gray-300 bg-gray-50 p-3">
                  <option value="">Gender (Any)</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Any">Any</option>
                </select>
                <input name="age_limit" value={jobForm.age_limit} onChange={handleJobChange} placeholder="Age Limit (e.g. 18-35)" className="rounded-2xl border border-gray-300 bg-gray-50 p-3" />
                <input name="experience" value={jobForm.experience} onChange={handleJobChange} placeholder="Experience" className="rounded-2xl border border-gray-300 bg-gray-50 p-3" />
                <input name="salary" value={jobForm.salary} onChange={handleJobChange} placeholder="Salary" className="rounded-2xl border border-gray-300 bg-gray-50 p-3" />
                <input name="location" value={jobForm.location} onChange={handleJobChange} placeholder="Location" className="rounded-2xl border border-gray-300 bg-gray-50 p-3" />
                <input name="district" value={jobForm.district} onChange={handleJobChange} placeholder="District" className="rounded-2xl border border-gray-300 bg-gray-50 p-3" />
                <input name="company_firm_organisation" value={jobForm.company_firm_organisation} onChange={handleJobChange} placeholder="Company / Firm / Organisation" className="rounded-2xl border border-gray-300 bg-gray-50 p-3" />
                <textarea name="description" value={jobForm.description} onChange={handleJobChange} placeholder="Description" className="rounded-2xl border border-gray-300 bg-gray-50 p-3 md:col-span-2" rows={2} />
                <div className="flex gap-3 md:col-span-2 md:justify-end">
                  <button
                    type="button"
                    onClick={() => {
                      setShowJobForm(false);
                      setJobError('');
                    }}
                    className="rounded-xl border border-gray-300 px-4 py-2.5 font-bold text-black transition hover:border-yellow-400"
                  >
                    Cancel
                  </button>
                  <button type="submit" className="rounded-xl bg-yellow-400 px-4 py-2.5 font-extrabold text-black transition hover:bg-yellow-500" disabled={jobLoading}>
                    {jobLoading ? 'Saving...' : 'Add Job'}
                  </button>
                </div>
                {jobError && <div className="text-red-600 md:col-span-2">{jobError}</div>}
                {jobSuccess && <div className="text-green-600 md:col-span-2">{jobSuccess}</div>}
              </form>
            )}
          </div>
          <div>
            <h3 className="mb-3 text-lg font-black text-black">Current Jobs</h3>
            <div className="overflow-x-auto">
              <table className="min-w-full rounded-2xl bg-white shadow-sm">
                <thead>
                  <tr>
                    <th className="px-2 py-1 border">Title</th>
                    <th className="px-2 py-1 border">Department</th>
                    <th className="px-2 py-1 border">Section</th>
                    <th className="px-2 py-1 border">Qualification</th>
                    <th className="px-2 py-1 border">Gender</th>
                    <th className="px-2 py-1 border">Age Limit</th>
                    <th className="px-2 py-1 border">Experience</th>
                    <th className="px-2 py-1 border">Salary</th>
                    <th className="px-2 py-1 border">Location</th>
                    <th className="px-2 py-1 border">District</th>
                    <th className="px-2 py-1 border">Edit</th>
                    <th className="px-2 py-1 border">Delete</th>
                  </tr>
                </thead>
                <tbody>
                  {jobs.length === 0 && (
                    <tr><td colSpan="12" className="text-gray-500 text-center">No jobs found.</td></tr>
                  )}
                  {jobs.map(job => (
                    <tr key={job.id}>
                      <td className="px-2 py-1 border">{job.title}</td>
                      <td className="px-2 py-1 border">{job.department}</td>
                      <td className="px-2 py-1 border">{job.section}</td>
                      <td className="px-2 py-1 border">{job.qualification || '-'}</td>
                      <td className="px-2 py-1 border">{job.gender || '-'}</td>
                      <td className="px-2 py-1 border">{job.age_limit || '-'}</td>
                      <td className="px-2 py-1 border">{job.experience}</td>
                      <td className="px-2 py-1 border">{job.salary}</td>
                      <td className="px-2 py-1 border">{job.location}</td>
                      <td className="px-2 py-1 border">{job.district}</td>
                      <td className="px-2 py-1 border">
                        <button className="rounded-lg border border-yellow-400 px-3 py-1 text-xs font-bold text-yellow-700 hover:bg-yellow-50" onClick={() => handleEditJobClick(job)}>Edit</button>
                      </td>
                      <td className="px-2 py-1 border">
                        <button className="rounded-lg border border-red-400 px-3 py-1 text-xs font-bold text-red-600 hover:bg-red-100" onClick={() => handleDeleteJob(job.id)}>Delete</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Edit Job Modal */}
        {editJobId && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
            <div className="w-full max-w-lg rounded-2xl bg-white shadow-2xl overflow-hidden">
              <div className="bg-black px-5 py-4 flex items-center justify-between">
                <h3 className="text-lg font-extrabold text-yellow-300">Edit Job</h3>
                <button type="button" onClick={() => setEditJobId(null)} className="text-white font-bold text-xl hover:text-yellow-300">✕</button>
              </div>
              <div className="p-5 grid grid-cols-1 gap-3 md:grid-cols-2 max-h-[70vh] overflow-y-auto">
                {[
                  { name: 'title', label: 'Title' },
                  { name: 'company_firm_organisation', label: 'Company / Firm / Organisation' },
                  { name: 'department', label: 'Department' },
                  { name: 'section', label: 'Section' },
                  { name: 'qualification', label: 'Qualification' },
                  { name: 'age_limit', label: 'Age Limit (e.g. 18-35)' },
                  { name: 'experience', label: 'Experience' },
                  { name: 'salary', label: 'Salary' },
                  { name: 'location', label: 'Location' },
                  { name: 'district', label: 'District' },
                ].map(({ name, label }) => (
                  <label key={name} className="text-sm font-semibold text-gray-700">
                    {label}
                    <input
                      name={name}
                      value={editJobForm[name]}
                      onChange={handleEditJobChange}
                      className="mt-1 w-full rounded-xl border border-gray-300 bg-gray-50 px-3 py-2 font-normal focus:border-yellow-400 focus:outline-none"
                    />
                  </label>
                ))}
                <label className="text-sm font-semibold text-gray-700">
                  Gender
                  <select
                    name="gender"
                    value={editJobForm.gender}
                    onChange={handleEditJobChange}
                    className="mt-1 w-full rounded-xl border border-gray-300 bg-gray-50 px-3 py-2 font-normal focus:border-yellow-400 focus:outline-none"
                  >
                    <option value="">Any</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Any">Any</option>
                  </select>
                </label>
                <label className="text-sm font-semibold text-gray-700 md:col-span-2">
                  Description
                  <textarea
                    name="description"
                    value={editJobForm.description}
                    onChange={handleEditJobChange}
                    rows={3}
                    className="mt-1 w-full rounded-xl border border-gray-300 bg-gray-50 px-3 py-2 font-normal focus:border-yellow-400 focus:outline-none"
                  />
                </label>
                {editJobError && <div className="text-red-600 text-sm md:col-span-2">{editJobError}</div>}
              </div>
              <div className="flex justify-end gap-3 border-t border-gray-100 px-5 py-4">
                <button
                  type="button"
                  onClick={() => setEditJobId(null)}
                  className="rounded-xl border border-gray-300 px-4 py-2.5 font-bold text-black hover:border-yellow-400"
                >Cancel</button>
                <button
                  type="button"
                  onClick={handleEditJobSave}
                  disabled={editJobLoading}
                  className="rounded-xl bg-yellow-400 px-5 py-2.5 font-extrabold text-black hover:bg-yellow-500 disabled:opacity-60"
                >{editJobLoading ? 'Saving...' : 'Save Changes'}</button>
              </div>
            </div>
          </div>
        )}
        </>
      )}

      {activeTab === 'registrations' && (
        <>
        {/* Member Plans Overview */}
        {planOverview && (
          <div className="mb-4 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6 rounded-[24px] border border-yellow-200 bg-yellow-50 p-4">
            <div className="text-center">
              <p className="text-2xl font-black text-gray-900">{planOverview.total_plans}</p>
              <p className="text-[11px] font-semibold text-gray-500 uppercase tracking-wider">Total Plans</p>
            </div>
            <div className="text-center">
              <p className="text-2xl font-black text-yellow-600">{planOverview.prime_count}</p>
              <p className="text-[11px] font-semibold text-gray-500 uppercase tracking-wider">👑 Prime</p>
            </div>
            <div className="text-center">
              <p className="text-2xl font-black text-blue-600">{planOverview.regular_count}</p>
              <p className="text-[11px] font-semibold text-gray-500 uppercase tracking-wider">⭐ Regular</p>
            </div>
            <div className="text-center">
              <p className="text-2xl font-black text-emerald-600">{planOverview.placed_count}</p>
              <p className="text-[11px] font-semibold text-gray-500 uppercase tracking-wider">Placed</p>
            </div>
            <div className="text-center">
              <p className="text-2xl font-black text-red-500">{planOverview.expiring_soon}</p>
              <p className="text-[11px] font-semibold text-gray-500 uppercase tracking-wider">Expiring ≤10d</p>
            </div>
            <div className="text-center">
              <p className="text-2xl font-black text-gray-900">₹{Number(planOverview.total_revenue || 0).toLocaleString()}</p>
              <p className="text-[11px] font-semibold text-gray-500 uppercase tracking-wider">Revenue</p>
            </div>
          </div>
        )}
        <div className="rounded-[28px] border border-gray-200 bg-white p-5 shadow-sm">
          <input
            ref={registrationImportInputRef}
            type="file"
            accept=".xlsx,.xls"
            onChange={handleRegistrationImport}
            className="hidden"
          />
          <div className="mb-4 flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
            <div>
              <h2 className="text-xl font-bold">Talent Registrations</h2>
            </div>
            <div className="flex flex-wrap items-center gap-2.5">
              <p className="text-sm font-semibold text-gray-600">
                Showing {filteredRegistrations.length === 0 ? 0 : (safeRegistrationsPage - 1) * REGISTRATIONS_PAGE_SIZE + 1}
                {' '}-{' '}
                {Math.min(safeRegistrationsPage * REGISTRATIONS_PAGE_SIZE, filteredRegistrations.length)} of {filteredRegistrations.length}
              </p>
              <button
                type="button"
                onClick={() => setShowRegistrationFilters((prev) => !prev)}
                className={`rounded-xl border px-4 py-2.5 font-extrabold transition ${
                  showRegistrationFilters
                    ? 'border-black bg-black text-yellow-300'
                    : 'border-gray-300 bg-white text-black hover:border-yellow-400'
                }`}
              >
                {showRegistrationFilters ? 'Hide Filters' : 'Enable Filters'}
              </button>
              <button
                type="button"
                onClick={handleDownloadRegistrationTemplate}
                disabled={registrationTemplateLoading}
                className="rounded-xl border border-gray-300 bg-white px-4 py-2.5 font-extrabold text-black hover:border-yellow-400 disabled:cursor-not-allowed disabled:opacity-60"
              >
                {registrationTemplateLoading ? 'Preparing Template...' : 'Excel Template'}
              </button>
              <button
                type="button"
                onClick={triggerRegistrationImport}
                disabled={registrationImporting}
                className="rounded-xl border border-gray-300 bg-white px-4 py-2.5 font-extrabold text-black hover:border-yellow-400 disabled:cursor-not-allowed disabled:opacity-60"
              >
                {registrationImporting ? 'Importing...' : 'Import Excel'}
              </button>
              <button
                type="button"
                onClick={handleExportRegistrations}
                disabled={registrationExportLoading}
                className="rounded-xl border border-gray-300 bg-white px-4 py-2.5 font-extrabold text-black hover:border-yellow-400 disabled:cursor-not-allowed disabled:opacity-60"
              >
                {registrationExportLoading ? 'Exporting...' : 'Export Excel'}
              </button>
              <button
                type="button"
                onClick={fetchRegistrations}
                className="rounded-xl bg-yellow-400 px-4 py-2.5 font-extrabold text-black hover:bg-yellow-500"
              >
                Refresh
              </button>
            </div>
          </div>

          {showRegistrationFilters && (
            <div className="mb-4 rounded-[24px] border border-yellow-200 bg-[linear-gradient(135deg,#fffdf7_0%,#fff8e6_50%,#ffffff_100%)] p-3">
              <div className="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-3">
                <input
                  type="text"
                  name="name"
                  value={registrationFilters.name}
                  onChange={handleRegistrationFilterChange}
                  placeholder="Filter by name"
                  className="rounded-2xl border border-gray-300 bg-white px-3 py-2.5"
                />
                <input
                  type="text"
                  name="district"
                  value={registrationFilters.district}
                  onChange={handleRegistrationFilterChange}
                  placeholder="Filter by district"
                  className="rounded-2xl border border-gray-300 bg-white px-3 py-2.5"
                />
                <input
                  type="text"
                  name="contact"
                  value={registrationFilters.contact}
                  onChange={handleRegistrationFilterChange}
                  placeholder="Filter by contact number"
                  className="rounded-2xl border border-gray-300 bg-white px-3 py-2.5"
                />
                <input
                  type="text"
                  name="department"
                  value={registrationFilters.department}
                  onChange={handleRegistrationFilterChange}
                  placeholder="Filter by department"
                  className="rounded-2xl border border-gray-300 bg-white px-3 py-2.5"
                />
                <input
                  type="text"
                  name="expectingJob"
                  value={registrationFilters.expectingJob}
                  onChange={handleRegistrationFilterChange}
                  placeholder="Filter by expecting job"
                  className="rounded-2xl border border-gray-300 bg-white px-3 py-2.5"
                />
                <select
                  name="forwardStatus"
                  value={registrationFilters.forwardStatus}
                  onChange={handleRegistrationFilterChange}
                  className="rounded-2xl border border-gray-300 bg-white px-3 py-2.5"
                >
                  <option value="all">All forward status</option>
                  <option value="forwarded">Forwarded only</option>
                  <option value="not-forwarded">Not forwarded only</option>
                </select>
              </div>
              <div className="mt-3 flex flex-wrap items-center justify-between gap-3">
                <button
                  type="button"
                  onClick={clearRegistrationFilters}
                  className="rounded-xl border border-gray-300 bg-white px-4 py-2.5 text-sm font-bold text-black hover:border-yellow-400"
                >
                  Clear Filters
                </button>
              </div>
            </div>
          )}

          {registrationsLoading && <div className="text-gray-600">Loading registrations...</div>}

          {!registrationsLoading && (
            <div className="overflow-x-auto">
              <table className="min-w-full rounded-2xl bg-white shadow-sm">
                <thead>
                  <tr>
                    <th className="px-3 py-2 border">Name</th>
                    <th className="px-3 py-2 border">Place</th>
                    <th className="px-3 py-2 border">Contact Number</th>
                    <th className="px-3 py-2 border">Whatsapp Number</th>
                    <th className="px-3 py-2 border">Highest Qualification</th>
                    <th className="px-3 py-2 border">Resume</th>
                    <th className="px-3 py-2 border">Photo</th>
                    <th className="px-3 py-2 border">Forward Status</th>
                    <th className="px-3 py-2 border">Created At</th>
                    <th className="px-3 py-2 border">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredRegistrations.length === 0 && (
                    <tr>
                      <td colSpan="10" className="text-center text-gray-500 px-3 py-3 border">No registrations found for the selected filters.</td>
                    </tr>
                  )}
                  {paginatedRegistrations.map((row) => {
                    const isPrime = row.plan_type === 'prime';
                    const isRegular = row.plan_type === 'regular';
                    const adminRowBg = isPrime
                      ? 'bg-yellow-50'
                      : isRegular
                      ? 'bg-blue-50'
                      : Number(row.is_forwarded || 0) > 0 ? 'bg-emerald-50' : '';
                    return (
                    <tr key={row.id} className={`${adminRowBg} ${isPrime ? 'border-l-4 border-l-yellow-400' : isRegular ? 'border-l-4 border-l-blue-400' : ''}`}>
                      <td className="px-3 py-2 border">
                        <div className="flex flex-wrap items-center gap-1.5">
                          <span className="font-semibold">{row.name || '-'}</span>
                          {isPrime && <span className="inline-flex items-center rounded-full bg-yellow-400 px-2 py-0.5 text-[10px] font-black text-black">👑 PRIME</span>}
                          {isRegular && <span className="inline-flex items-center rounded-full bg-blue-500 px-2 py-0.5 text-[10px] font-black text-white">⭐ REGULAR</span>}
                          <PartnerTag row={row} />
                        </div>
                      </td>
                      <td className="px-3 py-2 border">{row.place || '-'}</td>
                      <td className="px-3 py-2 border"><ContactLink value={row.contact_number} /></td>
                      <td className="px-3 py-2 border"><ContactLink value={row.whatsapp_number} type="whatsapp" /></td>
                      <td className="px-3 py-2 border">{row.highest_qualification || '-'}</td>
                      <td className="px-3 py-2 border">
                        {row.resume_file ? (
                          <a
                            href={row.resume_file.startsWith('http') ? row.resume_file : `${API_URL}${row.resume_file}`}
                            target="_blank"
                            rel="noreferrer"
                            className="text-blue-600 underline"
                          >
                            View
                          </a>
                        ) : '-'}
                      </td>
                      <td className="px-3 py-2 border">
                        {row.photo_file ? (
                          <a
                            href={row.photo_file.startsWith('http') ? row.photo_file : `${API_URL}${row.photo_file}`}
                            target="_blank"
                            rel="noreferrer"
                            className="inline-block"
                            title="Open photo"
                          >
                            <img
                              src={row.photo_file.startsWith('http') ? row.photo_file : `${API_URL}${row.photo_file}`}
                              alt="Talent"
                              className="w-12 h-12 rounded object-cover border"
                            />
                          </a>
                        ) : '-'}
                      </td>
                      <td className="px-3 py-2 border">
                        <PlacementPipeline row={row} />
                      </td>
                      <td className="px-3 py-2 border">{row.created_at}</td>
                      <td className="px-3 py-2 border">
                        <div className="flex gap-2">
                          <button
                            type="button"
                            onClick={() => handleViewRegistration(row)}
                            className="text-xs border border-slate-400 text-slate-700 px-2 py-1 rounded hover:bg-slate-50"
                          >
                            View
                          </button>
                          <button
                            type="button"
                            onClick={() => handleForwardRegistration(row.id, Number(row.is_forwarded || 0) > 0)}
                            disabled={Number(row.is_forwarded || 0) > 0}
                            className={`text-xs border px-2 py-1 rounded ${Number(row.is_forwarded || 0) > 0 ? 'border-gray-300 text-gray-400 cursor-not-allowed' : 'border-emerald-500 text-emerald-600 hover:bg-emerald-50'}`}
                            title={Number(row.is_forwarded || 0) > 0 ? 'Already forwarded' : 'Forward to HR Assistant'}
                          >
                            {'->'}
                          </button>
                          <button
                            type="button"
                            onClick={() => handleEditRegistration(row)}
                            className="text-xs border border-blue-500 text-blue-600 px-2 py-1 rounded hover:bg-blue-50"
                          >
                            Edit
                          </button>
                          <button
                            type="button"
                            onClick={() => handleDeleteRegistration(row.id)}
                            className="text-xs border border-red-500 text-red-600 px-2 py-1 rounded hover:bg-red-50"
                          >
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}

          {!registrationsLoading && filteredRegistrations.length > REGISTRATIONS_PAGE_SIZE && (
            <div className="mt-4 flex flex-col gap-3 border-t border-gray-200 pt-3 sm:flex-row sm:items-center sm:justify-between">
              <p className="text-sm text-gray-600">
                Page {safeRegistrationsPage} of {totalRegistrationPages}
              </p>
              <div className="flex flex-wrap items-center gap-2">
                <button
                  type="button"
                  onClick={() => setRegistrationsPage((prev) => Math.max(1, prev - 1))}
                  disabled={safeRegistrationsPage === 1}
                  className="rounded-lg border border-gray-300 px-3 py-2 text-sm font-bold text-black transition hover:border-yellow-400 hover:text-yellow-700 disabled:cursor-not-allowed disabled:opacity-50"
                >
                  Previous
                </button>
                {Array.from({ length: totalRegistrationPages }, (_, index) => index + 1).map((pageNumber) => (
                  <button
                    key={pageNumber}
                    type="button"
                    onClick={() => setRegistrationsPage(pageNumber)}
                    className={`rounded-lg px-3 py-2 text-sm font-bold transition ${
                      safeRegistrationsPage === pageNumber
                        ? 'bg-black text-yellow-300'
                        : 'border border-gray-300 text-black hover:border-yellow-400 hover:text-yellow-700'
                    }`}
                  >
                    {pageNumber}
                  </button>
                ))}
                <button
                  type="button"
                  onClick={() => setRegistrationsPage((prev) => Math.min(totalRegistrationPages, prev + 1))}
                  disabled={safeRegistrationsPage === totalRegistrationPages}
                  className="rounded-lg border border-gray-300 px-3 py-2 text-sm font-bold text-black transition hover:border-yellow-400 hover:text-yellow-700 disabled:cursor-not-allowed disabled:opacity-50"
                >
                  Next
                </button>
              </div>
            </div>
          )}
        </div>
        </>
      )}

      {activeTab === 'staff' && (
        <div className="rounded-[28px] border border-gray-200 bg-white p-5 shadow-sm">
          <h2 className="mb-4 text-xl font-black text-black">Staff Creation</h2>
          <form onSubmit={handleStaffSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-6">
            <label className="text-sm font-semibold text-gray-700">Staff ID
              <input name="staff_id" value={staffForm.staff_id} onChange={handleStaffChange} className="mt-1 w-full rounded-2xl border border-gray-300 bg-gray-50 px-3 py-2.5" required />
            </label>
            <label className="text-sm font-semibold text-gray-700">Name
              <input name="name" value={staffForm.name} onChange={handleStaffChange} className="mt-1 w-full rounded-2xl border border-gray-300 bg-gray-50 px-3 py-2.5" required />
            </label>
            <label className="text-sm font-semibold text-gray-700">Contact Number
              <input name="contact_number" value={staffForm.contact_number} onChange={handleStaffChange} className="mt-1 w-full rounded-2xl border border-gray-300 bg-gray-50 px-3 py-2.5" maxLength={13} required />
            </label>
            <label className="text-sm font-semibold text-gray-700">User ID
              <input name="user_id" value={staffForm.user_id} onChange={handleStaffChange} className="mt-1 w-full rounded-2xl border border-gray-300 bg-gray-50 px-3 py-2.5" required />
            </label>
            <label className="text-sm font-semibold text-gray-700">Password
              <input type="password" name="password" value={staffForm.password} onChange={handleStaffChange} className="mt-1 w-full rounded-2xl border border-gray-300 bg-gray-50 px-3 py-2.5" required />
            </label>
            <label className="text-sm font-semibold text-gray-700">Role
              <select
                name="role"
                value={addingNewRole ? '__new__' : staffForm.role}
                onChange={(e) => {
                  if (e.target.value === '__new__') {
                    setAddingNewRole(true);
                    setNewRoleName('');
                    setStaffForm((prev) => ({ ...prev, role: '' }));
                  } else {
                    setAddingNewRole(false);
                    handleStaffChange(e);
                  }
                }}
                className="mt-1 w-full rounded-2xl border border-gray-300 bg-gray-50 px-3 py-2.5"
                required={!addingNewRole}
              >
                <option value="">Select Role</option>
                {staffRoles.map((role) => (
                  <option key={role} value={role}>{role}</option>
                ))}
                <option value="__new__">＋ Add new role...</option>
              </select>
              {addingNewRole && (
                <div className="mt-2 flex gap-2">
                  <input
                    type="text"
                    placeholder="Enter new role name"
                    value={newRoleName}
                    onChange={(e) => setNewRoleName(e.target.value)}
                    className="flex-1 rounded-2xl border border-indigo-300 bg-white px-3 py-2 text-sm font-semibold focus:outline-none focus:ring-2 focus:ring-indigo-400"
                    autoFocus
                  />
                  <button
                    type="button"
                    onClick={() => {
                      const trimmed = newRoleName.trim();
                      if (!trimmed) return;
                      if (staffRoles.includes(trimmed)) {
                        setStaffForm((prev) => ({ ...prev, role: trimmed }));
                        setAddingNewRole(false);
                        return;
                      }
                      const updated = [...staffRoles, trimmed];
                      setStaffRoles(updated);
                      localStorage.setItem('dani_staff_roles', JSON.stringify(updated));
                      setStaffForm((prev) => ({ ...prev, role: trimmed }));
                      setAddingNewRole(false);
                      setNewRoleName('');
                    }}
                    className="rounded-xl bg-indigo-600 px-4 py-2 text-sm font-extrabold text-white hover:bg-indigo-700"
                  >
                    Add
                  </button>
                  <button
                    type="button"
                    onClick={() => { setAddingNewRole(false); setNewRoleName(''); }}
                    className="rounded-xl border border-gray-300 px-3 py-2 text-sm font-bold text-gray-600 hover:bg-gray-100"
                  >
                    Cancel
                  </button>
                </div>
              )}
            </label>
            <div className="md:col-span-2 flex justify-end">
              <button type="submit" disabled={staffSaving} className="rounded-xl bg-yellow-400 px-4 py-2.5 font-extrabold text-black hover:bg-yellow-500">
                {staffSaving ? 'Saving...' : 'Save Staff'}
              </button>
            </div>
          </form>

          <div className="flex items-center justify-between mb-3">
            <h3 className="text-lg font-bold">Staff Users</h3>
            <button type="button" onClick={fetchStaff} className="rounded-xl bg-yellow-400 px-4 py-2.5 font-extrabold text-black hover:bg-yellow-500">Refresh</button>
          </div>

          {staffLoading && <div className="text-gray-600">Loading staff...</div>}
          {!staffLoading && (
            <div className="overflow-x-auto">
              <table className="min-w-full rounded-2xl bg-white shadow-sm">
                <thead>
                  <tr>
                    <th className="px-3 py-2 border">Staff ID</th>
                    <th className="px-3 py-2 border">Name</th>
                    <th className="px-3 py-2 border">Contact Number</th>
                    <th className="px-3 py-2 border">User ID</th>
                    <th className="px-3 py-2 border">Password</th>
                    <th className="px-3 py-2 border">Role</th>
                    <th className="px-3 py-2 border">Created At</th>
                    <th className="px-3 py-2 border">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {staff.length === 0 && (
                    <tr>
                      <td colSpan="8" className="text-center text-gray-500 px-3 py-3 border">No staff users found.</td>
                    </tr>
                  )}
                  {staff.map((row) => (
                    <tr key={row.id}>
                      <td className="px-3 py-2 border">{row.staff_id}</td>
                      <td className="px-3 py-2 border">{row.name}</td>
                      <td className="px-3 py-2 border"><ContactLink value={row.contact_number} /></td>
                      <td className="px-3 py-2 border">{row.user_id}</td>
                      <td className="px-3 py-2 border">********</td>
                      <td className="px-3 py-2 border">{row.role}</td>
                      <td className="px-3 py-2 border">{row.created_at}</td>
                      <td className="px-3 py-2 border">
                        <div className="flex gap-2">
                          <button
                            type="button"
                            onClick={() => { setEditRoleRow(row); setEditRoleValue(row.role || ''); }}
                            className="rounded-lg bg-yellow-400 px-3 py-1.5 text-xs font-bold text-black hover:bg-yellow-500"
                          >
                            Edit Role
                          </button>
                          <button
                            type="button"
                            onClick={() => handleDeleteStaff(row)}
                            disabled={staffDeletingId === row.id}
                            className="rounded-lg bg-red-500 px-3 py-1.5 text-xs font-bold text-white hover:bg-red-600 disabled:opacity-60"
                          >
                            {staffDeletingId === row.id ? 'Deleting...' : 'Delete'}
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {/* Edit Role Modal */}
      {editRoleRow && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
          <div className="w-full max-w-sm rounded-2xl bg-white p-6 shadow-2xl">
            <h2 className="mb-1 text-lg font-black text-black">Edit Role</h2>
            <p className="mb-4 text-sm text-gray-500">Changing role for <span className="font-bold text-black">{editRoleRow.name}</span></p>
            <div className="mb-1 text-xs text-gray-400">Current: <span className="font-bold text-black">{editRoleRow.role}</span></div>
            <select
              value={editRoleValue}
              onChange={e => setEditRoleValue(e.target.value)}
              className="mt-2 w-full rounded-xl border border-gray-300 bg-gray-50 px-4 py-2.5 text-black outline-none focus:border-yellow-400 focus:ring-2 focus:ring-yellow-200"
            >
              <option value="">— Select role —</option>
              {staffRoles.map(r => <option key={r} value={r}>{r}</option>)}
            </select>
            <div className="mt-5 flex justify-end gap-3">
              <button onClick={() => setEditRoleRow(null)} className="rounded-xl border border-gray-300 px-4 py-2 text-sm font-bold text-gray-700 hover:bg-gray-50">Cancel</button>
              <button onClick={handleEditRoleSave} disabled={editRoleSaving || !editRoleValue}
                className="rounded-xl bg-black px-5 py-2 text-sm font-bold text-yellow-400 hover:bg-gray-800 disabled:opacity-60">
                {editRoleSaving ? 'Saving...' : 'Save Role'}
              </button>
            </div>
          </div>
        </div>
      )}

      {activeTab === 'recruitment' && (
        <div className="space-y-6">
          <div className="flex items-center justify-between">
            <h2 className="text-xl font-black text-black">Recruitment Activity</h2>
            <button type="button" onClick={fetchRecruitmentStats} disabled={recruitmentStatsLoading} className="rounded-xl bg-indigo-500 px-4 py-2.5 text-sm font-extrabold text-white hover:bg-indigo-600 disabled:opacity-60">
              {recruitmentStatsLoading ? 'Loading...' : 'Refresh'}
            </button>
          </div>

          {recruitmentStatsLoading && <div className="text-sm text-gray-500">Loading recruitment stats...</div>}

          {recruitmentStats && (
            <>
              {/* Key Metric Tiles */}
              <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
                {[
                  { label: 'Shortlisted', value: recruitmentStats.shortlisted, color: 'bg-indigo-50 border-indigo-200 text-indigo-700' },
                  { label: 'Interviews This Week', value: recruitmentStats.interviews_this_week, color: 'bg-cyan-50 border-cyan-200 text-cyan-700' },
                  { label: 'Interviews Next Week', value: recruitmentStats.interviews_next_week, color: 'bg-sky-50 border-sky-200 text-sky-700' },
                  { label: 'Total Placements', value: recruitmentStats.placements_total, color: 'bg-emerald-50 border-emerald-200 text-emerald-700' },
                  { label: 'Placements This Month', value: recruitmentStats.placements_this_month, color: 'bg-green-50 border-green-200 text-green-700' },
                  { label: 'Awaiting HR Confirm', value: recruitmentStats.pending_hr_confirmation, color: 'bg-amber-50 border-amber-200 text-amber-700' },
                  { label: 'Awaiting AR Confirm', value: recruitmentStats.pending_ar_confirmation, color: 'bg-orange-50 border-orange-200 text-orange-700' },
                  { label: 'Awaiting Approval', value: recruitmentStats.awaiting_recruiter_approval, color: 'bg-rose-50 border-rose-200 text-rose-700' }
                ].map((tile) => (
                  <div key={tile.label} className={`rounded-[20px] border px-4 py-4 ${tile.color}`}>
                    <p className="text-2xl font-black">{tile.value ?? 0}</p>
                    <p className="mt-1 text-xs font-bold uppercase tracking-[0.18em]">{tile.label}</p>
                  </div>
                ))}
              </div>

              {/* By Recruiter */}
              {recruitmentStats.by_recruiter && recruitmentStats.by_recruiter.length > 0 && (
                <div className="rounded-[24px] border border-gray-200 bg-white p-5 shadow-sm">
                  <h3 className="mb-4 text-sm font-black uppercase tracking-[0.22em] text-gray-600">Performance by Recruiter</h3>
                  <div className="overflow-x-auto">
                    <table className="min-w-full text-sm">
                      <thead>
                        <tr className="border-b border-gray-100">
                          <th className="pb-2 pr-4 text-left text-xs font-black uppercase tracking-[0.16em] text-gray-500">Recruiter</th>
                          <th className="pb-2 pr-4 text-center text-xs font-black uppercase tracking-[0.16em] text-gray-500">Assigned</th>
                          <th className="pb-2 pr-4 text-center text-xs font-black uppercase tracking-[0.16em] text-gray-500">Shortlisted</th>
                          <th className="pb-2 pr-4 text-center text-xs font-black uppercase tracking-[0.16em] text-gray-500">Interviewed</th>
                          <th className="pb-2 text-center text-xs font-black uppercase tracking-[0.16em] text-gray-500">Placed</th>
                        </tr>
                      </thead>
                      <tbody>
                        {recruitmentStats.by_recruiter.map((r, i) => (
                          <tr key={i} className="border-b border-gray-50 hover:bg-gray-50">
                            <td className="py-2 pr-4 font-semibold">{r.recruiter_name || r.recruiter_id || '-'}</td>
                            <td className="py-2 pr-4 text-center">{r.total_assigned}</td>
                            <td className="py-2 pr-4 text-center">{r.shortlisted}</td>
                            <td className="py-2 pr-4 text-center">{r.interviewed}</td>
                            <td className="py-2 text-center font-bold text-emerald-600">{r.placed}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* Recent Activity */}
              {recruitmentStats.recent_activity && recruitmentStats.recent_activity.length > 0 && (
                <div className="rounded-[24px] border border-gray-200 bg-white p-5 shadow-sm">
                  <h3 className="mb-4 text-sm font-black uppercase tracking-[0.22em] text-gray-600">Recent Activity</h3>
                  <div className="space-y-2">
                    {recruitmentStats.recent_activity.map((item, i) => (
                      <div key={i} className="flex flex-col gap-1 rounded-xl border border-gray-100 bg-gray-50 px-4 py-3 text-sm md:flex-row md:items-center md:gap-4">
                        <span className="font-bold text-black">{item.member_name || '-'}</span>
                        <span className="text-gray-600">{item.vacancy_title || '-'} · {item.vacancy_company || '-'}</span>
                        {item.interview_date && <span className="rounded-full bg-indigo-100 px-2 py-0.5 text-xs font-bold text-indigo-700">{item.interview_date}</span>}
                        <span className={`rounded-full px-2 py-0.5 text-xs font-bold ${item.placement_status === 'Placed' ? 'bg-emerald-100 text-emerald-700' : 'bg-gray-100 text-gray-600'}`}>{item.placement_status || 'In Progress'}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </>
          )}

          {!recruitmentStatsLoading && !recruitmentStats && (
            <div className="rounded-2xl border border-dashed border-gray-200 py-10 text-center text-sm text-gray-400">No recruitment data available.</div>
          )}
        </div>
      )}

      {activeTab === 'analysis' && (
        <div className="space-y-6">
          {/* Header row */}
          <div className="flex flex-wrap items-center justify-between gap-3">
            <div>
              <h2 className="text-xl font-black text-black">Agent &amp; Telecaller Analysis</h2>
              <p className="mt-0.5 text-xs text-gray-500">Comprehensive report on leads, calls, and conversions by each staff member.</p>
            </div>
            <button type="button" onClick={fetchActivityReport} disabled={activityReportLoading}
              className="rounded-[18px] border border-black bg-black px-5 py-2.5 text-sm font-extrabold text-yellow-300 hover:bg-[#222] disabled:opacity-50 transition">
              {activityReportLoading ? '↻ Loading…' : '↻ Refresh'}
            </button>
          </div>

          {activityReportLoading && (
            <div className="flex items-center justify-center py-20 text-sm font-semibold text-gray-400">
              <span className="mr-2 animate-spin text-xl">⟳</span> Loading report…
            </div>
          )}

          {!activityReportLoading && activityReport && (() => {
            const agents      = activityReport.agentStats     || [];
            const telecallers = activityReport.telecallerStats|| [];
            const trend       = activityReport.dailyTrend     || [];
            const sources     = activityReport.sourceBreakdown|| [];
            const districts   = activityReport.districtBreakdown || [];

            // Summary totals
            const totalLeads       = agents.reduce((s, a) => s + (a.total_leads || 0), 0);
            const totalForwarded   = agents.reduce((s, a) => s + (a.forwarded || 0), 0);
            const totalConversions = agents.reduce((s, a) => s + (a.conversions || 0), 0);
            const totalCalled      = telecallers.reduce((s, t) => s + (t.total_called || 0), 0);

            // Filtered agents
            const filteredAgents = agents.filter(a =>
              (!reportAgentSearch || a.agent_name?.toLowerCase().includes(reportAgentSearch.toLowerCase()))
            );
            const filteredTCs = telecallers.filter(t =>
              (!reportTCSearch || t.telecaller_name?.toLowerCase().includes(reportTCSearch.toLowerCase()))
            );

            return (
              <>
                {/* Summary tiles */}
                <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
                  {[
                    { label: 'Total Leads',       value: totalLeads,       color: 'bg-[linear-gradient(135deg,#0a0a0a,#1f1f1f)] text-white', vcolor: 'text-yellow-300' },
                    { label: 'Forwarded',          value: totalForwarded,   color: 'bg-amber-50 border border-amber-200', vcolor: 'text-amber-700' },
                    { label: 'Total Calls Made',   value: totalCalled,      color: 'bg-blue-50 border border-blue-200', vcolor: 'text-blue-700' },
                    { label: 'Total Conversions',  value: totalConversions, color: 'bg-emerald-50 border border-emerald-200', vcolor: 'text-emerald-700' },
                  ].map(t => (
                    <div key={t.label} className={`rounded-[20px] px-5 py-4 ${t.color}`}>
                      <p className={`text-3xl font-black ${t.vcolor}`}>{t.value}</p>
                      <p className="mt-1 text-[10px] font-black uppercase tracking-[0.22em] opacity-70">{t.label}</p>
                    </div>
                  ))}
                </div>

                {/* Filters row */}
                <div className="flex flex-wrap items-end gap-3 rounded-[20px] border border-gray-100 bg-gray-50 px-4 py-3">
                  <div>
                    <p className="mb-1 text-[9px] font-black uppercase tracking-[0.2em] text-gray-400">Date From</p>
                    <input type="date" value={reportDateFrom} onChange={e => setReportDateFrom(e.target.value)}
                      className="rounded-xl border border-gray-200 bg-white px-3 py-2 text-xs font-semibold outline-none focus:border-yellow-400" />
                  </div>
                  <div>
                    <p className="mb-1 text-[9px] font-black uppercase tracking-[0.2em] text-gray-400">Date To</p>
                    <input type="date" value={reportDateTo} onChange={e => setReportDateTo(e.target.value)}
                      className="rounded-xl border border-gray-200 bg-white px-3 py-2 text-xs font-semibold outline-none focus:border-yellow-400" />
                  </div>
                  <div>
                    <p className="mb-1 text-[9px] font-black uppercase tracking-[0.2em] text-gray-400">Agent Name</p>
                    <input type="text" placeholder="Search agent…" value={reportAgentSearch} onChange={e => setReportAgentSearch(e.target.value)}
                      className="rounded-xl border border-gray-200 bg-white px-3 py-2 text-xs font-semibold outline-none focus:border-yellow-400 w-40" />
                  </div>
                  <div>
                    <p className="mb-1 text-[9px] font-black uppercase tracking-[0.2em] text-gray-400">Telecaller Name</p>
                    <input type="text" placeholder="Search telecaller…" value={reportTCSearch} onChange={e => setReportTCSearch(e.target.value)}
                      className="rounded-xl border border-gray-200 bg-white px-3 py-2 text-xs font-semibold outline-none focus:border-yellow-400 w-44" />
                  </div>
                  {(reportDateFrom || reportDateTo || reportAgentSearch || reportTCSearch) && (
                    <button type="button" onClick={() => { setReportDateFrom(''); setReportDateTo(''); setReportAgentSearch(''); setReportTCSearch(''); }}
                      className="rounded-xl border border-rose-200 bg-white px-3 py-2 text-[10px] font-black text-rose-500 hover:bg-rose-50 transition">
                      ✕ Clear
                    </button>
                  )}
                  <p className="ml-auto text-[10px] font-semibold text-gray-400">* Date filters apply on next refresh. Name filters apply instantly.</p>
                </div>

                {/* Agent Report Table */}
                <div className="overflow-hidden rounded-[24px] border border-gray-200 bg-white shadow-sm">
                  <div className="border-b border-gray-100 bg-[linear-gradient(135deg,#0a0a0a,#1f1f1f)] px-5 py-3.5">
                    <p className="text-[10px] font-black uppercase tracking-[0.26em] text-yellow-300">👤 Agent Performance</p>
                    <p className="mt-0.5 text-sm font-black text-white">Leads generated by each agent</p>
                  </div>
                  {filteredAgents.length === 0 ? (
                    <div className="py-12 text-center text-sm text-gray-400">No agent data found.</div>
                  ) : (
                    <div className="overflow-x-auto">
                      <table className="w-full text-sm">
                        <thead>
                          <tr className="bg-[#111] text-left">
                            {['Agent Name', 'Total Leads', 'Today', 'This Week', 'This Month', 'Forwarded to TC', 'Conversions', 'Conv. Rate', 'Revenue (₹)'].map(h => (
                              <th key={h} className="whitespace-nowrap px-4 py-3 text-[10px] font-black uppercase tracking-[0.18em] text-yellow-300">{h}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {filteredAgents.map((a, i) => {
                            const convRate = a.total_leads > 0 ? ((a.conversions / a.total_leads) * 100).toFixed(1) : '0.0';
                            const revenue  = (a.conversions || 0) * 50;
                            return (
                              <tr key={a.agent_id} className={`border-b transition-colors hover:bg-yellow-50/40 ${i % 2 === 0 ? 'bg-white' : 'bg-gray-50/60'}`}>
                                <td className="px-4 py-3 font-extrabold text-gray-900">{a.agent_name || a.agent_id}</td>
                                <td className="px-4 py-3 text-center font-black text-gray-800">{a.total_leads}</td>
                                <td className="px-4 py-3 text-center font-semibold text-gray-600">{a.today_leads}</td>
                                <td className="px-4 py-3 text-center font-semibold text-gray-600">{a.week_leads}</td>
                                <td className="px-4 py-3 text-center font-semibold text-gray-600">{a.month_leads}</td>
                                <td className="px-4 py-3 text-center">
                                  <span className="inline-flex items-center rounded-full bg-amber-100 px-2.5 py-0.5 text-[11px] font-extrabold text-amber-700">{a.forwarded}</span>
                                </td>
                                <td className="px-4 py-3 text-center">
                                  <span className="inline-flex items-center rounded-full bg-emerald-100 px-2.5 py-0.5 text-[11px] font-extrabold text-emerald-700">{a.conversions}</span>
                                </td>
                                <td className="px-4 py-3 text-center">
                                  <div className="flex items-center justify-center gap-1.5">
                                    <div className="h-1.5 w-16 overflow-hidden rounded-full bg-gray-100">
                                      <div className="h-full rounded-full bg-emerald-500 transition-all" style={{ width: `${Math.min(100, parseFloat(convRate))}%` }} />
                                    </div>
                                    <span className="text-[11px] font-extrabold text-gray-700">{convRate}%</span>
                                  </div>
                                </td>
                                <td className="px-4 py-3 text-center font-black text-yellow-700">₹{revenue}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                        <tfoot>
                          <tr className="border-t-2 border-gray-200 bg-gray-50">
                            <td className="px-4 py-3 text-xs font-black uppercase tracking-wider text-gray-500">Total</td>
                            <td className="px-4 py-3 text-center font-black text-gray-900">{filteredAgents.reduce((s,a)=>s+(a.total_leads||0),0)}</td>
                            <td className="px-4 py-3 text-center font-bold text-gray-600">{filteredAgents.reduce((s,a)=>s+(a.today_leads||0),0)}</td>
                            <td className="px-4 py-3 text-center font-bold text-gray-600">{filteredAgents.reduce((s,a)=>s+(a.week_leads||0),0)}</td>
                            <td className="px-4 py-3 text-center font-bold text-gray-600">{filteredAgents.reduce((s,a)=>s+(a.month_leads||0),0)}</td>
                            <td className="px-4 py-3 text-center font-bold text-amber-700">{filteredAgents.reduce((s,a)=>s+(a.forwarded||0),0)}</td>
                            <td className="px-4 py-3 text-center font-bold text-emerald-700">{filteredAgents.reduce((s,a)=>s+(a.conversions||0),0)}</td>
                            <td className="px-4 py-3" />
                            <td className="px-4 py-3 text-center font-black text-yellow-700">₹{filteredAgents.reduce((s,a)=>s+((a.conversions||0)*50),0)}</td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  )}
                </div>

                {/* Telecaller Report Table */}
                <div className="overflow-hidden rounded-[24px] border border-gray-200 bg-white shadow-sm">
                  <div className="border-b border-gray-100 bg-[linear-gradient(135deg,#0a0a0a,#1f1f1f)] px-5 py-3.5">
                    <p className="text-[10px] font-black uppercase tracking-[0.26em] text-yellow-300">📞 Telecaller Performance</p>
                    <p className="mt-0.5 text-sm font-black text-white">Calls made, statuses, and conversions per telecaller</p>
                  </div>
                  {filteredTCs.length === 0 ? (
                    <div className="py-12 text-center text-sm text-gray-400">No telecaller data found.</div>
                  ) : (
                    <div className="overflow-x-auto">
                      <table className="w-full text-sm">
                        <thead>
                          <tr className="bg-[#111] text-left">
                            {['Telecaller Name', 'Assigned', 'Called', 'Pending', 'Progressing', 'Converted', 'No Hope', 'Rejected', 'Conv. Rate', 'Today Updates'].map(h => (
                              <th key={h} className="whitespace-nowrap px-4 py-3 text-[10px] font-black uppercase tracking-[0.18em] text-yellow-300">{h}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {filteredTCs.map((t, i) => {
                            const convRate = t.total_assigned > 0 ? ((t.converted / t.total_assigned) * 100).toFixed(1) : '0.0';
                            return (
                              <tr key={t.telecaller_id} className={`border-b transition-colors hover:bg-yellow-50/40 ${i % 2 === 0 ? 'bg-white' : 'bg-gray-50/60'}`}>
                                <td className="px-4 py-3 font-extrabold text-gray-900">{t.telecaller_name || t.telecaller_id}</td>
                                <td className="px-4 py-3 text-center font-black text-gray-800">{t.total_assigned}</td>
                                <td className="px-4 py-3 text-center font-semibold text-gray-600">{t.total_called}</td>
                                <td className="px-4 py-3 text-center">
                                  <span className="inline-flex items-center rounded-full bg-gray-100 px-2 py-0.5 text-[11px] font-bold text-gray-600">{t.pending}</span>
                                </td>
                                <td className="px-4 py-3 text-center">
                                  <span className="inline-flex items-center rounded-full bg-blue-100 px-2 py-0.5 text-[11px] font-bold text-blue-700">{t.progressing}</span>
                                </td>
                                <td className="px-4 py-3 text-center">
                                  <span className="inline-flex items-center rounded-full bg-emerald-100 px-2.5 py-0.5 text-[11px] font-extrabold text-emerald-700">{t.converted}</span>
                                </td>
                                <td className="px-4 py-3 text-center">
                                  <span className="inline-flex items-center rounded-full bg-orange-100 px-2 py-0.5 text-[11px] font-bold text-orange-700">{t.no_hope}</span>
                                </td>
                                <td className="px-4 py-3 text-center">
                                  <span className="inline-flex items-center rounded-full bg-rose-100 px-2 py-0.5 text-[11px] font-bold text-rose-700">{t.rejected}</span>
                                </td>
                                <td className="px-4 py-3 text-center">
                                  <div className="flex items-center justify-center gap-1.5">
                                    <div className="h-1.5 w-16 overflow-hidden rounded-full bg-gray-100">
                                      <div className="h-full rounded-full bg-emerald-500 transition-all" style={{ width: `${Math.min(100, parseFloat(convRate))}%` }} />
                                    </div>
                                    <span className="text-[11px] font-extrabold text-gray-700">{convRate}%</span>
                                  </div>
                                </td>
                                <td className="px-4 py-3 text-center">
                                  <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-bold ${t.today_updates > 0 ? 'bg-yellow-100 text-yellow-700' : 'bg-gray-100 text-gray-400'}`}>{t.today_updates}</span>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                        <tfoot>
                          <tr className="border-t-2 border-gray-200 bg-gray-50">
                            <td className="px-4 py-3 text-xs font-black uppercase tracking-wider text-gray-500">Total</td>
                            <td className="px-4 py-3 text-center font-black text-gray-900">{filteredTCs.reduce((s,t)=>s+(t.total_assigned||0),0)}</td>
                            <td className="px-4 py-3 text-center font-bold text-gray-600">{filteredTCs.reduce((s,t)=>s+(t.total_called||0),0)}</td>
                            <td className="px-4 py-3 text-center font-bold text-gray-500">{filteredTCs.reduce((s,t)=>s+(t.pending||0),0)}</td>
                            <td className="px-4 py-3 text-center font-bold text-blue-700">{filteredTCs.reduce((s,t)=>s+(t.progressing||0),0)}</td>
                            <td className="px-4 py-3 text-center font-bold text-emerald-700">{filteredTCs.reduce((s,t)=>s+(t.converted||0),0)}</td>
                            <td className="px-4 py-3 text-center font-bold text-orange-700">{filteredTCs.reduce((s,t)=>s+(t.no_hope||0),0)}</td>
                            <td className="px-4 py-3 text-center font-bold text-rose-700">{filteredTCs.reduce((s,t)=>s+(t.rejected||0),0)}</td>
                            <td className="px-4 py-3" />
                            <td className="px-4 py-3 text-center font-bold text-yellow-700">{filteredTCs.reduce((s,t)=>s+(t.today_updates||0),0)}</td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  )}
                </div>

                {/* Daily Trend + Source + District row */}
                <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
                  {/* Daily Trend */}
                  <div className="lg:col-span-2 overflow-hidden rounded-[24px] border border-gray-200 bg-white shadow-sm">
                    <div className="border-b border-gray-100 px-5 py-3.5">
                      <p className="text-[10px] font-black uppercase tracking-[0.22em] text-gray-500">📈 Daily Lead Trend — Last 14 Days</p>
                    </div>
                    {trend.length === 0 ? (
                      <div className="py-10 text-center text-sm text-gray-400">No trend data.</div>
                    ) : (
                      <div className="overflow-x-auto p-4">
                        <table className="w-full text-xs">
                          <thead>
                            <tr className="border-b border-gray-100 text-left">
                              <th className="pb-2 pr-4 font-black uppercase tracking-wide text-gray-400">Date</th>
                              <th className="pb-2 pr-4 text-center font-black uppercase tracking-wide text-gray-400">Leads</th>
                              <th className="pb-2 pr-4 text-center font-black uppercase tracking-wide text-emerald-500">Conversions</th>
                              <th className="pb-2 text-center font-black uppercase tracking-wide text-gray-400">Bar</th>
                            </tr>
                          </thead>
                          <tbody>
                            {(() => {
                              const maxLeads = Math.max(1, ...trend.map(d => d.leads));
                              return trend.map((d, i) => (
                                <tr key={d.date} className={`border-b ${i % 2 === 0 ? 'bg-white' : 'bg-gray-50/50'}`}>
                                  <td className="py-1.5 pr-4 font-semibold text-gray-600 whitespace-nowrap">{d.date}</td>
                                  <td className="py-1.5 pr-4 text-center font-black text-gray-800">{d.leads}</td>
                                  <td className="py-1.5 pr-4 text-center font-bold text-emerald-600">{d.conversions}</td>
                                  <td className="py-1.5">
                                    <div className="flex items-center gap-1">
                                      <div className="h-2 rounded-full bg-yellow-400" style={{ width: `${Math.round((d.leads / maxLeads) * 80)}px` }} />
                                      {d.conversions > 0 && <div className="h-2 rounded-full bg-emerald-400" style={{ width: `${Math.round((d.conversions / maxLeads) * 80)}px` }} />}
                                    </div>
                                  </td>
                                </tr>
                              ));
                            })()}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>

                  {/* Source + District */}
                  <div className="flex flex-col gap-4">
                    {/* Source Breakdown */}
                    <div className="overflow-hidden rounded-[24px] border border-gray-200 bg-white shadow-sm">
                      <div className="border-b border-gray-100 px-5 py-3.5">
                        <p className="text-[10px] font-black uppercase tracking-[0.22em] text-gray-500">🔗 Source Breakdown</p>
                      </div>
                      <div className="p-4 space-y-2">
                        {sources.map(s => (
                          <div key={s.source} className="flex items-center gap-2">
                            <span className="w-24 truncate text-[11px] font-bold text-gray-700">{s.source || 'Unknown'}</span>
                            <div className="flex-1 h-2 rounded-full bg-gray-100 overflow-hidden">
                              <div className="h-full rounded-full bg-yellow-400" style={{ width: `${Math.min(100, Math.round(((s.total || 0) / (sources[0]?.total || 1)) * 100))}%` }} />
                            </div>
                            <span className="text-[11px] font-black text-gray-700 w-6 text-right">{s.total}</span>
                            {s.converted > 0 && <span className="text-[10px] font-bold text-emerald-600">✓{s.converted}</span>}
                          </div>
                        ))}
                        {sources.length === 0 && <p className="text-xs text-gray-400">No data.</p>}
                      </div>
                    </div>

                    {/* District Breakdown */}
                    <div className="overflow-hidden rounded-[24px] border border-gray-200 bg-white shadow-sm">
                      <div className="border-b border-gray-100 px-5 py-3.5">
                        <p className="text-[10px] font-black uppercase tracking-[0.22em] text-gray-500">📍 Top Districts</p>
                      </div>
                      <div className="p-4 space-y-2">
                        {districts.map((d, i) => (
                          <div key={d.district} className="flex items-center gap-2">
                            <span className="w-5 text-[10px] font-black text-gray-400">#{i+1}</span>
                            <span className="w-28 truncate text-[11px] font-bold text-gray-700">{d.district}</span>
                            <div className="flex-1 h-2 rounded-full bg-gray-100 overflow-hidden">
                              <div className="h-full rounded-full bg-black" style={{ width: `${Math.min(100, Math.round(((d.total || 0) / (districts[0]?.total || 1)) * 100))}%` }} />
                            </div>
                            <span className="text-[11px] font-black text-gray-700 w-6 text-right">{d.total}</span>
                          </div>
                        ))}
                        {districts.length === 0 && <p className="text-xs text-gray-400">No data.</p>}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            );
          })()}

          {!activityReportLoading && !activityReport && (
            <div className="rounded-2xl border border-dashed border-gray-200 py-12 text-center text-sm text-gray-400">
              {activityReportError
                ? <><p className="text-rose-500 font-bold">{activityReportError}</p><p className="mt-1 text-xs text-gray-400">Check that the backend is running and you are logged in as admin.</p></>
                : 'No report data available. Click Refresh to load.'
              }
            </div>
          )}
        </div>
      )}

      {activeTab === 'id-setup' && (
        <div className="space-y-5">
          <div className="rounded-[28px] border border-gray-200 bg-white p-5 shadow-sm">
            <div className="mb-4 flex items-center justify-between">
              <h2 className="text-xl font-black text-black">ID &amp; Password Setup</h2>
            </div>

            {/* Sub-tabs */}
            <div className="mb-5 flex flex-wrap gap-2">
              {[
                { id: 'staff', label: 'Staff' },
                { id: 'partners', label: 'Partners' },
                { id: 'members', label: 'Members' },
                { id: 'companies', label: 'Companies' },
                { id: 'reset-requests', label: `🔔 Reset Requests${resetRequests.filter(r => r.status === 'Pending').length ? ` (${resetRequests.filter(r => r.status === 'Pending').length})` : ''}` },
              ].map((s) => (
                <button key={s.id} type="button" onClick={() => setIdSubTab(s.id)}
                  className={`rounded-full px-4 py-1.5 text-xs font-extrabold uppercase tracking-wide transition ${idSubTab === s.id ? 'bg-black text-yellow-300' : 'border border-gray-300 bg-white text-gray-700 hover:border-blue-400'}`}>
                  {s.label}
                </button>
              ))}
            </div>

            {/* ── Staff IDs ── */}
            {idSubTab === 'staff' && (
              <div>
                <p className="mb-3 text-sm text-gray-500">Reset passwords for existing staff logins. Create new staff from the <span className="font-bold">Staff</span> tab.</p>
                {staffLoading && <p className="text-sm text-gray-500">Loading...</p>}
                {!staffLoading && (
                  <div className="overflow-x-auto">
                    <table className="min-w-full text-sm">
                      <thead>
                        <tr className="border-b text-left text-xs font-black uppercase tracking-wide text-gray-500">
                          <th className="py-2 pr-4">Staff ID</th>
                          <th className="py-2 pr-4">Name</th>
                          <th className="py-2 pr-4">Role</th>
                          <th className="py-2 pr-4">User ID</th>
                          <th className="py-2">New Password</th>
                          <th className="py-2 pl-3">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {staff.length === 0 && <tr><td colSpan="6" className="py-4 text-center text-gray-400">No staff found.</td></tr>}
                        {staff.map((row) => (
                          <tr key={row.id} className="border-b hover:bg-blue-50/30">
                            <td className="py-2 pr-4 font-bold text-gray-700">{row.staff_id}</td>
                            <td className="py-2 pr-4 font-semibold">{row.name}</td>
                            <td className="py-2 pr-4"><span className="rounded-full bg-indigo-100 px-2 py-0.5 text-[11px] font-bold text-indigo-700">{row.role}</span></td>
                            <td className="py-2 pr-4 font-mono text-xs text-gray-600">{row.user_id}</td>
                            <td className="py-2">
                              <input type="password" placeholder="New password"
                                value={staffResetPasswordMap[row.id] || ''}
                                onChange={(e) => setStaffResetPasswordMap((p) => ({ ...p, [row.id]: e.target.value }))}
                                className="w-40 rounded-xl border border-gray-300 bg-gray-50 px-3 py-1.5 text-xs focus:outline-none focus:ring-2 focus:ring-blue-300" />
                            </td>
                            <td className="py-2 pl-3">
                              <button type="button" disabled={staffResetSavingId === row.id}
                                onClick={() => handleStaffResetPassword(row)}
                                className="rounded-xl bg-blue-600 px-3 py-1.5 text-xs font-extrabold text-white hover:bg-blue-700 disabled:opacity-60">
                                {staffResetSavingId === row.id ? 'Saving...' : 'Reset PW'}
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}

            {/* ── Partner IDs ── */}
            {idSubTab === 'partners' && (
              <div>
                <p className="mb-3 text-sm text-gray-500">Reset passwords for approved partner accounts.</p>
                {partnersLoading && <p className="text-sm text-gray-500">Loading...</p>}
                {!partnersLoading && (
                  <div className="overflow-x-auto">
                    <table className="min-w-full text-sm">
                      <thead>
                        <tr className="border-b text-left text-xs font-black uppercase tracking-wide text-gray-500">
                          <th className="py-2 pr-4">Organisation</th>
                          <th className="py-2 pr-4">Owner</th>
                          <th className="py-2 pr-4">User ID</th>
                          <th className="py-2 pr-4">Status</th>
                          <th className="py-2">New Password</th>
                          <th className="py-2 pl-3">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {partners.filter((p) => p.partner_user_id).length === 0 && (
                          <tr><td colSpan="6" className="py-4 text-center text-gray-400">No partners with accounts.</td></tr>
                        )}
                        {partners.filter((p) => p.partner_user_id).map((p) => (
                          <tr key={p.id} className="border-b hover:bg-blue-50/30">
                            <td className="py-2 pr-4 font-bold text-gray-700">{p.name_of_organisation}</td>
                            <td className="py-2 pr-4">{p.owner_of_organisation}</td>
                            <td className="py-2 pr-4 font-mono text-xs text-gray-600">{p.partner_user_id}</td>
                            <td className="py-2 pr-4"><span className={`rounded-full px-2 py-0.5 text-[11px] font-bold ${p.partnership_status === 'Approved' ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-600'}`}>{p.partnership_status}</span></td>
                            <td className="py-2">
                              <input type="password" placeholder="New password"
                                value={partnerResetPasswordMap[p.id] || ''}
                                onChange={(e) => setPartnerResetPasswordMap((prev) => ({ ...prev, [p.id]: e.target.value }))}
                                className="w-40 rounded-xl border border-gray-300 bg-gray-50 px-3 py-1.5 text-xs focus:outline-none focus:ring-2 focus:ring-blue-300" />
                            </td>
                            <td className="py-2 pl-3">
                              <button type="button" disabled={partnerResetSavingId === p.id}
                                onClick={() => handlePartnerResetPassword(p)}
                                className="rounded-xl bg-blue-600 px-3 py-1.5 text-xs font-extrabold text-white hover:bg-blue-700 disabled:opacity-60">
                                {partnerResetSavingId === p.id ? 'Saving...' : 'Reset PW'}
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}

            {/* ── Member IDs ── */}
            {idSubTab === 'members' && (
              <div className="space-y-5">
                <form onSubmit={handleCreateMemberAccount} className="grid grid-cols-1 gap-3 rounded-2xl border border-blue-100 bg-blue-50 p-4 md:grid-cols-2">
                  <h3 className="text-sm font-black text-black md:col-span-2">Issue New Member Account</h3>
                  <label className="text-xs font-semibold text-gray-700">Registration ID
                    <input type="number" value={memberAccountForm.talent_registration_id}
                      onChange={(e) => setMemberAccountForm((p) => ({ ...p, talent_registration_id: e.target.value }))}
                      placeholder="e.g. 42" className="mt-1 w-full rounded-xl border border-gray-300 bg-white px-3 py-2 text-sm" required />
                  </label>
                  <label className="text-xs font-semibold text-gray-700">User ID (login identifier)
                    <input type="text" value={memberAccountForm.user_id}
                      onChange={(e) => setMemberAccountForm((p) => ({ ...p, user_id: e.target.value }))}
                      placeholder="e.g. member001 or phone number" className="mt-1 w-full rounded-xl border border-gray-300 bg-white px-3 py-2 text-sm" required />
                  </label>
                  <label className="text-xs font-semibold text-gray-700">Email (optional)
                    <input type="email" value={memberAccountForm.email}
                      onChange={(e) => setMemberAccountForm((p) => ({ ...p, email: e.target.value }))}
                      placeholder="optional" className="mt-1 w-full rounded-xl border border-gray-300 bg-white px-3 py-2 text-sm" />
                  </label>
                  <label className="text-xs font-semibold text-gray-700">Password
                    <input type="password" value={memberAccountForm.password}
                      onChange={(e) => setMemberAccountForm((p) => ({ ...p, password: e.target.value }))}
                      placeholder="Min 4 chars" className="mt-1 w-full rounded-xl border border-gray-300 bg-white px-3 py-2 text-sm" required />
                  </label>
                  <div className="md:col-span-2 flex justify-end">
                    <button type="submit" disabled={memberAccountSaving}
                      className="rounded-xl bg-blue-600 px-5 py-2 text-sm font-extrabold text-white hover:bg-blue-700 disabled:opacity-60">
                      {memberAccountSaving ? 'Creating...' : 'Create Account'}
                    </button>
                  </div>
                </form>

                <div>
                  <div className="mb-2 flex items-center justify-between">
                    <h3 className="text-sm font-black text-black">Member Accounts</h3>
                    <input type="text" value={memberAccountSearch} onChange={(e) => setMemberAccountSearch(e.target.value)}
                      placeholder="Search name / user ID..." className="w-48 rounded-xl border border-gray-300 px-3 py-1.5 text-xs" />
                  </div>
                  {memberAccountsLoading && <p className="text-sm text-gray-500">Loading...</p>}
                  {!memberAccountsLoading && (
                    <div className="overflow-x-auto">
                      <table className="min-w-full text-sm">
                        <thead>
                          <tr className="border-b text-left text-xs font-black uppercase tracking-wide text-gray-500">
                            <th className="py-2 pr-4">Name</th>
                            <th className="py-2 pr-4">Reg #</th>
                            <th className="py-2 pr-4">User ID</th>
                            <th className="py-2 pr-4">Email</th>
                            <th className="py-2 pr-4">Created</th>
                            <th className="py-2">Delete</th>
                          </tr>
                        </thead>
                        <tbody>
                          {memberAccounts.filter((m) => {
                            const q = memberAccountSearch.toLowerCase();
                            return !q || `${m.member_name} ${m.user_id} ${m.registration_number}`.toLowerCase().includes(q);
                          }).map((m) => (
                            <tr key={m.id} className="border-b hover:bg-gray-50">
                              <td className="py-2 pr-4 font-bold text-gray-800">{m.member_name}</td>
                              <td className="py-2 pr-4 text-xs text-gray-600">{m.registration_number}</td>
                              <td className="py-2 pr-4 font-mono text-xs">{m.user_id}</td>
                              <td className="py-2 pr-4 text-xs text-gray-500">{m.email || '-'}</td>
                              <td className="py-2 pr-4 text-xs text-gray-500">{m.created_at?.slice(0, 10)}</td>
                              <td className="py-2">
                                <button type="button" onClick={() => handleDeleteMemberAccount(m.id, m.member_name)}
                                  className="rounded-lg bg-red-500 px-3 py-1 text-xs font-bold text-white hover:bg-red-600">Delete</button>
                              </td>
                            </tr>
                          ))}
                          {memberAccounts.length === 0 && (
                            <tr><td colSpan="6" className="py-4 text-center text-gray-400">No member accounts yet.</td></tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* ── Company IDs ── */}
            {idSubTab === 'companies' && (
              <div className="space-y-5">
                <form onSubmit={handleCreateCompanyAccount} className="grid grid-cols-1 gap-3 rounded-2xl border border-blue-100 bg-blue-50 p-4 md:grid-cols-2">
                  <h3 className="text-sm font-black text-black md:col-span-2">Issue New Company Account</h3>
                  <label className="text-xs font-semibold text-gray-700">Company Name
                    <input type="text" value={companyAccountForm.company_name}
                      onChange={(e) => setCompanyAccountForm((p) => ({ ...p, company_name: e.target.value }))}
                      className="mt-1 w-full rounded-xl border border-gray-300 bg-white px-3 py-2 text-sm" required />
                  </label>
                  <label className="text-xs font-semibold text-gray-700">Contact Person
                    <input type="text" value={companyAccountForm.contact_person}
                      onChange={(e) => setCompanyAccountForm((p) => ({ ...p, contact_person: e.target.value }))}
                      className="mt-1 w-full rounded-xl border border-gray-300 bg-white px-3 py-2 text-sm" />
                  </label>
                  <label className="text-xs font-semibold text-gray-700">Contact Number
                    <input type="text" value={companyAccountForm.contact_number}
                      onChange={(e) => setCompanyAccountForm((p) => ({ ...p, contact_number: e.target.value }))}
                      className="mt-1 w-full rounded-xl border border-gray-300 bg-white px-3 py-2 text-sm" />
                  </label>
                  <label className="text-xs font-semibold text-gray-700">Email (optional)
                    <input type="email" value={companyAccountForm.email}
                      onChange={(e) => setCompanyAccountForm((p) => ({ ...p, email: e.target.value }))}
                      className="mt-1 w-full rounded-xl border border-gray-300 bg-white px-3 py-2 text-sm" />
                  </label>
                  <label className="text-xs font-semibold text-gray-700">User ID (login identifier)
                    <input type="text" value={companyAccountForm.user_id}
                      onChange={(e) => setCompanyAccountForm((p) => ({ ...p, user_id: e.target.value }))}
                      placeholder="e.g. company@domain or custom id" className="mt-1 w-full rounded-xl border border-gray-300 bg-white px-3 py-2 text-sm" required />
                  </label>
                  <label className="text-xs font-semibold text-gray-700">Password
                    <input type="password" value={companyAccountForm.password}
                      onChange={(e) => setCompanyAccountForm((p) => ({ ...p, password: e.target.value }))}
                      placeholder="Min 4 chars" className="mt-1 w-full rounded-xl border border-gray-300 bg-white px-3 py-2 text-sm" required />
                  </label>
                  <label className="text-xs font-semibold text-gray-700 md:col-span-2">Notes (optional)
                    <input type="text" value={companyAccountForm.notes}
                      onChange={(e) => setCompanyAccountForm((p) => ({ ...p, notes: e.target.value }))}
                      className="mt-1 w-full rounded-xl border border-gray-300 bg-white px-3 py-2 text-sm" />
                  </label>
                  <div className="md:col-span-2 flex justify-end">
                    <button type="submit" disabled={companyAccountSaving}
                      className="rounded-xl bg-blue-600 px-5 py-2 text-sm font-extrabold text-white hover:bg-blue-700 disabled:opacity-60">
                      {companyAccountSaving ? 'Creating...' : 'Create Account'}
                    </button>
                  </div>
                </form>

                <div>
                  {companyAccountsLoading && <p className="text-sm text-gray-500">Loading...</p>}
                  {!companyAccountsLoading && (
                    <div className="overflow-x-auto">
                      <table className="min-w-full text-sm">
                        <thead>
                          <tr className="border-b text-left text-xs font-black uppercase tracking-wide text-gray-500">
                            <th className="py-2 pr-4">Company</th>
                            <th className="py-2 pr-4">Contact Person</th>
                            <th className="py-2 pr-4">User ID</th>
                            <th className="py-2 pr-4">Email</th>
                            <th className="py-2 pr-4">Created</th>
                            <th className="py-2">Delete</th>
                          </tr>
                        </thead>
                        <tbody>
                          {companyAccounts.map((c) => (
                            <tr key={c.id} className="border-b hover:bg-gray-50">
                              <td className="py-2 pr-4 font-bold text-gray-800">{c.company_name}</td>
                              <td className="py-2 pr-4 text-xs text-gray-600">{c.contact_person || '-'}</td>
                              <td className="py-2 pr-4 font-mono text-xs">{c.user_id}</td>
                              <td className="py-2 pr-4 text-xs text-gray-500">{c.email || '-'}</td>
                              <td className="py-2 pr-4 text-xs text-gray-500">{c.created_at?.slice(0, 10)}</td>
                              <td className="py-2">
                                <button type="button" onClick={() => handleDeleteCompanyAccount(c.id, c.company_name)}
                                  className="rounded-lg bg-red-500 px-3 py-1 text-xs font-bold text-white hover:bg-red-600">Delete</button>
                              </td>
                            </tr>
                          ))}
                          {companyAccounts.length === 0 && (
                            <tr><td colSpan="6" className="py-4 text-center text-gray-400">No company accounts yet.</td></tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* ── Reset Requests ── */}
            {idSubTab === 'reset-requests' && (
              <div>
                <div className="mb-3 flex items-center justify-between">
                  <h3 className="text-sm font-black text-black">Forgot Password Requests</h3>
                  <button type="button" onClick={fetchResetRequests}
                    className="rounded-xl border border-gray-300 px-3 py-1.5 text-xs font-bold hover:border-blue-400">Refresh</button>
                </div>
                {resetRequestsLoading && <p className="text-sm text-gray-500">Loading...</p>}
                {!resetRequestsLoading && (
                  <div className="space-y-2">
                    {resetRequests.length === 0 && (
                      <div className="rounded-2xl border border-dashed border-gray-200 py-10 text-center text-sm text-gray-400">No requests yet.</div>
                    )}
                    {resetRequests.map((r) => (
                      <div key={r.id} className={`rounded-2xl border p-4 ${r.status === 'Pending' ? 'border-amber-200 bg-amber-50' : 'border-gray-200 bg-gray-50'}`}>
                        <div className="flex flex-wrap items-start justify-between gap-3">
                          <div>
                            <span className={`inline-block rounded-full px-2 py-0.5 text-[10px] font-extrabold ${r.status === 'Pending' ? 'bg-amber-400 text-black' : 'bg-green-100 text-green-700'}`}>{r.status}</span>
                            <p className="mt-1 font-black text-gray-800">User ID: <span className="font-mono text-blue-700">{r.user_id}</span></p>
                            {r.contact_name && <p className="text-xs text-gray-600">From: {r.contact_name} {r.contact_phone && `· ${r.contact_phone}`}</p>}
                            {r.message && <p className="mt-1 text-xs italic text-gray-500">"{r.message}"</p>}
                            <p className="mt-1 text-[10px] text-gray-400">{r.created_at?.slice(0, 16)}</p>
                          </div>
                          {r.status === 'Pending' && (
                            <div className="flex items-center gap-2">
                              <input type="password" placeholder="New password"
                                value={resolvePasswordMap[r.id] || ''}
                                onChange={(e) => setResolvePasswordMap((p) => ({ ...p, [r.id]: e.target.value }))}
                                className="w-36 rounded-xl border border-gray-300 bg-white px-3 py-1.5 text-xs focus:outline-none focus:ring-2 focus:ring-blue-300" />
                              <button type="button" disabled={resolvingResetId === r.id}
                                onClick={() => handleResolveResetRequest(r.id)}
                                className="rounded-xl bg-blue-600 px-3 py-1.5 text-xs font-extrabold text-white hover:bg-blue-700 disabled:opacity-60">
                                {resolvingResetId === r.id ? 'Resolving...' : 'Set & Resolve'}
                              </button>
                              <a href={`https://wa.me/${String(r.contact_phone || '').replace(/\D/g,'').length === 10 ? `91${String(r.contact_phone).replace(/\D/g,'')}` : String(r.contact_phone || '').replace(/\D/g,'')}`}
                                target="_blank" rel="noreferrer"
                                className="rounded-xl border border-green-400 bg-green-50 px-3 py-1.5 text-xs font-extrabold text-green-700 hover:bg-green-100">
                                WhatsApp
                              </a>
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      )}

      {activeTab === 'partners' && (
        <div className="space-y-6">
          <div className="rounded-[28px] border border-gray-200 bg-white p-5 shadow-sm">
              <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                <h3 className="text-xl font-black text-black">Partners</h3>
                <button type="button" onClick={fetchPartners} className="rounded-xl bg-yellow-400 px-4 py-2.5 font-extrabold text-black hover:bg-yellow-500">
                  Refresh
                </button>
              </div>

              <div className="mt-4 rounded-[24px] border border-yellow-200 bg-[linear-gradient(135deg,#fffdf7_0%,#fff8e6_50%,#ffffff_100%)] p-3">
                <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
                  <input
                    type="text"
                    name="search"
                    value={partnerFilters.search}
                    onChange={handlePartnerFilterChange}
                    placeholder="Search organisation, owner, contact"
                    className="rounded-2xl border border-gray-300 bg-white px-3 py-2.5"
                  />
                  <input
                    type="text"
                    name="district"
                    value={partnerFilters.district}
                    onChange={handlePartnerFilterChange}
                    placeholder="Filter by district"
                    className="rounded-2xl border border-gray-300 bg-white px-3 py-2.5"
                  />
                  <select
                    name="status"
                    value={partnerFilters.status}
                    onChange={handlePartnerFilterChange}
                    className="rounded-2xl border border-gray-300 bg-white px-3 py-2.5"
                  >
                    <option value="all">All statuses</option>
                    {partnerStatusOptions.map((status) => (
                      <option key={status} value={status}>{status}</option>
                    ))}
                  </select>
                </div>
                <div className="mt-3 flex flex-wrap items-center justify-between gap-3">
                  <p className="text-sm text-gray-600">
                    Showing {filteredPartners.length === 0 ? 0 : (safePartnersPage - 1) * PARTNERS_PAGE_SIZE + 1}
                    {' '}-{' '}
                    {Math.min(safePartnersPage * PARTNERS_PAGE_SIZE, filteredPartners.length)} of {filteredPartners.length} partnership submissions.
                  </p>
                  <button
                    type="button"
                    onClick={clearPartnerFilters}
                    className="rounded-xl border border-gray-300 bg-white px-4 py-2.5 text-sm font-bold text-black hover:border-yellow-400"
                  >
                    Clear Filters
                  </button>
                </div>
              </div>

              {partnersLoading && <div className="mt-4 text-gray-600">Loading partnership submissions...</div>}
              {!partnersLoading && filteredPartners.length === 0 && (
                <div className="mt-4 rounded-2xl border border-dashed border-gray-300 bg-gray-50 px-4 py-5 text-sm text-gray-600">
                  No partnership submissions found for the selected filters.
                </div>
              )}

              {!partnersLoading && filteredPartners.length > 0 && (
                <div className="mt-4 overflow-x-auto rounded-[24px] border border-gray-200 bg-white shadow-sm">
                  <table className="min-w-[1320px] w-full text-left">
                    <thead className="bg-[linear-gradient(135deg,#fffdfa_0%,#fff6d8_100%)]">
                      <tr>
                        <th className="border-b border-gray-200 px-3 py-2.5 text-xs font-extrabold uppercase tracking-[0.18em] text-gray-600">Submitted</th>
                        <th className="border-b border-gray-200 px-3 py-2.5 text-xs font-extrabold uppercase tracking-[0.18em] text-gray-600">Organisation</th>
                        <th className="border-b border-gray-200 px-3 py-2.5 text-xs font-extrabold uppercase tracking-[0.18em] text-gray-600">Contact Details</th>
                        <th className="border-b border-gray-200 px-3 py-2.5 text-xs font-extrabold uppercase tracking-[0.18em] text-gray-600">Links</th>
                        <th className="border-b border-gray-200 px-3 py-2.5 text-xs font-extrabold uppercase tracking-[0.18em] text-gray-600">Partner Login</th>
                        <th className="border-b border-gray-200 px-3 py-2.5 text-xs font-extrabold uppercase tracking-[0.18em] text-gray-600">Status</th>
                        <th className="border-b border-gray-200 px-3 py-2.5 text-xs font-extrabold uppercase tracking-[0.18em] text-gray-600">Admin Note</th>
                        <th className="border-b border-gray-200 px-3 py-2.5 text-xs font-extrabold uppercase tracking-[0.18em] text-gray-600">Uploads</th>
                        <th className="border-b border-gray-200 px-3 py-2.5 text-xs font-extrabold uppercase tracking-[0.18em] text-gray-600">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {paginatedPartners.map((partner) => (
                        <tr key={partner.id} className="align-top odd:bg-white even:bg-gray-50/60">
                          <td className="border-b border-gray-200 px-3 py-3 text-sm text-gray-600">
                            <div className="font-bold text-black">{partner.created_at}</div>
                            <div className="mt-2 text-xs text-gray-500">Updated {partner.status_updated_at || partner.created_at}</div>
                          </td>
                          <td className="border-b border-gray-200 px-3 py-3 text-sm text-gray-700">
                            <div className="text-lg font-black text-black">{partner.name_of_organisation}</div>
                            <div className="mt-1">Owner: <span className="font-bold text-black">{partner.owner_of_organisation}</span></div>
                            <div className="mt-1">{partner.place}, {partner.district}</div>
                            <div className="mt-1">Experience: <span className="font-semibold text-black">{partner.years_of_experience || '-'}</span></div>
                          </td>
                          <td className="border-b border-gray-200 px-3 py-3 text-sm text-gray-700">
                            <div>Contact: <ContactLink value={partner.contact_number} /></div>
                            <div className="mt-1">Whatsapp: <ContactLink value={partner.whatsapp_number} type="whatsapp" /></div>
                            <div className="mt-1 break-all">Email: <span className="font-semibold text-black">{partner.email_id || '-'}</span></div>
                          </td>
                          <td className="border-b border-gray-200 px-3 py-3 text-sm text-gray-700">
                            <div>
                              {partner.website ? (
                                <a href={partner.website} target="_blank" rel="noreferrer" className="font-bold text-blue-600 underline">Website</a>
                              ) : 'Website -'}
                            </div>
                            <div className="mt-2">
                              {partner.location_map ? (
                                <a href={partner.location_map} target="_blank" rel="noreferrer" className="font-bold text-blue-600 underline">Location Map</a>
                              ) : 'Map -'}
                            </div>
                          </td>
                          <td className="border-b border-gray-200 px-3 py-3 text-sm text-gray-700">
                            <div className="w-[240px] space-y-3">
                              <div className="rounded-2xl border border-yellow-200 bg-yellow-50 px-3 py-2.5">
                                <div className="text-xs font-extrabold uppercase tracking-[0.18em] text-yellow-700">Current Login ID</div>
                                <div className="mt-2 break-all font-bold text-black">{partner.partner_user_id || 'Not created yet'}</div>
                                <div className="mt-2 text-xs text-gray-500">
                                  {partner.has_partner_account ? `Created ${partner.account_created_at || '-'}` : 'Create a login ID and password for this partner from here.'}
                                </div>
                              </div>
                              <input
                                type="text"
                                value={partner.partner_user_id || ''}
                                onChange={(e) => handlePartnerFieldChange(partner.id, 'partner_user_id', e.target.value)}
                                placeholder="Partner login ID or leave blank"
                                className="w-full rounded-xl border border-gray-300 bg-white px-3 py-2"
                              />
                              <input
                                type="text"
                                value={partner.partner_password || ''}
                                onChange={(e) => handlePartnerFieldChange(partner.id, 'partner_password', e.target.value)}
                                placeholder="Create password"
                                className="w-full rounded-xl border border-gray-300 bg-white px-3 py-2"
                              />
                              <input
                                type="text"
                                value={partner.commission_percentage || ''}
                                onChange={(e) => handlePartnerFieldChange(partner.id, 'commission_percentage', e.target.value)}
                                placeholder="Commission %"
                                className="w-full rounded-xl border border-gray-300 bg-white px-3 py-2"
                              />
                              <button
                                type="button"
                                onClick={() => handlePartnerAccountSave(partner)}
                                disabled={savingPartnerAccountId === partner.id}
                                className="w-full rounded-xl bg-black px-3 py-2 text-sm font-extrabold text-yellow-300 hover:bg-gray-900 disabled:opacity-60"
                              >
                                {savingPartnerAccountId === partner.id ? 'Saving Login...' : partner.has_partner_account ? 'Update Login' : 'Create Login'}
                              </button>
                            </div>
                          </td>
                          <td className="border-b border-gray-200 px-3 py-3 text-sm text-gray-700">
                            <div className="flex flex-col gap-2">
                              <span className={`inline-flex w-fit rounded-full px-3 py-1 text-xs font-extrabold uppercase tracking-[0.16em] ${
                                partner.partnership_status === 'Approved'
                                  ? 'bg-emerald-100 text-emerald-700'
                                  : partner.partnership_status === 'Rejected'
                                    ? 'bg-red-100 text-red-700'
                                    : partner.partnership_status === 'Contacted'
                                      ? 'bg-blue-100 text-blue-700'
                                      : 'bg-gray-100 text-gray-700'
                              }`}>
                                {partner.partnership_status || 'Pending'}
                              </span>
                              <select
                                value={partner.partnership_status || 'Pending'}
                                onChange={(e) => handlePartnerStatusUpdate(partner.id, e.target.value, partner.admin_note || '')}
                                disabled={savingPartnerId === partner.id}
                                className="rounded-xl border border-gray-300 bg-white px-3 py-2 text-sm"
                              >
                                {partnerStatusOptions.map((status) => (
                                  <option key={status} value={status}>{status}</option>
                                ))}
                              </select>
                            </div>
                          </td>
                          <td className="border-b border-gray-200 px-3 py-3 text-sm text-gray-700">
                            <textarea
                              value={partner.admin_note || ''}
                              onChange={(e) => setPartners((prev) => prev.map((row) => (
                                row.id === partner.id ? { ...row, admin_note: e.target.value } : row
                              )))}
                              className="min-h-[88px] w-[220px] rounded-xl border border-gray-300 bg-white px-3 py-2.5"
                              rows={4}
                              placeholder="Add admin note"
                            />
                          </td>
                          <td className="border-b border-gray-200 px-3 py-3 text-sm text-gray-700">
                            <div className="flex flex-col gap-2">
                              {partner.organisation_license_file ? (
                                <a href={`${API_URL}${partner.organisation_license_file}`} target="_blank" rel="noreferrer" className="font-bold text-blue-600 underline">Licence</a>
                              ) : <span>Licence -</span>}
                              {partner.organisation_photo_file ? (
                                <a href={`${API_URL}${partner.organisation_photo_file}`} target="_blank" rel="noreferrer" className="font-bold text-blue-600 underline">Photo</a>
                              ) : <span>Photo -</span>}
                              {partner.organisation_name_board_photo_file ? (
                                <a href={`${API_URL}${partner.organisation_name_board_photo_file}`} target="_blank" rel="noreferrer" className="font-bold text-blue-600 underline">Name Board</a>
                              ) : <span>Name Board -</span>}
                            </div>
                          </td>
                          <td className="border-b border-gray-200 px-3 py-3 text-sm text-gray-700">
                            <div className="grid grid-cols-1 gap-2">
                              <button
                                type="button"
                                onClick={() => openEditPartner(partner)}
                                className="rounded-xl bg-yellow-400 px-3 py-2 text-sm font-extrabold text-black hover:bg-yellow-500"
                              >
                                Edit / Upload
                              </button>
                              <button
                                type="button"
                                onClick={() => handlePartnerStatusUpdate(partner.id, 'Approved', partner.admin_note || '')}
                                disabled={savingPartnerId === partner.id}
                                className="rounded-xl bg-emerald-500 px-3 py-2 text-sm font-extrabold text-white hover:bg-emerald-600 disabled:opacity-60"
                              >
                                Approve
                              </button>
                              <button
                                type="button"
                                onClick={() => handlePartnerStatusUpdate(partner.id, 'Contacted', partner.admin_note || '')}
                                disabled={savingPartnerId === partner.id}
                                className="rounded-xl bg-blue-500 px-3 py-2 text-sm font-extrabold text-white hover:bg-blue-600 disabled:opacity-60"
                              >
                                Contacted
                              </button>
                              <button
                                type="button"
                                onClick={() => handlePartnerStatusUpdate(partner.id, 'Rejected', partner.admin_note || '')}
                                disabled={savingPartnerId === partner.id}
                                className="rounded-xl bg-red-500 px-3 py-2 text-sm font-extrabold text-white hover:bg-red-600 disabled:opacity-60"
                              >
                                Reject
                              </button>
                              <button
                                type="button"
                                onClick={() => handlePartnerStatusUpdate(partner.id, partner.partnership_status || 'Pending', partner.admin_note || '')}
                                disabled={savingPartnerId === partner.id}
                                className="rounded-xl border border-gray-300 bg-white px-3 py-2 text-sm font-extrabold text-black hover:border-yellow-400 disabled:opacity-60"
                              >
                                {savingPartnerId === partner.id ? 'Saving...' : 'Save Note'}
                              </button>
                              <button
                                type="button"
                                onClick={() => handleDeletePartner(partner.id, partner.name_of_organisation)}
                                className="rounded-xl bg-red-100 px-3 py-2 text-sm font-extrabold text-red-700 hover:bg-red-200"
                              >
                                Delete
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  {filteredPartners.length > PARTNERS_PAGE_SIZE && (
                    <div className="flex flex-col gap-3 border-t border-gray-200 pt-3 sm:flex-row sm:items-center sm:justify-between">
                      <p className="text-sm text-gray-600">
                        Page {safePartnersPage} of {totalPartnerPages}
                      </p>
                      <div className="flex flex-wrap items-center gap-2">
                        <button
                          type="button"
                          onClick={() => setPartnersPage((prev) => Math.max(1, prev - 1))}
                          disabled={safePartnersPage === 1}
                          className="rounded-lg border border-gray-300 px-3 py-2 text-sm font-bold text-black transition hover:border-yellow-400 hover:text-yellow-700 disabled:cursor-not-allowed disabled:opacity-50"
                        >
                          Previous
                        </button>
                        {Array.from({ length: totalPartnerPages }, (_, index) => index + 1).map((pageNumber) => (
                          <button
                            key={pageNumber}
                            type="button"
                            onClick={() => setPartnersPage(pageNumber)}
                            className={`rounded-lg px-3 py-2 text-sm font-bold transition ${
                              safePartnersPage === pageNumber
                                ? 'bg-black text-yellow-300'
                                : 'border border-gray-300 text-black hover:border-yellow-400 hover:text-yellow-700'
                            }`}
                          >
                            {pageNumber}
                          </button>
                        ))}
                        <button
                          type="button"
                          onClick={() => setPartnersPage((prev) => Math.min(totalPartnerPages, prev + 1))}
                          disabled={safePartnersPage === totalPartnerPages}
                          className="rounded-lg border border-gray-300 px-3 py-2 text-sm font-bold text-black transition hover:border-yellow-400 hover:text-yellow-700 disabled:cursor-not-allowed disabled:opacity-50"
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              )}
          </div>
        </div>
      )}

      {activeTab === 'partner-registrations' && (
        <div className="space-y-6">
          <div className="rounded-[24px] border border-gray-200 bg-white p-4 shadow-sm">
            <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
              <div className="flex items-center gap-3">
                <h3 className="text-xl font-black text-black">Partner Registrations</h3>
                <span className="rounded-2xl border border-gray-200 bg-gray-50 px-3 py-1.5 text-sm font-bold text-black">Total: {partnerRegistrations.length}</span>
              </div>
              <button
                type="button"
                onClick={fetchPartnerRegistrations}
                className="rounded-xl border border-gray-300 bg-white px-4 py-2 text-sm font-bold text-black hover:border-yellow-400"
              >
                Refresh Registrations
              </button>
            </div>

            {/* Summary cards (follow the active filters) */}
            <div className="mt-4 grid grid-cols-2 gap-3 sm:grid-cols-3 xl:grid-cols-6">
              {[
                { label: 'Total Received', value: prSummary.total, icon: '📥', cls: 'from-slate-800 to-black text-white', sub: 'text-yellow-300' },
                { label: 'Forwarded to HR', value: prSummary.forwarded, icon: '📤', cls: 'from-emerald-400 to-emerald-600 text-white', sub: 'text-emerald-50' },
                { label: 'Pending Forward', value: prSummary.pending, icon: '⏳', cls: 'from-orange-400 to-rose-500 text-white', sub: 'text-orange-50' },
                { label: 'Placed', value: prSummary.placed, icon: '🏆', cls: 'from-yellow-300 to-amber-500 text-black', sub: 'text-black/70' },
                { label: 'Partners', value: prSummary.partners, icon: '🤝', cls: 'from-sky-400 to-blue-600 text-white', sub: 'text-sky-50' },
                { label: 'This Month', value: prSummary.thisMonth, icon: '📅', cls: 'from-violet-400 to-purple-600 text-white', sub: 'text-violet-50' }
              ].map((card) => (
                <div key={card.label} className={`relative overflow-hidden rounded-2xl bg-gradient-to-br p-4 shadow-md transition hover:-translate-y-0.5 hover:shadow-lg ${card.cls}`}>
                  <span className="absolute -right-3 -top-3 text-5xl opacity-20" aria-hidden="true">{card.icon}</span>
                  <div className={`text-xs font-extrabold uppercase tracking-[0.14em] ${card.sub}`}>{card.label}</div>
                  <div className="mt-2 text-3xl font-black">{card.value}</div>
                  {card.label === 'Placed' && prSummary.forwarded > 0 && (
                    <div className={`mt-1 text-xs font-bold ${card.sub}`}>{Math.round((prSummary.placed / prSummary.forwarded) * 100)}% of forwarded</div>
                  )}
                </div>
              ))}
            </div>

            {/* Filters */}
            <div className="mt-4 rounded-2xl border border-yellow-200 bg-gradient-to-r from-yellow-50 to-amber-50 p-3">
              <div className="grid grid-cols-1 gap-2 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-7">
                <input
                  name="search"
                  value={prFilters.search}
                  onChange={handlePrFilterChange}
                  placeholder="🔍 Search member, contact, place"
                  className="rounded-xl border border-gray-300 bg-white px-3 py-2 text-sm xl:col-span-2"
                />
                <select name="partner" value={prFilters.partner} onChange={handlePrFilterChange} className="rounded-xl border border-gray-300 bg-white px-3 py-2 text-sm">
                  <option value="">All partners</option>
                  {prPartnerOptions.map((name) => <option key={name} value={name}>{name}</option>)}
                </select>
                <select name="month" value={prFilters.month} onChange={handlePrFilterChange} className="rounded-xl border border-gray-300 bg-white px-3 py-2 text-sm">
                  <option value="">All months</option>
                  {prMonthOptions.map((ym) => <option key={ym} value={ym}>{formatMonthLabel(ym)}</option>)}
                </select>
                <label className="flex items-center gap-2 rounded-xl border border-gray-300 bg-white px-3 py-1 text-xs font-bold text-gray-500">
                  From
                  <input type="date" name="from" value={prFilters.from} onChange={handlePrFilterChange} className="w-full bg-transparent text-sm font-normal text-black outline-none" />
                </label>
                <label className="flex items-center gap-2 rounded-xl border border-gray-300 bg-white px-3 py-1 text-xs font-bold text-gray-500">
                  To
                  <input type="date" name="to" value={prFilters.to} onChange={handlePrFilterChange} className="w-full bg-transparent text-sm font-normal text-black outline-none" />
                </label>
                <select name="status" value={prFilters.status} onChange={handlePrFilterChange} className="rounded-xl border border-gray-300 bg-white px-3 py-2 text-sm">
                  <option value="">All statuses</option>
                  <option value="forwarded">Forwarded to HR</option>
                  <option value="pending">Pending forward</option>
                  <option value="placed">Placed</option>
                </select>
              </div>
              <div className="mt-2 flex flex-wrap items-center justify-between gap-2">
                <p className="text-sm text-gray-600">
                  Showing <b className="text-black">{filteredPartnerRegistrations.length}</b> of {partnerRegistrations.length} registrations
                  {prActiveFilterCount > 0 && <span className="ml-2 rounded-full bg-yellow-400 px-2 py-0.5 text-xs font-bold text-black">{prActiveFilterCount} filter{prActiveFilterCount > 1 ? 's' : ''} on</span>}
                </p>
                <button
                  type="button"
                  onClick={() => { setPrFilters(initialPrFilters); setPrPage(1); }}
                  disabled={prActiveFilterCount === 0}
                  className="rounded-xl border border-gray-300 bg-white px-3 py-1.5 text-sm font-bold text-black hover:border-yellow-400 disabled:opacity-40"
                >
                  Clear Filters
                </button>
              </div>
            </div>

            {partnerRegistrationsLoading && <div className="mt-4 text-gray-600">Loading partner registrations...</div>}
            {!partnerRegistrationsLoading && filteredPartnerRegistrations.length === 0 && (
              <div className="mt-4 rounded-2xl border border-dashed border-gray-300 bg-gray-50 px-4 py-5 text-sm text-gray-600">
                {partnerRegistrations.length === 0
                  ? 'No partner member registrations have been submitted yet.'
                  : 'No registrations match these filters.'}
              </div>
            )}

            {!partnerRegistrationsLoading && filteredPartnerRegistrations.length > 0 && (
              <div className="mt-4 overflow-x-auto rounded-[20px] border border-gray-200 bg-white">
                <table className="min-w-[1400px] w-full text-left text-sm">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="border-b border-gray-200 px-3 py-2.5 font-extrabold text-gray-700">Submitted</th>
                      <th className="border-b border-gray-200 px-3 py-2.5 font-extrabold text-gray-700">Partner</th>
                      <th className="border-b border-gray-200 px-3 py-2.5 font-extrabold text-gray-700">Member</th>
                      <th className="border-b border-gray-200 px-3 py-2.5 font-extrabold text-gray-700">Contact</th>
                      <th className="border-b border-gray-200 px-3 py-2.5 font-extrabold text-gray-700">Profile</th>
                      <th className="border-b border-gray-200 px-3 py-2.5 font-extrabold text-gray-700">Qualification</th>
                      <th className="border-b border-gray-200 px-3 py-2.5 font-extrabold text-gray-700">Expectation</th>
                      <th className="border-b border-gray-200 px-3 py-2.5 font-extrabold text-gray-700">Commission</th>
                      <th className="border-b border-gray-200 px-3 py-2.5 font-extrabold text-gray-700">Resume</th>
                      <th className="border-b border-gray-200 px-3 py-2.5 font-extrabold text-gray-700">Forward to HR</th>
                    </tr>
                  </thead>
                  <tbody>
                    {pagedPartnerRegistrations.map((registration) => (
                      <tr key={registration.id} className="align-top odd:bg-white even:bg-gray-50/60">
                        <td className="border-b border-gray-200 px-3 py-3 text-gray-600">{registration.created_at}</td>
                        <td className="border-b border-gray-200 px-3 py-3 text-gray-700">
                          <div className="font-bold text-black">{registration.partner_name_of_organisation || '-'}</div>
                          <div className="mt-1 text-xs text-gray-500">Owner: {registration.partner_owner_of_organisation || '-'}</div>
                          <div className="mt-1 text-xs text-gray-500">Login ID: {registration.partner_user_id || '-'}</div>
                        </td>
                        <td className="border-b border-gray-200 px-3 py-3 text-gray-700">
                          <div className="font-bold text-black">{registration.name}</div>
                          <div className="mt-1 text-xs text-gray-500">Age: {registration.age || '-'}</div>
                          <div className="mt-1 text-xs text-gray-500">Gender: {registration.gender || '-'}</div>
                          {registration.remarks && (
                            <div className="mt-2 max-w-[240px] whitespace-pre-line rounded-lg border border-yellow-200 bg-yellow-50 px-2 py-1.5 text-xs text-gray-700">
                              <span className="font-bold text-yellow-800">💬 Remarks: </span>{registration.remarks}
                            </div>
                          )}
                          {registration.voice_note_file && (
                            <div className="mt-2">
                              <div className="text-[11px] font-bold text-gray-500">🎤 Voice note</div>
                              <audio controls preload="none" src={`${API_URL}${registration.voice_note_file}`} className="mt-0.5 h-8 w-[220px]" />
                            </div>
                          )}
                        </td>
                        <td className="border-b border-gray-200 px-3 py-3 text-gray-700">
                          <div>Contact: <ContactLink value={registration.contact_number} /></div>
                          <div className="mt-1">WhatsApp: <ContactLink value={registration.whatsapp_number} type="whatsapp" /></div>
                        </td>
                        <td className="border-b border-gray-200 px-3 py-3 text-gray-700">
                          <div>{registration.place}, {registration.district}</div>
                          <div className="mt-1 text-xs text-gray-500">Experience: {registration.experience_level || '-'}</div>
                        </td>
                        <td className="border-b border-gray-200 px-3 py-3 text-gray-700">{registration.qualification || '-'}</td>
                        <td className="border-b border-gray-200 px-3 py-3 text-gray-700">{registration.expecting_job || '-'}</td>
                        <td className="border-b border-gray-200 px-3 py-3 text-gray-700">{registration.commission_percentage ? `${registration.commission_percentage}%` : '-'}</td>
                        <td className="border-b border-gray-200 px-3 py-3 text-gray-700">
                          {registration.resume_file ? (
                            <a href={`${API_URL}${registration.resume_file}`} target="_blank" rel="noreferrer" className="font-bold text-blue-600 underline">Resume PDF</a>
                          ) : '-'}
                        </td>
                        <td className="border-b border-gray-200 px-3 py-3">
                          {registration.forwarded_to_hr ? (
                            <div className="flex flex-col items-start gap-1.5">
                              <span className="inline-flex items-center gap-1 rounded-full bg-emerald-100 border border-emerald-300 px-3 py-1 text-xs font-bold text-emerald-700">✓ Forwarded</span>
                              {registration.is_placed ? (
                                <span className="inline-flex items-center gap-1 rounded-full bg-gradient-to-r from-yellow-300 to-amber-400 border border-amber-500 px-3 py-1 text-xs font-extrabold text-black">🏆 Placed</span>
                              ) : registration.hr_status ? (
                                <span className="text-xs text-gray-500">HR: {registration.hr_status}</span>
                              ) : null}
                            </div>
                          ) : (
                            <button
                              type="button"
                              onClick={() => handleForwardPartnerRegistration(registration.id, false)}
                              className="rounded-xl border border-yellow-400 bg-yellow-50 px-3 py-1.5 text-xs font-bold text-yellow-800 hover:bg-yellow-100 transition"
                            >
                              Forward to HR
                            </button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {!partnerRegistrationsLoading && filteredPartnerRegistrations.length > 0 && (
              <div className="mt-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                <div className="flex items-center gap-2 text-sm text-gray-600">
                  <span>
                    {(prSafePage - 1) * prPageSize + 1}–{Math.min(prSafePage * prPageSize, filteredPartnerRegistrations.length)} of {filteredPartnerRegistrations.length}
                  </span>
                  <select
                    value={prPageSize}
                    onChange={(e) => { setPrPageSize(Number(e.target.value)); setPrPage(1); }}
                    className="rounded-lg border border-gray-300 bg-white px-2 py-1 text-sm"
                    aria-label="Rows per page"
                  >
                    {[10, 25, 50, 100].map((size) => <option key={size} value={size}>{size} / page</option>)}
                  </select>
                </div>
                <div className="flex flex-wrap items-center gap-1.5">
                  {[
                    { label: '« First', page: 1, disabled: prSafePage === 1 },
                    { label: '‹ Prev', page: prSafePage - 1, disabled: prSafePage === 1 }
                  ].map((btn) => (
                    <button key={btn.label} type="button" onClick={() => setPrPage(btn.page)} disabled={btn.disabled}
                      className="rounded-lg border border-gray-300 bg-white px-3 py-1.5 text-sm font-bold text-black hover:border-yellow-400 disabled:cursor-not-allowed disabled:opacity-40">
                      {btn.label}
                    </button>
                  ))}
                  {getPageNumbers(prSafePage, prTotalPages).map((n, i) => (
                    n === '...' ? (
                      <span key={`gap-${i}`} className="px-1 text-gray-400">…</span>
                    ) : (
                      <button key={n} type="button" onClick={() => setPrPage(n)}
                        className={`min-w-[36px] rounded-lg px-3 py-1.5 text-sm font-extrabold transition ${
                          n === prSafePage
                            ? 'bg-gradient-to-r from-yellow-400 to-amber-500 text-black shadow-md'
                            : 'border border-gray-300 bg-white text-black hover:border-yellow-400'
                        }`}>
                        {n}
                      </button>
                    )
                  ))}
                  {[
                    { label: 'Next ›', page: prSafePage + 1, disabled: prSafePage === prTotalPages },
                    { label: 'Last »', page: prTotalPages, disabled: prSafePage === prTotalPages }
                  ].map((btn) => (
                    <button key={btn.label} type="button" onClick={() => setPrPage(btn.page)} disabled={btn.disabled}
                      className="rounded-lg border border-gray-300 bg-white px-3 py-1.5 text-sm font-bold text-black hover:border-yellow-400 disabled:cursor-not-allowed disabled:opacity-40">
                      {btn.label}
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {activeTab === 'partner-vacancies' && (
        <AdminPartnerVacancies onPendingCount={setPartnerVacancyPending} />
      )}

      {activeTab === 'partner-commissions' && (
        <div className="space-y-6">
          <div className="rounded-[24px] border border-gray-200 bg-white p-4 shadow-sm">
            <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
              <div className="flex items-center gap-3">
                <h3 className="text-xl font-black text-black">Partner Commissions</h3>
                <span className="rounded-2xl border border-purple-200 bg-purple-50 px-3 py-1.5 text-sm font-bold text-purple-800">
                  Pending: {partnerCommissions.filter((c) => c.status === 'Pending').length}
                </span>
                <span className="rounded-2xl border border-gray-200 bg-gray-50 px-3 py-1.5 text-sm font-bold text-black">
                  Total: {partnerCommissions.length}
                </span>
              </div>
              <div className="flex gap-2">
                <button
                  type="button"
                  onClick={handleRecalculateCommissions}
                  className="rounded-xl border border-orange-300 bg-orange-50 px-4 py-2 text-sm font-bold text-orange-700 hover:bg-orange-100"
                >
                  Recalculate Missing
                </button>
                <button
                  type="button"
                  onClick={fetchAdminCommissions}
                  className="rounded-xl border border-gray-300 bg-white px-4 py-2 text-sm font-bold text-black hover:border-purple-400"
                >
                  ↺ Refresh
                </button>
              </div>
            </div>

            {partnerCommissionsLoading && <div className="mt-4 text-gray-600">Loading commissions...</div>}
            {!partnerCommissionsLoading && partnerCommissions.length === 0 && (
              <div className="mt-4 rounded-2xl border border-dashed border-gray-300 bg-gray-50 px-4 py-5 text-sm text-gray-600">
                No partner commissions have been generated yet.
              </div>
            )}

            {!partnerCommissionsLoading && partnerCommissions.length > 0 && (
              <div className="mt-4 overflow-x-auto rounded-[20px] border border-gray-200 bg-white">
                <table className="min-w-[1000px] w-full text-left text-sm">
                  <thead className="bg-purple-50">
                    <tr>
                      <th className="border-b border-gray-200 px-3 py-2.5 font-extrabold text-gray-700">Date</th>
                      <th className="border-b border-gray-200 px-3 py-2.5 font-extrabold text-gray-700">Partner</th>
                      <th className="border-b border-gray-200 px-3 py-2.5 font-extrabold text-gray-700">Member Name</th>
                      <th className="border-b border-gray-200 px-3 py-2.5 font-extrabold text-gray-700">Job Title</th>
                      <th className="border-b border-gray-200 px-3 py-2.5 font-extrabold text-gray-700">Company</th>
                      <th className="border-b border-gray-200 px-3 py-2.5 font-extrabold text-gray-700">Service Charge</th>
                      <th className="border-b border-gray-200 px-3 py-2.5 font-extrabold text-gray-700">Commission %</th>
                      <th className="border-b border-gray-200 px-3 py-2.5 font-extrabold text-gray-700">Commission Amount</th>
                      <th className="border-b border-gray-200 px-3 py-2.5 font-extrabold text-gray-700">Status</th>
                      <th className="border-b border-gray-200 px-3 py-2.5 font-extrabold text-gray-700">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {partnerCommissions.map((c) => (
                      <tr key={c.id} className="align-top odd:bg-white even:bg-gray-50/60">
                        <td className="border-b border-gray-200 px-3 py-3 text-gray-600 whitespace-nowrap">{c.created_at ? c.created_at.slice(0, 10) : '-'}</td>
                        <td className="border-b border-gray-200 px-3 py-3 text-gray-700">
                          <div className="font-bold text-black">{c.partner_org_name || '-'}</div>
                          <div className="text-xs text-gray-500">{c.partner_user_id || ''}</div>
                        </td>
                        <td className="border-b border-gray-200 px-3 py-3 font-bold text-black">
                          {c.member_name || '-'}
                          <p className={`mt-0.5 text-[10px] font-bold ${c.source_type === 'vacancy' ? 'text-blue-600' : 'text-gray-400'}`}>
                            {c.source_type === 'vacancy' ? '🏢 Partner shared vacancy' : '👤 Partner member referral'}
                          </p>
                        </td>
                        <td className="border-b border-gray-200 px-3 py-3 text-gray-700">{c.job_title || '-'}</td>
                        <td className="border-b border-gray-200 px-3 py-3 text-gray-700">{c.company || '-'}</td>
                        <td className="border-b border-gray-200 px-3 py-3 text-gray-700">{c.service_charge_amount ? `₹${c.service_charge_amount}` : '-'}</td>
                        <td className="border-b border-gray-200 px-3 py-3 text-gray-700">{c.commission_percentage ? `${c.commission_percentage}%` : '-'}</td>
                        <td className="border-b border-gray-200 px-3 py-3">
                          <span className="font-extrabold text-purple-700">{c.commission_amount && c.commission_amount !== '0' ? `₹${c.commission_amount}` : '-'}</span>
                        </td>
                        <td className="border-b border-gray-200 px-3 py-3">
                          {c.status === 'Paid' ? (
                            <div className="flex flex-col gap-1">
                              <span className="inline-block rounded-full bg-emerald-100 px-2 py-0.5 text-xs font-bold text-emerald-800">
                                Paid ✓{c.paid_at ? ` (${c.paid_at.slice(0, 10)})` : ''}
                              </span>
                              {c.transaction_screenshot && (
                                <button
                                  type="button"
                                  onClick={() => openCommissionReceipt(c.id, localStorage.getItem('adminToken'))}
                                  className="inline-block rounded-lg bg-gray-100 border border-gray-200 px-2 py-0.5 text-xs font-semibold text-gray-700 hover:bg-gray-200"
                                >
                                  🧾 View Receipt
                                </button>
                              )}
                            </div>
                          ) : (
                            <span className="inline-block rounded-full bg-yellow-100 px-2 py-0.5 text-xs font-bold text-yellow-800">Pending</span>
                          )}
                        </td>
                        <td className="border-b border-gray-200 px-3 py-3">
                          {c.status !== 'Paid' && (
                            <button
                              type="button"
                              onClick={() => handleMarkCommissionPaid(c.id)}
                              className="rounded-xl bg-purple-600 px-3 py-1.5 text-xs font-extrabold text-white hover:bg-purple-700 transition"
                            >
                              Mark Paid
                            </button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      )}

      {selectedRegistration && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
          <div className="max-h-[90vh] w-full max-w-4xl overflow-y-auto rounded-2xl bg-white p-6 text-black shadow-xl">
            <div className="flex items-start justify-between gap-4 border-b border-gray-200 pb-4">
              <div>
                <p className="text-xs font-extrabold uppercase tracking-[0.24em] text-yellow-600">Registration Details</p>
                <h3 className="mt-2 text-2xl font-black text-black">{selectedRegistration.name || 'Talent Registration'}</h3>
                <p className="mt-1 text-sm text-gray-500">Submitted at {selectedRegistration.created_at || '-'}</p>
              </div>
              <button
                type="button"
                onClick={() => setSelectedRegistration(null)}
                className="rounded-lg border border-gray-300 px-4 py-2 text-sm font-bold text-black hover:border-yellow-400"
              >
                Close
              </button>
            </div>

            <div className="mt-5 grid grid-cols-1 gap-4 text-sm md:grid-cols-2">
              <div className="rounded-2xl border border-amber-200 bg-amber-50 px-4 py-4"><span className="font-semibold">Registration Number:</span> {selectedRegistration.registration_number || '-'}</div>
              <div className="rounded-2xl border border-gray-200 bg-gray-50 px-4 py-4"><span className="font-semibold">Date of Communication:</span> {selectedRegistration.date_of_communication || '-'}</div>
              <div className="rounded-2xl border border-gray-200 bg-gray-50 px-4 py-4"><span className="font-semibold">Name:</span> {selectedRegistration.name || '-'}</div>
              <div className="rounded-2xl border border-gray-200 bg-gray-50 px-4 py-4"><span className="font-semibold">Email:</span> {selectedRegistration.email || '-'}</div>
              <div className="rounded-2xl border border-gray-200 bg-gray-50 px-4 py-4"><span className="font-semibold">Place:</span> {selectedRegistration.place || '-'}</div>
              <div className="rounded-2xl border border-gray-200 bg-gray-50 px-4 py-4"><span className="font-semibold">District:</span> {selectedRegistration.district || '-'}</div>
              <div className="rounded-2xl border border-gray-200 bg-gray-50 px-4 py-4"><span className="font-semibold">Contact Number:</span> <ContactLink value={selectedRegistration.contact_number} /></div>
              <div className="rounded-2xl border border-gray-200 bg-gray-50 px-4 py-4"><span className="font-semibold">Whatsapp Number:</span> <ContactLink value={selectedRegistration.whatsapp_number} type="whatsapp" /></div>
              <div className="rounded-2xl border border-gray-200 bg-gray-50 px-4 py-4"><span className="font-semibold">Guardian Number:</span> {selectedRegistration.guardian_number || '-'}</div>
              <div className="rounded-2xl border border-gray-200 bg-gray-50 px-4 py-4"><span className="font-semibold">Age:</span> {selectedRegistration.age || '-'}</div>
              <div className="rounded-2xl border border-gray-200 bg-gray-50 px-4 py-4"><span className="font-semibold">Highest Qualification:</span> {selectedRegistration.highest_qualification || '-'}</div>
              <div className="rounded-2xl border border-gray-200 bg-gray-50 px-4 py-4"><span className="font-semibold">Qualification Department:</span> {selectedRegistration.qualification_department || '-'}</div>
              <div className="rounded-2xl border border-gray-200 bg-gray-50 px-4 py-4"><span className="font-semibold">Expecting Job:</span> {selectedRegistration.expecting_job || '-'}</div>
              <div className="rounded-2xl border border-gray-200 bg-gray-50 px-4 py-4"><span className="font-semibold">Job Priority:</span> {selectedRegistration.job_priority || '-'}</div>
              <div className="rounded-2xl border border-gray-200 bg-gray-50 px-4 py-4"><span className="font-semibold">Department:</span> {selectedRegistration.department || '-'}</div>
              <div className="rounded-2xl border border-gray-200 bg-gray-50 px-4 py-4"><span className="font-semibold">Section:</span> {selectedRegistration.section || '-'}</div>
              <div className="rounded-2xl border border-gray-200 bg-gray-50 px-4 py-4"><span className="font-semibold">Completed Year:</span> {selectedRegistration.completed_year || '-'}</div>
              <div className="rounded-2xl border border-gray-200 bg-gray-50 px-4 py-4"><span className="font-semibold">Exam Status:</span> {selectedRegistration.exam_status || '-'}</div>
              <div className="rounded-2xl border border-gray-200 bg-gray-50 px-4 py-4"><span className="font-semibold">Contact Through:</span> {selectedRegistration.contact_through || '-'}</div>
              <div className="rounded-2xl border border-gray-200 bg-gray-50 px-4 py-4"><span className="font-semibold">Preferred Location:</span> {selectedRegistration.preferred_location || '-'}</div>
              <div className="rounded-2xl border border-gray-200 bg-gray-50 px-4 py-4"><span className="font-semibold">License Category:</span> {selectedRegistration.license_category || '-'}</div>
              <div className="rounded-2xl border border-gray-200 bg-gray-50 px-4 py-4"><span className="font-semibold">Marital Status:</span> {selectedRegistration.marital_status || '-'}</div>
              <div className="rounded-2xl border border-gray-200 bg-gray-50 px-4 py-4"><span className="font-semibold">Highlight Language:</span> {selectedRegistration.highlight_language || '-'}</div>
              <div className="rounded-2xl border border-gray-200 bg-gray-50 px-4 py-4"><span className="font-semibold">Rating:</span> {selectedRegistration.rating || '-'}</div>
              <div className="rounded-2xl border border-gray-200 bg-gray-50 px-4 py-4"><span className="font-semibold">How you heard about Dani:</span> {selectedRegistration.how_you_heard || '-'}</div>
              <div className="rounded-2xl border border-gray-200 bg-gray-50 px-4 py-4"><span className="font-semibold">Additional Qualification:</span> {selectedRegistration.additional_qualification || '-'}</div>
              <div className="rounded-2xl border border-gray-200 bg-gray-50 px-4 py-4 md:col-span-2"><span className="font-semibold">Remarks:</span> {selectedRegistration.remarks || '-'}</div>
              <div className="rounded-2xl border border-gray-200 bg-gray-50 px-4 py-4 md:col-span-2"><span className="font-semibold">Google Location:</span> {selectedRegistration.google_location || '-'}</div>
              <div className="rounded-2xl border border-gray-200 bg-gray-50 px-4 py-4 md:col-span-2">
                <span className="font-semibold">Forward Status:</span>{' '}
                {Number(selectedRegistration.is_forwarded || 0) > 0
                  ? `Forwarded to ${selectedRegistration.current_handler_name || '-'} | ${selectedRegistration.current_communication_status || 'Waiting for the results'}`
                  : 'Not Forwarded'}
              </div>
              <div className="rounded-2xl border border-gray-200 bg-gray-50 px-4 py-4 md:col-span-2">
                <span className="font-semibold">Experience Details:</span>
                {Array.isArray(selectedRegistration.experience_details) && selectedRegistration.experience_details.length > 0 ? (
                  <div className="mt-3 space-y-3">
                    {selectedRegistration.experience_details.map((experience, index) => (
                      <div key={`admin-registration-experience-${selectedRegistration.id}-${index}`} className="rounded-xl border border-gray-200 bg-white px-4 py-3">
                        <div className="grid grid-cols-1 gap-2 md:grid-cols-2">
                          <div><span className="font-semibold">Exp Department:</span> {experience.exp_department || '-'}</div>
                          <div><span className="font-semibold">Title Post:</span> {experience.title_post || '-'}</div>
                          <div><span className="font-semibold">Company Name:</span> {experience.company_name || '-'}</div>
                          <div><span className="font-semibold">Salary:</span> {experience.salary || '-'}</div>
                          <div><span className="font-semibold">Total Years:</span> {experience.total_years || '-'}</div>
                          <div><span className="font-semibold">Location:</span> {experience.location || '-'}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <span> -</span>
                )}
              </div>
              <div className="rounded-2xl border border-gray-200 bg-gray-50 px-4 py-4">
                <span className="font-semibold">Resume:</span>{' '}
                {selectedRegistration.resume_file ? (
                  <a
                    href={selectedRegistration.resume_file.startsWith('http') ? selectedRegistration.resume_file : `${API_URL}${selectedRegistration.resume_file}`}
                    target="_blank"
                    rel="noreferrer"
                    className="text-blue-600 underline"
                  >
                    View
                  </a>
                ) : '-'}
              </div>
              <div className="rounded-2xl border border-gray-200 bg-gray-50 px-4 py-4">
                <span className="font-semibold">Photo:</span>{' '}
                {selectedRegistration.photo_file ? (
                  <a
                    href={selectedRegistration.photo_file.startsWith('http') ? selectedRegistration.photo_file : `${API_URL}${selectedRegistration.photo_file}`}
                    target="_blank"
                    rel="noreferrer"
                    className="text-blue-600 underline"
                  >
                    View
                  </a>
                ) : '-'}
              </div>
            </div>
          </div>
        </div>
      )}

      {editRegistrationOpen && (
        <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4">
          <div className="w-full max-w-3xl bg-white text-black rounded-xl shadow-xl p-6 max-h-[90vh] overflow-y-auto">
            <h3 className="text-xl font-bold mb-4">Edit Registration</h3>
            <form onSubmit={handleUpdateRegistration} className="grid grid-cols-1 md:grid-cols-2 gap-3">
              <label className="text-sm font-semibold text-gray-700">Name
                <input name="name" value={editRegistrationForm.name} onChange={handleEditRegistrationChange} placeholder="Name" className="mt-1 w-full border p-2 rounded" required />
              </label>
              <label className="text-sm font-semibold text-gray-700">Email
                <input type="email" name="email" value={editRegistrationForm.email} onChange={handleEditRegistrationChange} placeholder="Email" className="mt-1 w-full border p-2 rounded" required />
              </label>
              <label className="text-sm font-semibold text-gray-700">Place
                <input name="place" list="dl-edit-place" autoComplete="off" value={editRegistrationForm.place} onChange={handleEditRegistrationChange} placeholder="Place" className="mt-1 w-full border p-2 rounded" required />
              </label>
              <label className="text-sm font-semibold text-gray-700">Contact Number
                <input name="contact_number" value={editRegistrationForm.contact_number} onChange={handleEditRegistrationChange} placeholder="Contact Number" className="mt-1 w-full border p-2 rounded" maxLength={13} required />
              </label>
              <label className="text-sm font-semibold text-gray-700">Whatsapp Number
                <input name="whatsapp_number" value={editRegistrationForm.whatsapp_number} onChange={handleEditRegistrationChange} placeholder="Whatsapp Number" className="mt-1 w-full border p-2 rounded" maxLength={13} required />
              </label>
              <label className="text-sm font-semibold text-gray-700">District
                <input name="district" value={editRegistrationForm.district} onChange={handleEditRegistrationChange} placeholder="District" className="mt-1 w-full border p-2 rounded" required />
              </label>
              <label className="text-sm font-semibold text-gray-700">Highest Qualification
                <input name="highest_qualification" list="dl-edit-qualification" autoComplete="off" value={editRegistrationForm.highest_qualification} onChange={handleEditRegistrationChange} placeholder="Highest Qualification" className="mt-1 w-full border p-2 rounded" required />
              </label>
              <label className="text-sm font-semibold text-gray-700">Expecting Job
                <input name="expecting_job" list="dl-edit-job" autoComplete="off" value={editRegistrationForm.expecting_job} onChange={handleEditRegistrationChange} placeholder="Expecting Job" className="mt-1 w-full border p-2 rounded" required />
              </label>
              <label className="text-sm font-semibold text-gray-700">Department
                <input name="department" list="dl-edit-department" autoComplete="off" value={editRegistrationForm.department} onChange={handleEditRegistrationChange} placeholder="Department" className="mt-1 w-full border p-2 rounded" required />
              </label>
              <label className="text-sm font-semibold text-gray-700">Section
                <input name="section" list="dl-edit-section" autoComplete="off" value={editRegistrationForm.section} onChange={handleEditRegistrationChange} placeholder="Section" className="mt-1 w-full border p-2 rounded" required />
              </label>

              <div className="md:col-span-2 text-sm text-gray-700">
                Current Resume: {editRegistrationForm.resume_file ? (
                  <a href={editRegistrationForm.resume_file.startsWith('http') ? editRegistrationForm.resume_file : `${API_URL}${editRegistrationForm.resume_file}`} target="_blank" rel="noreferrer" className="text-blue-600 underline">View</a>
                ) : 'None'}
              </div>
              <input type="file" name="resume" accept="application/pdf" onChange={handleEditRegistrationChange} className="md:col-span-2 border p-2 rounded" />

              <div className="md:col-span-2 text-sm text-gray-700">
                Current Photo: {editRegistrationForm.photo_file ? (
                  <a href={editRegistrationForm.photo_file.startsWith('http') ? editRegistrationForm.photo_file : `${API_URL}${editRegistrationForm.photo_file}`} target="_blank" rel="noreferrer" className="text-blue-600 underline">View</a>
                ) : 'None'}
              </div>
              <input type="file" name="photo" accept="image/jpeg,image/jpg" onChange={handleEditRegistrationChange} className="md:col-span-2 border p-2 rounded" />

              <datalist id="dl-edit-place">{KERALA_PLACES.map((p) => <option key={p} value={p} />)}</datalist>
              <datalist id="dl-edit-qualification">{QUALIFICATIONS.map((q) => <option key={q} value={q} />)}</datalist>
              <datalist id="dl-edit-job">{JOB_ROLES.map((j) => <option key={j} value={j} />)}</datalist>
              <datalist id="dl-edit-department">{DEPARTMENTS.map((d) => <option key={d} value={d} />)}</datalist>
              <datalist id="dl-edit-section">{(DEPT_SECTIONS[editRegistrationForm.department] || ALL_SECTIONS).map((s) => <option key={s} value={s} />)}</datalist>
              <div className="md:col-span-2 flex justify-end gap-2 mt-2">
                <button type="button" onClick={() => setEditRegistrationOpen(false)} className="px-4 py-2 rounded border">Cancel</button>
                <button type="submit" disabled={savingRegistration} className="bg-yellow-400 text-black px-4 py-2 rounded font-bold hover:bg-yellow-500">
                  {savingRegistration ? 'Updating...' : 'Update'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {editPartnerForm && (
        <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4">
          <div className="w-full max-w-3xl bg-white text-black rounded-xl shadow-xl p-6 max-h-[90vh] overflow-y-auto">
            <h3 className="text-xl font-bold mb-4">Edit Partner</h3>
            <form onSubmit={handleEditPartnerSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-3">
              {[
                ['name_of_organisation', 'Name of Organisation', true],
                ['owner_of_organisation', 'Owner of Organisation', true],
                ['place', 'Place', true],
                ['district', 'District', true],
                ['location_map', 'Location Map (Google Maps link)', false],
                ['years_of_experience', 'Years of Experience', false],
                ['contact_number', 'Contact Number', true],
                ['whatsapp_number', 'WhatsApp Number', true],
                ['email_id', 'Email ID', false],
                ['website', 'Website', false]
              ].map(([name, label, required]) => (
                <label key={name} className="text-sm font-semibold text-gray-700">{label}
                  <input
                    name={name}
                    type={name === 'email_id' ? 'email' : 'text'}
                    inputMode={name === 'contact_number' || name === 'whatsapp_number' ? 'numeric' : undefined}
                    value={editPartnerForm[name]}
                    onChange={handleEditPartnerChange}
                    required={required}
                    className="mt-1 w-full border p-2 rounded"
                  />
                </label>
              ))}

              <div className="md:col-span-2 mt-2 text-sm font-bold text-gray-800">Uploads</div>
              {[
                ['organisation_license', 'Organisation Licence (PDF/JPG)', '.pdf,.jpg,.jpeg,.png'],
                ['organisation_photo', 'Organisation Photo', 'image/*'],
                ['organisation_name_board_photo', 'Name Board Photo', 'image/*']
              ].map(([field, label, accept]) => {
                const current = editPartnerForm.current[field];
                const removing = editPartnerForm.remove[field];
                return (
                  <div key={field} className="md:col-span-2 rounded-lg border border-dashed border-gray-300 p-3">
                    <div className="flex flex-wrap items-center justify-between gap-2">
                      <span className="text-sm font-semibold text-gray-700">{label}</span>
                      {current ? (
                        <span className="flex items-center gap-3 text-sm">
                          <a href={`${API_URL}${current}`} target="_blank" rel="noreferrer" className={`font-bold underline ${removing ? 'text-gray-400 line-through' : 'text-blue-600'}`}>View current</a>
                          <button type="button" onClick={() => toggleRemovePartnerFile(field)} className="font-bold text-red-600 hover:underline">
                            {removing ? 'Undo remove' : 'Remove'}
                          </button>
                        </span>
                      ) : <span className="text-xs text-gray-500">Not uploaded yet</span>}
                    </div>
                    <input
                      key={removing ? `${field}-removed` : field}
                      type="file"
                      accept={accept}
                      onChange={(e) => handleEditPartnerFile(field, e.target.files?.[0])}
                      className="mt-2 w-full text-sm"
                    />
                    {current && <p className="mt-1 text-xs text-gray-500">Choosing a new file replaces the current one.</p>}
                  </div>
                );
              })}

              <div className="md:col-span-2 flex justify-end gap-2 mt-2">
                <button type="button" onClick={() => setEditPartnerForm(null)} className="px-4 py-2 rounded border">Cancel</button>
                <button type="submit" disabled={savingPartnerEdit} className="bg-yellow-400 text-black px-4 py-2 rounded font-bold hover:bg-yellow-500 disabled:opacity-60">
                  {savingPartnerEdit ? 'Saving...' : 'Save Changes'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {activeTab === 'target-setup' && (
        <div className="space-y-4">

          {/* ── Header bar ─────────────────────────────────────────────── */}
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-xl font-black text-black">Staff Targets</h2>
              <p className="text-xs text-gray-400 mt-0.5">Track and manage performance targets per staff / period</p>
            </div>
            <div className="flex gap-2">
              <button type="button" onClick={() => { fetchTargets(); fetchTargetProgress(); }}
                className="rounded-xl border border-gray-300 bg-white px-3 py-1.5 text-xs font-bold text-gray-600 hover:border-gray-400 transition">
                ↺ Refresh
              </button>
              {!editingTarget && (
                <button type="button"
                  onClick={() => { setShowNewTargetForm((v) => !v); if (editingTarget) { setEditingTarget(null); resetTargetForm(); } }}
                  className={`rounded-xl px-4 py-1.5 text-xs font-extrabold transition ${showNewTargetForm ? 'bg-gray-100 text-gray-700 border border-gray-300' : 'bg-black text-white hover:bg-gray-800'}`}>
                  {showNewTargetForm ? '✕ Cancel' : '+ New Target'}
                </button>
              )}
            </div>
          </div>

          {/* ── Create / Edit form ─────────────────────────────────────── */}
          {(showNewTargetForm || editingTarget) && (
            <div className="rounded-2xl border border-gray-200 bg-white p-5 shadow-sm">
              <div className="mb-4 flex items-center gap-2">
                <span className="flex h-7 w-7 items-center justify-center rounded-xl bg-black text-white text-xs font-black">
                  {editingTarget ? '✎' : '+'}
                </span>
                <h3 className="text-sm font-black text-black">{editingTarget ? 'Edit Target' : 'Create New Target'}</h3>
              </div>
              <form onSubmit={handleTargetSubmit} className="grid grid-cols-2 gap-3 md:grid-cols-3">
                {/* Category */}
                <label className="col-span-1 text-xs font-semibold text-gray-600">
                  Category
                  <select value={targetForm.target_type}
                    onChange={(e) => { setTargetForm((p) => ({ ...p, target_type: e.target.value, role_or_user_id: '', metric: '' })); handleTargetRoleChange(''); }}
                    className="mt-1 w-full rounded-lg border border-gray-300 bg-gray-50 px-2 py-2 text-sm">
                    <option value="Staff">Staff</option>
                    <option value="Partner">Partner</option>
                  </select>
                </label>

                {/* Role */}
                <label className="col-span-1 text-xs font-semibold text-gray-600">
                  Role
                  <select value={targetSelectedRole} onChange={(e) => handleTargetRoleChange(e.target.value)}
                    className="mt-1 w-full rounded-lg border border-gray-300 bg-gray-50 px-2 py-2 text-sm" required>
                    <option value="">— Select role —</option>
                    {targetForm.target_type === 'Staff'
                      ? TARGET_ROLE_OPTIONS.filter((r) => r !== 'Partner').map((r) => <option key={r}>{r}</option>)
                      : <option value="Partner">Partner</option>}
                  </select>
                </label>

                {/* Scope */}
                <label className="col-span-1 text-xs font-semibold text-gray-600">
                  Assign To
                  <select
                    value={targetScope}
                    onChange={(e) => {
                      const v = e.target.value;
                      setTargetScope(v);
                      if (v === 'role') { setTargetSelectedStaff(''); setTargetForm((p) => ({ ...p, scope: 'role', role_or_user_id: targetSelectedRole })); }
                      else { setTargetForm((p) => ({ ...p, scope: 'individual', role_or_user_id: '' })); }
                    }}
                    className="mt-1 w-full rounded-lg border border-gray-300 bg-gray-50 px-2 py-2 text-sm"
                    disabled={!targetSelectedRole}>
                    <option value="role">All in this role</option>
                    <option value="individual">Specific person</option>
                  </select>
                </label>

                {/* Staff picker (individual) */}
                {targetScope === 'individual' && targetSelectedRole && (
                  <label className="col-span-2 text-xs font-semibold text-gray-600 md:col-span-3">
                    Staff Member
                    {staffByRoleLoading
                      ? <div className="mt-1 rounded-lg border bg-gray-50 px-3 py-2 text-xs text-gray-400">Loading…</div>
                      : staffByRole.length === 0
                        ? <div className="mt-1 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-700">No staff found for this role.</div>
                        : <select value={targetSelectedStaff} onChange={(e) => handleTargetStaffChange(e.target.value)}
                            className="mt-1 w-full rounded-lg border border-gray-300 bg-gray-50 px-2 py-2 text-sm" required>
                            <option value="">— Select staff member —</option>
                            {staffByRole.map((s) => <option key={s.user_id} value={s.user_id}>{s.name}</option>)}
                          </select>}
                  </label>
                )}

                {/* Metric */}
                <label className="col-span-2 text-xs font-semibold text-gray-600">
                  Metric
                  <div className="mt-1 flex gap-2">
                    <select value={targetForm.metric} onChange={(e) => setTargetForm((p) => ({ ...p, metric: e.target.value }))}
                      className="flex-1 rounded-lg border border-gray-300 bg-gray-50 px-2 py-2 text-sm">
                      <option value="">— Select metric —</option>
                      {(METRIC_PRESETS[targetSelectedRole] || []).map((m) => <option key={m}>{m}</option>)}
                      <option value="__custom__">Custom…</option>
                    </select>
                    {(targetForm.metric === '__custom__' || (targetForm.metric && !(METRIC_PRESETS[targetSelectedRole] || []).includes(targetForm.metric))) && (
                      <input type="text" value={targetForm.metric === '__custom__' ? '' : targetForm.metric}
                        onChange={(e) => setTargetForm((p) => ({ ...p, metric: e.target.value }))}
                        placeholder="Type metric name"
                        className="flex-1 rounded-lg border border-gray-300 bg-gray-50 px-2 py-2 text-sm" />
                    )}
                  </div>
                </label>

                {/* Target value */}
                <label className="col-span-1 text-xs font-semibold text-gray-600">
                  Target Value
                  <input type="number" min="0" step="any" value={targetForm.target_value}
                    onChange={(e) => setTargetForm((p) => ({ ...p, target_value: e.target.value }))}
                    placeholder="e.g. 5" className="mt-1 w-full rounded-lg border border-gray-300 bg-gray-50 px-2 py-2 text-sm" required />
                </label>

                {/* Unit */}
                <label className="col-span-1 text-xs font-semibold text-gray-600">
                  Unit
                  <select value={targetForm.metric_unit} onChange={(e) => setTargetForm((p) => ({ ...p, metric_unit: e.target.value }))}
                    className="mt-1 w-full rounded-lg border border-gray-300 bg-gray-50 px-2 py-2 text-sm">
                    <option value="count">Count</option>
                    <option value="amount">Amount (₹)</option>
                    <option value="percent">Percent (%)</option>
                  </select>
                </label>

                {/* Period */}
                <label className="col-span-1 text-xs font-semibold text-gray-600">
                  Period
                  <select value={targetForm.period} onChange={(e) => setTargetForm((p) => ({ ...p, period: e.target.value }))}
                    className="mt-1 w-full rounded-lg border border-gray-300 bg-gray-50 px-2 py-2 text-sm">
                    <option value="daily">Daily</option>
                    <option value="weekly">Weekly</option>
                    <option value="monthly">Monthly</option>
                  </select>
                </label>

                {/* Description */}
                <label className="col-span-2 text-xs font-semibold text-gray-600 md:col-span-3">
                  Description <span className="font-normal text-gray-400">(optional)</span>
                  <input type="text" value={targetForm.description}
                    onChange={(e) => setTargetForm((p) => ({ ...p, description: e.target.value }))}
                    placeholder="e.g. HR Assistant must have at least 5 paid registrations per month"
                    className="mt-1 w-full rounded-lg border border-gray-300 bg-gray-50 px-2 py-2 text-sm" />
                </label>

                {/* Buttons */}
                <div className="col-span-2 flex justify-end gap-2 pt-1 md:col-span-3">
                  {editingTarget && (
                    <button type="button" onClick={() => { setEditingTarget(null); resetTargetForm(); setShowNewTargetForm(false); }}
                      className="rounded-lg border border-gray-300 px-4 py-2 text-xs font-bold text-gray-600 hover:bg-gray-50">
                      Cancel
                    </button>
                  )}
                  <button type="submit" disabled={targetSaving}
                    className="rounded-lg bg-black px-5 py-2 text-xs font-extrabold text-white hover:bg-gray-800 disabled:opacity-50">
                    {targetSaving ? 'Saving…' : editingTarget ? 'Update Target' : 'Save Target'}
                  </button>
                </div>
              </form>
            </div>
          )}

          {/* ── Target cards list ──────────────────────────────────────── */}
          {targetsLoading && (
            <div className="rounded-2xl border border-gray-100 bg-white p-8 text-center text-sm text-gray-400">Loading targets…</div>
          )}

          {!targetsLoading && targets.length === 0 && (
            <div className="rounded-2xl border border-dashed border-gray-200 bg-white py-14 text-center">
              <div className="text-3xl mb-2">🎯</div>
              <p className="text-sm font-bold text-gray-500">No targets set yet</p>
              <p className="text-xs text-gray-400 mt-1">Click "+ New Target" to create one</p>
            </div>
          )}

          {!targetsLoading && targets.length > 0 && (() => {
            const progressMap = Object.fromEntries(targetProgress.map((p) => [p.id, p]));
            return targets.map((t) => {
              const members = progressMap[t.id]?.members || [];
              const unitSuffix = t.metric_unit === 'amount' ? ' ₹' : t.metric_unit === 'percent' ? '%' : '';
              const achievedCount = members.filter((m) => m.achieved).length;
              const totalCount = members.length;
              const overallPct = totalCount > 0
                ? Math.min(100, Math.round(members.reduce((s, m) => s + m.current_value, 0) / (totalCount * Number(t.target_value)) * 100))
                : 0;
              const periodColor = t.period === 'daily' ? 'bg-blue-100 text-blue-700' : t.period === 'weekly' ? 'bg-purple-100 text-purple-700' : 'bg-amber-100 text-amber-700';
              const isRole = TARGET_ROLE_OPTIONS.includes(t.role_or_user_id);
              const scopeLabel = isRole ? `All ${t.role_or_user_id}` : (() => {
                const found = (staff || []).find((s) => s.user_id === t.role_or_user_id);
                return found ? found.name : t.role_or_user_id;
              })();

              return (
                <div key={t.id} className="rounded-2xl border border-gray-200 bg-white shadow-sm overflow-hidden">
                  {/* Card header */}
                  <div className="flex items-start justify-between gap-3 px-5 py-4 border-b border-gray-100">
                    <div className="flex-1 min-w-0">
                      <div className="flex flex-wrap items-center gap-2 mb-1">
                        <span className="text-sm font-black text-black">{t.metric}</span>
                        <span className={`rounded-full px-2 py-0.5 text-[10px] font-bold ${periodColor}`}>{t.period}</span>
                        <span className="rounded-full bg-gray-100 px-2 py-0.5 text-[10px] font-bold text-gray-500">{t.target_type}</span>
                        {!t.is_active && <span className="rounded-full bg-red-100 px-2 py-0.5 text-[10px] font-bold text-red-500">Inactive</span>}
                      </div>
                      <div className="flex flex-wrap items-center gap-3 text-[11px] text-gray-500">
                        <span>👥 {scopeLabel}</span>
                        <span>🎯 Target: <strong className="text-gray-800">{t.target_value}{unitSuffix}</strong></span>
                        {t.description && <span className="italic">"{t.description}"</span>}
                      </div>
                    </div>
                    {/* Overall summary pill */}
                    <div className="flex flex-col items-end gap-1.5 shrink-0">
                      {totalCount > 0 && (
                        <div className="text-right">
                          <span className="text-[11px] font-bold text-gray-500">
                            {achievedCount}/{totalCount} achieved
                          </span>
                          <div className="mt-1 h-2 w-28 rounded-full bg-gray-100 overflow-hidden">
                            <div
                              className={`h-full rounded-full transition-all ${overallPct >= 100 ? 'bg-emerald-500' : overallPct >= 60 ? 'bg-amber-400' : 'bg-red-400'}`}
                              style={{ width: `${overallPct}%` }}
                            />
                          </div>
                        </div>
                      )}
                      {targetProgressLoading && totalCount === 0 && (
                        <span className="text-[10px] text-gray-400 italic">Loading…</span>
                      )}
                      <div className="flex gap-1 mt-1">
                        <button type="button" onClick={() => handleEditTarget(t)}
                          className="rounded-lg bg-gray-100 px-3 py-1 text-[11px] font-bold text-gray-700 hover:bg-gray-200 transition">Edit</button>
                        <button type="button" disabled={targetDeletingId === t.id} onClick={() => handleDeleteTarget(t.id)}
                          className="rounded-lg bg-red-50 px-3 py-1 text-[11px] font-bold text-red-600 hover:bg-red-100 transition disabled:opacity-50">
                          {targetDeletingId === t.id ? '…' : 'Delete'}
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Staff rows */}
                  {totalCount > 0 && (
                    <div className="divide-y divide-gray-50">
                      {members.map((m) => {
                        const pct = Math.min(100, Math.round((m.current_value / Number(t.target_value)) * 100));
                        return (
                          <div key={m.user_id} className="flex items-center gap-3 px-5 py-2.5 hover:bg-gray-50 transition">
                            {/* Avatar */}
                            <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-gray-900 text-white text-xs font-black">
                              {(m.name || '?').charAt(0).toUpperCase()}
                            </div>
                            {/* Name + role */}
                            <div className="w-36 min-w-0">
                              <p className="text-xs font-bold text-gray-800 truncate">{m.name}</p>
                              <p className="text-[10px] text-gray-400 truncate">{m.role}</p>
                            </div>
                            {/* Progress bar */}
                            <div className="flex flex-1 items-center gap-2 min-w-0">
                              <div className="flex-1 h-2 rounded-full bg-gray-100 overflow-hidden">
                                <div
                                  className={`h-full rounded-full transition-all ${m.achieved ? 'bg-emerald-500' : pct >= 60 ? 'bg-amber-400' : 'bg-red-400'}`}
                                  style={{ width: `${pct}%` }}
                                />
                              </div>
                              <span className="text-[11px] font-bold text-gray-500 w-8 shrink-0 text-right">{pct}%</span>
                            </div>
                            {/* Done / Target */}
                            <div className="text-center w-20 shrink-0">
                              <span className="text-sm font-black text-gray-800">{m.current_value}</span>
                              <span className="text-[10px] text-gray-400"> / {t.target_value}{unitSuffix}</span>
                            </div>
                            {/* Status badge */}
                            <div className="w-24 shrink-0 text-right">
                              {m.achieved
                                ? <span className="rounded-full bg-emerald-100 px-2 py-1 text-[10px] font-extrabold text-emerald-700">✓ Achieved</span>
                                : pct >= 60
                                  ? <span className="rounded-full bg-amber-100 px-2 py-1 text-[10px] font-extrabold text-amber-600">In Progress</span>
                                  : <span className="rounded-full bg-red-100 px-2 py-1 text-[10px] font-extrabold text-red-600">Pending</span>}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}

                  {/* No staff found */}
                  {!targetProgressLoading && totalCount === 0 && (
                    <div className="px-5 py-3 text-xs text-gray-400 italic">
                      No active staff found for this target assignment.
                    </div>
                  )}
                </div>
              );
            });
          })()}
        </div>
      )}

      {/* ── Field Agent Control ───────────────────────────────────────────── */}
      {activeTab === 'field-agents' && (
        <div className="space-y-5">

          {/* KPI row */}
          <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
            {[
              { label: 'Total Leads',    value: fieldAgentLeads.length,                                        dot: 'bg-gray-400' },
              { label: 'Pending',        value: fieldAgentLeads.filter((l) => l.status === 'Pending').length,  dot: 'bg-yellow-400' },
              { label: 'Accepted',       value: fieldAgentLeads.filter((l) => l.status === 'Accepted').length, dot: 'bg-emerald-500' },
              { label: 'Rejected',       value: fieldAgentLeads.filter((l) => l.status === 'Rejected').length, dot: 'bg-red-400' },
            ].map((k) => (
              <div key={k.label} className="rounded-2xl border border-gray-200 bg-white px-5 py-4 shadow-sm">
                <div className="flex items-center gap-2 mb-1">
                  <span className={`h-2 w-2 rounded-full ${k.dot}`} />
                  <p className="text-[10px] font-extrabold uppercase tracking-widest text-gray-400">{k.label}</p>
                </div>
                <p className="text-2xl font-black text-black">{k.value}</p>
              </div>
            ))}
          </div>

          {/* Leads table */}
          <div className="rounded-[28px] border border-gray-200 bg-white p-5 shadow-sm">
            <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
              <h2 className="text-xl font-black text-black">Field Agent Leads</h2>
              <button type="button" onClick={fetchFieldAgentLeads} className="rounded-xl border border-gray-300 px-3 py-1.5 text-xs font-bold hover:border-yellow-400">Refresh</button>
            </div>

            {/* Filters */}
            <div className="mb-4 flex flex-wrap gap-2">
              <input
                type="text"
                value={faLeadSearch}
                onChange={(e) => setFaLeadSearch(e.target.value)}
                placeholder="Search company / agent / place…"
                className="rounded-xl border border-gray-200 bg-gray-50 px-3 py-2 text-sm outline-none focus:border-yellow-400 focus:ring-2 focus:ring-yellow-200"
              />
              <input
                type="text"
                value={faLeadAgentFilter}
                onChange={(e) => setFaLeadAgentFilter(e.target.value)}
                placeholder="Filter by agent name…"
                className="rounded-xl border border-gray-200 bg-gray-50 px-3 py-2 text-sm outline-none focus:border-yellow-400 focus:ring-2 focus:ring-yellow-200"
              />
              <div className="flex gap-1">
                {['all', 'Pending', 'Accepted', 'Rejected'].map((s) => (
                  <button
                    key={s}
                    type="button"
                    onClick={() => setFaLeadFilter(s)}
                    className={`rounded-xl px-3 py-2 text-xs font-bold transition ${
                      faLeadFilter === s
                        ? 'bg-black text-yellow-400'
                        : 'border border-gray-200 text-gray-600 hover:border-gray-400'
                    }`}
                  >
                    {s === 'all' ? 'All' : s}
                  </button>
                ))}
              </div>
            </div>

            {fieldAgentLeadsLoading && <p className="py-8 text-center text-sm text-gray-400">Loading leads…</p>}
            {!fieldAgentLeadsLoading && (() => {
              const q = faLeadSearch.toLowerCase();
              const ag = faLeadAgentFilter.toLowerCase();
              const filtered = fieldAgentLeads.filter((l) => {
                const matchStatus = faLeadFilter === 'all' || l.status === faLeadFilter;
                const matchSearch = !q || [l.company_name, l.place, l.district, l.agent_name].some((v) => String(v || '').toLowerCase().includes(q));
                const matchAgent = !ag || String(l.agent_name || '').toLowerCase().includes(ag);
                return matchStatus && matchSearch && matchAgent;
              });

              if (filtered.length === 0) {
                return (
                  <div className="rounded-2xl border border-dashed border-gray-200 py-14 text-center text-sm text-gray-400">
                    No leads found.
                  </div>
                );
              }

              // Group by agent for commission access
              const agentMap = {};
              fieldAgentLeads.forEach((l) => { if (l.agent_user_id) agentMap[l.agent_user_id] = l.agent_name || l.agent_user_id; });

              return (
                <>
                  {/* Agent commission buttons strip */}
                  {Object.keys(agentMap).length > 0 && (
                    <div className="mb-4 flex flex-wrap gap-2">
                      {Object.entries(agentMap).map(([uid, name]) => (
                        <button
                          key={uid}
                          type="button"
                          onClick={() => openFaCommissionModal(uid, name)}
                          className="rounded-xl border border-gray-200 bg-gray-50 px-3 py-1.5 text-xs font-bold text-gray-700 transition hover:border-yellow-400 hover:bg-yellow-50 hover:text-black"
                        >
                          💰 {name} — Commission
                        </button>
                      ))}
                    </div>
                  )}

                  <div className="overflow-x-auto">
                    <table className="w-full text-sm">
                      <thead>
                        <tr className="border-b border-gray-100">
                          <th className="py-2 pl-2 pr-4 text-left text-[10px] font-extrabold uppercase tracking-widest text-gray-400">Agent</th>
                          <th className="py-2 pr-4 text-left text-[10px] font-extrabold uppercase tracking-widest text-gray-400">Company</th>
                          <th className="py-2 pr-4 text-left text-[10px] font-extrabold uppercase tracking-widest text-gray-400">Place / District</th>
                          <th className="py-2 pr-4 text-left text-[10px] font-extrabold uppercase tracking-widest text-gray-400">Contact</th>
                          <th className="py-2 pr-4 text-left text-[10px] font-extrabold uppercase tracking-widest text-gray-400">Photos</th>
                          <th className="py-2 pr-4 text-left text-[10px] font-extrabold uppercase tracking-widest text-gray-400">Status</th>
                          <th className="py-2 pr-4 text-left text-[10px] font-extrabold uppercase tracking-widest text-gray-400">Date</th>
                          <th className="py-2 text-left text-[10px] font-extrabold uppercase tracking-widest text-gray-400">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filtered.map((lead) => {
                          const obPhotos = (() => { try { return JSON.parse(lead.outside_board_photos || '[]'); } catch { return []; } })();
                          const ofPhotos = (() => { try { return JSON.parse(lead.office_photos || '[]'); } catch { return []; } })();
                          const totalPhotos = obPhotos.length + ofPhotos.length;
                          const statusColors = {
                            Pending:  'bg-yellow-100 text-yellow-800',
                            Accepted: 'bg-emerald-100 text-emerald-800',
                            Rejected: 'bg-red-100 text-red-700',
                          };
                          return (
                            <tr key={lead.id} className="border-b border-gray-50 hover:bg-gray-50/60">
                              <td className="py-3 pl-2 pr-4 font-semibold text-black">{lead.agent_name || lead.agent_user_id}</td>
                              <td className="py-3 pr-4 font-bold text-black">{lead.company_name || '—'}</td>
                              <td className="py-3 pr-4 text-gray-600">{[lead.place, lead.district].filter(Boolean).join(', ') || '—'}</td>
                              <td className="py-3 pr-4 text-gray-600">{lead.contact_number || '—'}</td>
                              <td className="py-3 pr-4">
                                {totalPhotos > 0
                                  ? <span className="rounded-full bg-gray-100 px-2 py-0.5 text-xs font-bold text-gray-600">{totalPhotos} photo{totalPhotos !== 1 ? 's' : ''}</span>
                                  : <span className="text-gray-300">—</span>
                                }
                              </td>
                              <td className="py-3 pr-4">
                                <span className={`rounded-full px-2.5 py-0.5 text-[11px] font-extrabold ${statusColors[lead.status] || 'bg-gray-100 text-gray-500'}`}>
                                  {lead.status}
                                </span>
                              </td>
                              <td className="py-3 pr-4 text-xs text-gray-400">{lead.created_at ? fmtDate(lead.created_at) : '—'}</td>
                              <td className="py-3">
                                <div className="flex items-center gap-1.5">
                                  <button
                                    type="button"
                                    onClick={() => setFaLeadDetailModal(lead)}
                                    className="rounded-lg border border-gray-200 px-2.5 py-1 text-xs font-bold text-gray-700 hover:border-gray-400"
                                  >
                                    View
                                  </button>
                                  {lead.status !== 'Accepted' && (
                                    <button
                                      type="button"
                                      disabled={faLeadStatusSaving === lead.id}
                                      onClick={() => handleFaLeadStatus(lead.id, 'Accepted')}
                                      className="rounded-lg bg-emerald-600 px-2.5 py-1 text-xs font-bold text-white hover:bg-emerald-700 disabled:opacity-60"
                                    >
                                      {faLeadStatusSaving === lead.id ? '…' : 'Accept'}
                                    </button>
                                  )}
                                  {lead.status !== 'Rejected' && (
                                    <button
                                      type="button"
                                      disabled={faLeadStatusSaving === lead.id}
                                      onClick={() => handleFaLeadStatus(lead.id, 'Rejected')}
                                      className="rounded-lg bg-red-500 px-2.5 py-1 text-xs font-bold text-white hover:bg-red-600 disabled:opacity-60"
                                    >
                                      {faLeadStatusSaving === lead.id ? '…' : 'Reject'}
                                    </button>
                                  )}
                                  {lead.status !== 'Pending' && (
                                    <button
                                      type="button"
                                      disabled={faLeadStatusSaving === lead.id}
                                      onClick={() => handleFaLeadStatus(lead.id, 'Pending')}
                                      className="rounded-lg border border-gray-200 px-2.5 py-1 text-xs font-bold text-gray-500 hover:border-yellow-400 hover:text-yellow-700 disabled:opacity-60"
                                    >
                                      Reset
                                    </button>
                                  )}
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </>
              );
            })()}
          </div>

          {/* Lead detail modal */}
          {faLeadDetailModal && (() => {
            const lead = faLeadDetailModal;
            const obPhotos = (() => { try { return JSON.parse(lead.outside_board_photos || '[]'); } catch { return []; } })();
            const ofPhotos = (() => { try { return JSON.parse(lead.office_photos || '[]'); } catch { return []; } })();
            const statusColors = { Pending: 'bg-yellow-100 text-yellow-800', Accepted: 'bg-emerald-100 text-emerald-800', Rejected: 'bg-red-100 text-red-700' };
            return (
              <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4">
                <div className="w-full max-w-lg overflow-hidden rounded-3xl bg-white shadow-[0_32px_80px_rgba(0,0,0,0.35)]">
                  {/* Header */}
                  <div className="bg-black px-6 py-5">
                    <div className="flex items-start justify-between gap-3">
                      <div className="min-w-0">
                        <p className="text-[10px] font-extrabold uppercase tracking-[0.28em] text-yellow-400">Field Agent Lead</p>
                        <h3 className="mt-1.5 truncate text-xl font-black text-white">{lead.company_name || '—'}</h3>
                        <p className="mt-0.5 text-xs text-gray-400">{lead.agent_name || lead.agent_user_id}</p>
                      </div>
                      <div className="flex items-center gap-2">
                        <span className={`rounded-full px-2.5 py-0.5 text-[11px] font-extrabold ${statusColors[lead.status] || 'bg-gray-100 text-gray-500'}`}>{lead.status}</span>
                        <button type="button" onClick={() => setFaLeadDetailModal(null)}
                          className="rounded-lg border border-gray-600 px-3 py-1.5 text-xs font-bold text-gray-300 hover:border-yellow-400 hover:text-yellow-400">
                          Close
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="max-h-[70vh] overflow-y-auto px-6 py-5 space-y-4">
                    {/* Info grid */}
                    <div className="grid grid-cols-2 gap-3 text-sm">
                      {[
                        ['Contact', lead.contact_number],
                        ['Place', lead.place],
                        ['District', lead.district],
                        ['Location', lead.current_location],
                        ['Submitted', lead.created_at ? fmtDateTime(lead.created_at) : '—'],
                      ].map(([label, value]) => (
                        <div key={label} className="rounded-xl border border-gray-100 bg-gray-50 px-3 py-2.5">
                          <p className="text-[10px] font-bold uppercase tracking-widest text-gray-400">{label}</p>
                          <p className="mt-0.5 font-semibold text-black">{value || '—'}</p>
                        </div>
                      ))}
                    </div>

                    {lead.notes && (
                      <div className="rounded-xl border border-gray-100 bg-gray-50 px-4 py-3 text-sm">
                        <p className="mb-1 text-[10px] font-bold uppercase tracking-widest text-gray-400">Notes</p>
                        <p className="text-gray-700">{lead.notes}</p>
                      </div>
                    )}

                    {/* Photos */}
                    {obPhotos.length > 0 && (
                      <div>
                        <p className="mb-2 text-[10px] font-extrabold uppercase tracking-widest text-gray-400">Outside Board Photos</p>
                        <div className="grid grid-cols-3 gap-2">
                          {obPhotos.map((p, i) => (
                            <a key={i} href={`${API_URL}/${p.replace(/\\/g, '/')}`} target="_blank" rel="noreferrer">
                              <img src={`${API_URL}/${p.replace(/\\/g, '/')}`} alt={`board-${i}`} className="h-24 w-full rounded-xl object-cover border border-gray-100 hover:opacity-80 transition" />
                            </a>
                          ))}
                        </div>
                      </div>
                    )}
                    {ofPhotos.length > 0 && (
                      <div>
                        <p className="mb-2 text-[10px] font-extrabold uppercase tracking-widest text-gray-400">Office Photos</p>
                        <div className="grid grid-cols-3 gap-2">
                          {ofPhotos.map((p, i) => (
                            <a key={i} href={`${API_URL}/${p.replace(/\\/g, '/')}`} target="_blank" rel="noreferrer">
                              <img src={`${API_URL}/${p.replace(/\\/g, '/')}`} alt={`office-${i}`} className="h-24 w-full rounded-xl object-cover border border-gray-100 hover:opacity-80 transition" />
                            </a>
                          ))}
                        </div>
                      </div>
                    )}

                    {/* Action buttons */}
                    <div className="flex gap-2 border-t border-gray-100 pt-4">
                      {lead.status !== 'Accepted' && (
                        <button type="button" disabled={faLeadStatusSaving === lead.id}
                          onClick={() => handleFaLeadStatus(lead.id, 'Accepted')}
                          className="flex-1 rounded-xl bg-emerald-600 py-2.5 text-sm font-extrabold text-white hover:bg-emerald-700 disabled:opacity-60">
                          {faLeadStatusSaving === lead.id ? 'Saving…' : '✓ Accept'}
                        </button>
                      )}
                      {lead.status !== 'Rejected' && (
                        <button type="button" disabled={faLeadStatusSaving === lead.id}
                          onClick={() => handleFaLeadStatus(lead.id, 'Rejected')}
                          className="flex-1 rounded-xl bg-red-500 py-2.5 text-sm font-extrabold text-white hover:bg-red-600 disabled:opacity-60">
                          {faLeadStatusSaving === lead.id ? 'Saving…' : '✕ Reject'}
                        </button>
                      )}
                      {lead.status !== 'Pending' && (
                        <button type="button" disabled={faLeadStatusSaving === lead.id}
                          onClick={() => handleFaLeadStatus(lead.id, 'Pending')}
                          className="rounded-xl border border-gray-200 px-4 py-2.5 text-sm font-bold text-gray-600 hover:border-yellow-400 hover:text-yellow-700 disabled:opacity-60">
                          Reset
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          })()}

          {/* Commission modal */}
          {faCommissionModal && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4">
              <div className="w-full max-w-md overflow-hidden rounded-3xl bg-white shadow-[0_32px_80px_rgba(0,0,0,0.35)]">
                <div className="bg-black px-6 py-5">
                  <div className="flex items-start justify-between gap-3">
                    <div>
                      <p className="text-[10px] font-extrabold uppercase tracking-[0.28em] text-yellow-400">Commission</p>
                      <h3 className="mt-1 text-lg font-black text-white">{faCommissionModal.agentName}</h3>
                    </div>
                    <button type="button" onClick={() => setFaCommissionModal(null)}
                      className="rounded-lg border border-gray-600 px-3 py-1.5 text-xs font-bold text-gray-300 hover:border-yellow-400 hover:text-yellow-400">
                      Close
                    </button>
                  </div>
                </div>

                <div className="px-6 py-5 space-y-4">
                  {faCommissionLoading && <p className="py-4 text-center text-sm text-gray-400">Loading…</p>}
                  {!faCommissionLoading && faCommissionData && (
                    <>
                      {/* Summary */}
                      <div className="grid grid-cols-2 gap-3">
                        {[
                          ['Accepted Leads', faCommissionData.acceptedLeads],
                          ['Total Earned (₹5/lead)', `₹${faCommissionData.totalCommission}`],
                          ['Received', `₹${faCommissionData.receivedCommission}`],
                          ['Balance Due', `₹${faCommissionData.balanceCommission}`],
                        ].map(([label, value]) => (
                          <div key={label} className="rounded-xl border border-gray-100 bg-gray-50 px-3 py-3">
                            <p className="text-[10px] font-bold uppercase tracking-widest text-gray-400">{label}</p>
                            <p className="mt-0.5 text-lg font-black text-black">{value}</p>
                          </div>
                        ))}
                      </div>

                      {/* Add payment */}
                      <form onSubmit={handleFaAddCommission} className="rounded-xl border border-yellow-200 bg-yellow-50 p-4 space-y-3">
                        <p className="text-xs font-extrabold uppercase tracking-widest text-yellow-700">Record Payment</p>
                        <label className="block text-xs font-bold text-gray-600">Amount (₹)
                          <input type="number" min="1" step="any" required value={faCommissionAmount}
                            onChange={(e) => setFaCommissionAmount(e.target.value)}
                            className="mt-1 w-full rounded-xl border border-gray-200 bg-white px-3 py-2 text-sm outline-none focus:border-yellow-400 focus:ring-2 focus:ring-yellow-200" />
                        </label>
                        <label className="block text-xs font-bold text-gray-600">Note (optional)
                          <input type="text" value={faCommissionNote}
                            onChange={(e) => setFaCommissionNote(e.target.value)}
                            placeholder="e.g. April commission"
                            className="mt-1 w-full rounded-xl border border-gray-200 bg-white px-3 py-2 text-sm outline-none focus:border-yellow-400 focus:ring-2 focus:ring-yellow-200" />
                        </label>
                        <button type="submit" disabled={faCommissionSaving}
                          className="w-full rounded-xl bg-black py-2.5 text-sm font-extrabold text-yellow-400 hover:bg-gray-900 disabled:opacity-60">
                          {faCommissionSaving ? 'Saving…' : 'Record Payment'}
                        </button>
                      </form>

                      {/* Payment history */}
                      {faCommissionData.payments.length > 0 && (
                        <div>
                          <p className="mb-2 text-[10px] font-extrabold uppercase tracking-widest text-gray-400">Payment History</p>
                          <div className="space-y-2 max-h-48 overflow-y-auto">
                            {faCommissionData.payments.map((p) => (
                              <div key={p.id} className="flex items-center justify-between rounded-xl border border-gray-100 px-3 py-2 text-sm">
                                <div>
                                  <p className="font-bold text-black">₹{p.amount}</p>
                                  {p.note && <p className="text-xs text-gray-400">{p.note}</p>}
                                </div>
                                <p className="text-xs text-gray-400">{p.created_at ? fmtDate(p.created_at) : '—'}</p>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          )}

        </div>
      )}

      {/* ── Internship Applications ──────────────────────────────────────── */}
      {activeTab === 'internship' && (
        <div className="space-y-5">
          <div className="rounded-[28px] border border-blue-200 bg-white p-5 shadow-sm">
            {/* Header */}
            <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
              <div>
                <h2 className="text-xl font-black text-blue-700">Internship Applications</h2>
                <p className="text-xs text-gray-400 mt-0.5">{internships.length} total applications</p>
              </div>
              <div className="flex items-center gap-2 flex-wrap">
                <input
                  type="text"
                  placeholder="Search name, email, contact, industry..."
                  value={internshipSearch}
                  onChange={e => { setInternshipSearch(e.target.value); setInternshipPage(1); }}
                  className="rounded-xl border border-gray-200 bg-gray-50 px-3 py-2 text-xs outline-none focus:border-blue-300 focus:ring-1 focus:ring-blue-100 w-60"
                />
                <button type="button" onClick={fetchInternships}
                  className="rounded-xl border border-gray-200 bg-white px-3 py-2 text-xs font-bold text-gray-600 hover:border-blue-300 hover:text-blue-700 transition">
                  Refresh
                </button>
              </div>
            </div>

            {/* Filter bar */}
            <div className="flex flex-wrap items-center gap-2 mb-4">
              {/* Status filter */}
              <div className="flex items-center gap-1 flex-wrap">
                {['All', 'New', 'Forwarded', 'Not Forwarded'].map(f => (
                  <button key={f} type="button"
                    onClick={() => { setInternshipStatusFilter(f); setInternshipPage(1); }}
                    className={`rounded-full px-3 py-1 text-[11px] font-bold border transition ${internshipStatusFilter === f ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-gray-600 border-gray-200 hover:border-blue-300 hover:text-blue-600'}`}>
                    {f}
                    {f === 'New' && ` (${internships.filter(r => !r.is_seen).length})`}
                    {f === 'Forwarded' && ` (${internships.filter(r => !!r.forwarded_to_ar_id).length})`}
                    {f === 'Not Forwarded' && ` (${internships.filter(r => !r.forwarded_to_ar_id).length})`}
                  </button>
                ))}
              </div>
              {/* Gender filter */}
              <select
                value={internshipGenderFilter}
                onChange={e => { setInternshipGenderFilter(e.target.value); setInternshipPage(1); }}
                className="rounded-xl border border-gray-200 bg-gray-50 px-3 py-1.5 text-xs outline-none focus:border-blue-300 ml-auto">
                <option value="All">All Genders</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
              </select>
            </div>

            {internshipsLoading && <p className="text-sm text-gray-400 py-6 text-center">Loading...</p>}

            {!internshipsLoading && internships.length === 0 && (
              <div className="rounded-2xl border border-dashed border-gray-200 py-12 text-center text-sm text-gray-400">
                No internship applications yet.
              </div>
            )}

            {!internshipsLoading && internships.length > 0 && (() => {
              const q = internshipSearch.toLowerCase().trim();
              const filtered = internships.filter(r => {
                if (q && !(
                  (r.full_name || '').toLowerCase().includes(q) ||
                  (r.email_address || '').toLowerCase().includes(q) ||
                  (r.contact_number || '').includes(q) ||
                  (r.desired_industry || '').toLowerCase().includes(q) ||
                  (r.institution_name || '').toLowerCase().includes(q)
                )) return false;
                if (internshipStatusFilter === 'New' && r.is_seen) return false;
                if (internshipStatusFilter === 'Forwarded' && !r.forwarded_to_ar_id) return false;
                if (internshipStatusFilter === 'Not Forwarded' && !!r.forwarded_to_ar_id) return false;
                if (internshipGenderFilter !== 'All' && (r.gender || '') !== internshipGenderFilter) return false;
                return true;
              });

              const totalPages = Math.max(1, Math.ceil(filtered.length / INTERNSHIP_PER_PAGE));
              const safePage = Math.min(internshipPage, totalPages);
              const pageItems = filtered.slice((safePage - 1) * INTERNSHIP_PER_PAGE, safePage * INTERNSHIP_PER_PAGE);
              const globalStart = (safePage - 1) * INTERNSHIP_PER_PAGE;

              // Page number window (max 5 buttons)
              const pageNums = [];
              const half = 2;
              let start = Math.max(1, safePage - half);
              let end = Math.min(totalPages, start + 4);
              if (end - start < 4) start = Math.max(1, end - 4);
              for (let i = start; i <= end; i++) pageNums.push(i);

              return (
                <>
                  <div className="space-y-3">
                    {filtered.length === 0 && (
                      <p className="text-center text-sm text-gray-400 py-6">No matching applications.</p>
                    )}
                    {pageItems.map((row, idx) => {
                      const isOpen = internshipExpandedId === row.id;
                      const isNew = !row.is_seen;
                      const isForwarded = !!row.forwarded_to_ar_id;
                      return (
                        <div key={row.id}
                          className={`rounded-2xl border transition ${isNew ? 'border-blue-300 bg-blue-50/40' : 'border-gray-200 bg-white'} overflow-hidden`}>
                          {/* Header row */}
                          <button
                            type="button"
                            className="w-full flex items-center justify-between px-4 py-3 text-left gap-3 hover:bg-blue-50/30 transition"
                            onClick={() => setInternshipExpandedId(isOpen ? null : row.id)}
                          >
                            <div className="flex items-center gap-3 min-w-0">
                              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-blue-100 text-xs font-black text-blue-700">
                                {globalStart + idx + 1}
                              </span>
                              <div className="min-w-0">
                                <p className="font-black text-sm text-gray-900 truncate">{row.full_name}</p>
                                <p className="text-xs text-gray-500 truncate">{row.email_address} · {row.contact_number}</p>
                              </div>
                              {isNew && <span className="shrink-0 rounded-full bg-blue-500 px-2 py-0.5 text-[10px] font-extrabold text-white uppercase tracking-wide">New</span>}
                              {isForwarded && (
                                <span className="shrink-0 rounded-full bg-emerald-100 border border-emerald-300 px-2 py-0.5 text-[10px] font-extrabold text-emerald-700 uppercase tracking-wide">
                                  Forwarded → {row.forwarded_to_ar_name}
                                </span>
                              )}
                            </div>
                            <div className="flex items-center gap-3 shrink-0">
                              {row.desired_industry && (
                                <span className="hidden sm:inline rounded-full border border-blue-200 bg-blue-50 px-2 py-0.5 text-[10px] font-bold text-blue-600">
                                  {row.desired_industry}
                                </span>
                              )}
                              {row.availability && (
                                <span className="hidden sm:inline rounded-full border border-gray-200 bg-gray-50 px-2 py-0.5 text-[10px] font-bold text-gray-600">
                                  {row.availability}
                                </span>
                              )}
                              <span className="text-[10px] text-gray-400">
                                {row.created_at ? new Date(row.created_at).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : '—'}
                              </span>
                              <span className={`text-gray-400 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}>▾</span>
                            </div>
                          </button>

                          {/* Expanded details */}
                          {isOpen && (
                            <div className="border-t border-gray-100 px-4 pb-5 pt-4">
                              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-4 mb-5">
                                {/* Personal */}
                                <div>
                                  <p className="text-[10px] font-extrabold uppercase tracking-widest text-blue-500 mb-2">Personal Information</p>
                                  <div className="space-y-1.5 text-xs">
                                    <p><span className="font-bold text-gray-600">Name:</span> {row.full_name || '—'}</p>
                                    <p><span className="font-bold text-gray-600">Address:</span> {row.address || '—'}</p>
                                    <p><span className="font-bold text-gray-600">Contact:</span> {row.contact_number || '—'}</p>
                                    <p><span className="font-bold text-gray-600">WhatsApp:</span> {row.whatsapp_number || '—'}</p>
                                    <p><span className="font-bold text-gray-600">Email:</span> {row.email_address || '—'}</p>
                                    <p><span className="font-bold text-gray-600">Age:</span> {row.age || '—'}</p>
                                    <p><span className="font-bold text-gray-600">Gender:</span> {row.gender || '—'}</p>
                                  </div>
                                </div>
                                {/* Education */}
                                <div>
                                  <p className="text-[10px] font-extrabold uppercase tracking-widest text-indigo-500 mb-2">Educational Background</p>
                                  <div className="space-y-1.5 text-xs">
                                    <p><span className="font-bold text-gray-600">Institution:</span> {row.institution_name || '—'}</p>
                                    <p><span className="font-bold text-gray-600">Inst. Address:</span> {row.institution_address || '—'}</p>
                                    <p><span className="font-bold text-gray-600">Course:</span> {row.course || '—'}</p>
                                    <p><span className="font-bold text-gray-600">Year / Sem:</span> {row.year_semester || '—'}</p>
                                  </div>
                                </div>
                                {/* Internship */}
                                <div>
                                  <p className="text-[10px] font-extrabold uppercase tracking-widest text-yellow-600 mb-2">Internship Details</p>
                                  <div className="space-y-1.5 text-xs">
                                    <p><span className="font-bold text-gray-600">Industry:</span> {row.desired_industry || '—'}</p>
                                    <p><span className="font-bold text-gray-600">Position:</span> {row.desired_position || '—'}</p>
                                    <p><span className="font-bold text-gray-600">Location:</span> {row.desired_location || '—'}</p>
                                    <p><span className="font-bold text-gray-600">Start Date:</span> {row.preferred_start_date || '—'}</p>
                                    <p><span className="font-bold text-gray-600">End Date:</span> {row.preferred_end_date || '—'}</p>
                                    <p><span className="font-bold text-gray-600">Availability:</span> {row.availability || '—'}</p>
                                  </div>
                                </div>
                              </div>

                              {/* Forward action bar */}
                              <div className="flex items-center justify-between gap-3 border-t border-gray-100 pt-4">
                                {isForwarded ? (
                                  <div className="flex items-center gap-2">
                                    <span className="flex h-6 w-6 items-center justify-center rounded-full bg-emerald-100 text-emerald-600 text-xs">✓</span>
                                    <div>
                                      <p className="text-xs font-bold text-emerald-700">Forwarded to {row.forwarded_to_ar_name}</p>
                                      {row.forwarded_at && (
                                        <p className="text-[10px] text-gray-400">
                                          {new Date(row.forwarded_at).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                ) : (
                                  <p className="text-xs text-gray-400">Not yet forwarded to any AR.</p>
                                )}
                                <button
                                  type="button"
                                  onClick={(e) => { e.stopPropagation(); setInternshipForwardArId(''); setInternshipForwardModal({ appId: row.id, appName: row.full_name }); }}
                                  className="rounded-xl bg-blue-600 px-4 py-2 text-xs font-extrabold text-white hover:bg-blue-700 transition"
                                >
                                  {isForwarded ? 'Re-Forward' : 'Forward to AR'}
                                </button>
                              </div>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>

                  {/* Pagination */}
                  {totalPages > 1 && (
                    <div className="mt-5 flex flex-wrap items-center justify-between gap-3 border-t border-gray-100 pt-4">
                      <p className="text-xs text-gray-400">
                        Showing {globalStart + 1}–{Math.min(globalStart + INTERNSHIP_PER_PAGE, filtered.length)} of {filtered.length} applications
                      </p>
                      <div className="flex items-center gap-1">
                        <button
                          onClick={() => setInternshipPage(1)}
                          disabled={safePage === 1}
                          className="rounded-lg border border-gray-200 px-2 py-1 text-xs font-bold text-gray-500 hover:border-blue-300 hover:text-blue-600 disabled:opacity-30 disabled:cursor-not-allowed transition"
                        >«</button>
                        <button
                          onClick={() => setInternshipPage(p => Math.max(1, p - 1))}
                          disabled={safePage === 1}
                          className="rounded-lg border border-gray-200 px-2 py-1 text-xs font-bold text-gray-500 hover:border-blue-300 hover:text-blue-600 disabled:opacity-30 disabled:cursor-not-allowed transition"
                        >‹</button>
                        {pageNums.map(n => (
                          <button key={n}
                            onClick={() => setInternshipPage(n)}
                            className={`rounded-lg border px-3 py-1 text-xs font-bold transition ${safePage === n ? 'bg-blue-600 border-blue-600 text-white' : 'border-gray-200 text-gray-600 hover:border-blue-300 hover:text-blue-600'}`}
                          >{n}</button>
                        ))}
                        <button
                          onClick={() => setInternshipPage(p => Math.min(totalPages, p + 1))}
                          disabled={safePage === totalPages}
                          className="rounded-lg border border-gray-200 px-2 py-1 text-xs font-bold text-gray-500 hover:border-blue-300 hover:text-blue-600 disabled:opacity-30 disabled:cursor-not-allowed transition"
                        >›</button>
                        <button
                          onClick={() => setInternshipPage(totalPages)}
                          disabled={safePage === totalPages}
                          className="rounded-lg border border-gray-200 px-2 py-1 text-xs font-bold text-gray-500 hover:border-blue-300 hover:text-blue-600 disabled:opacity-30 disabled:cursor-not-allowed transition"
                        >»</button>
                      </div>
                    </div>
                  )}
                </>
              );
            })()}
          </div>

          {/* ── Forward Modal ── */}
          {internshipForwardModal && (() => {
            const arStaff = staff.filter(s => s.role === 'Assistant Recruiter');
            const selectedAr = arStaff.find(s => s.user_id === internshipForwardArId);
            const handleForward = async () => {
              if (!internshipForwardArId || !selectedAr) return;
              setInternshipForwarding(true);
              try {
                const token = localStorage.getItem('adminToken');
                await axios.put(
                  `${API_URL}/api/admin/internship/${internshipForwardModal.appId}/forward`,
                  { ar_user_id: selectedAr.user_id, ar_name: selectedAr.name },
                  { headers: { Authorization: `Bearer ${token}` } }
                );
                setInternships(prev => prev.map(r =>
                  r.id === internshipForwardModal.appId
                    ? { ...r, forwarded_to_ar_id: selectedAr.user_id, forwarded_to_ar_name: selectedAr.name, forwarded_at: new Date().toISOString() }
                    : r
                ));
                setInternshipForwardModal(null);
              } catch (err) {
                alert(err?.response?.data?.error || 'Failed to forward.');
              } finally {
                setInternshipForwarding(false);
              }
            };
            return (
              <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm px-4">
                <div className="w-full max-w-md rounded-[28px] border border-blue-200 bg-white p-6 shadow-2xl">
                  <div className="mb-4 flex items-center justify-between">
                    <div>
                      <p className="text-[10px] font-extrabold uppercase tracking-widest text-blue-500">Forward Internship Request</p>
                      <h3 className="mt-1 text-lg font-black text-gray-900">{internshipForwardModal.appName}</h3>
                    </div>
                    <button type="button" onClick={() => setInternshipForwardModal(null)}
                      className="rounded-full border border-gray-200 px-3 py-1 text-xs font-bold text-gray-500 hover:border-red-300 hover:text-red-500 transition">
                      ✕ Close
                    </button>
                  </div>

                  <p className="mb-3 text-xs text-gray-500">Select an Assistant Recruiter to forward this application to:</p>

                  {arStaff.length === 0 ? (
                    <div className="rounded-2xl border border-dashed border-gray-200 py-6 text-center text-xs text-gray-400">
                      No Assistant Recruiters found. Create AR staff accounts first.
                    </div>
                  ) : (
                    <div className="space-y-2 max-h-64 overflow-y-auto">
                      {arStaff.map(ar => (
                        <button
                          key={ar.user_id}
                          type="button"
                          onClick={() => setInternshipForwardArId(ar.user_id)}
                          className={`w-full flex items-center gap-3 rounded-2xl border px-4 py-3 text-left transition ${
                            internshipForwardArId === ar.user_id
                              ? 'border-blue-400 bg-blue-50 ring-2 ring-blue-200'
                              : 'border-gray-200 bg-white hover:border-blue-300'
                          }`}
                        >
                          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-blue-100 text-sm font-black text-blue-700">
                            {ar.name?.charAt(0) || 'A'}
                          </span>
                          <div>
                            <p className="text-sm font-bold text-gray-900">{ar.name}</p>
                            <p className="text-[11px] text-gray-400">{ar.staff_id} · {ar.user_id}</p>
                          </div>
                          {internshipForwardArId === ar.user_id && (
                            <span className="ml-auto text-blue-600 font-black text-sm">✓</span>
                          )}
                        </button>
                      ))}
                    </div>
                  )}

                  <div className="mt-5 flex justify-end gap-3">
                    <button type="button" onClick={() => setInternshipForwardModal(null)}
                      className="rounded-xl border border-gray-200 px-5 py-2.5 text-sm font-bold text-gray-600 hover:border-gray-400 transition">
                      Cancel
                    </button>
                    <button
                      type="button"
                      onClick={handleForward}
                      disabled={!internshipForwardArId || internshipForwarding}
                      className="rounded-xl bg-blue-600 px-6 py-2.5 text-sm font-extrabold text-white hover:bg-blue-700 transition disabled:opacity-50"
                    >
                      {internshipForwarding ? 'Forwarding...' : 'Forward'}
                    </button>
                  </div>
                </div>
              </div>
            );
          })()}
        </div>
      )}

          </div>
        </div>
      </div>

      {/* ── Change Password Modal ──────────────────────────────────────────── */}
      {changePwOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4">
          <div className="w-full max-w-sm rounded-2xl bg-white shadow-2xl">
            <div className="flex items-center justify-between rounded-t-2xl bg-black px-5 py-4">
              <div>
                <p className="text-[10px] font-extrabold uppercase tracking-widest text-yellow-400">Admin</p>
                <h3 className="text-base font-black text-white">Change Password</h3>
              </div>
              <button onClick={() => setChangePwOpen(false)} className="rounded-xl bg-white/20 px-3 py-1.5 text-sm font-bold text-white hover:bg-white/30">✕</button>
            </div>
            <div className="p-5 space-y-3">
              <div>
                <label className="block text-[10px] font-extrabold uppercase tracking-widest text-gray-400 mb-1">Current Password</label>
                <input
                  type="password"
                  value={changePwForm.current}
                  onChange={e => setChangePwForm(f => ({ ...f, current: e.target.value }))}
                  placeholder="Enter current password"
                  className="w-full rounded-xl border border-gray-200 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-yellow-400"
                />
              </div>
              <div>
                <label className="block text-[10px] font-extrabold uppercase tracking-widest text-gray-400 mb-1">New Password</label>
                <input
                  type="password"
                  value={changePwForm.newPw}
                  onChange={e => setChangePwForm(f => ({ ...f, newPw: e.target.value }))}
                  placeholder="Enter new password"
                  className="w-full rounded-xl border border-gray-200 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-yellow-400"
                />
              </div>
              <div>
                <label className="block text-[10px] font-extrabold uppercase tracking-widest text-gray-400 mb-1">Confirm New Password</label>
                <input
                  type="password"
                  value={changePwForm.confirm}
                  onChange={e => setChangePwForm(f => ({ ...f, confirm: e.target.value }))}
                  placeholder="Re-enter new password"
                  className="w-full rounded-xl border border-gray-200 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-yellow-400"
                  onKeyDown={e => e.key === 'Enter' && handleChangePassword()}
                />
              </div>
              {changePwMsg && (
                <div className={`rounded-xl px-3 py-2 text-xs font-semibold ${changePwMsg.type === 'success' ? 'bg-green-50 text-green-700 border border-green-200' : 'bg-red-50 text-red-700 border border-red-200'}`}>
                  {changePwMsg.text}
                </div>
              )}
              <div className="flex gap-3 pt-1">
                <button onClick={() => setChangePwOpen(false)} className="flex-1 rounded-xl border border-gray-200 py-2 text-sm font-bold text-gray-600 hover:bg-gray-50">Cancel</button>
                <button
                  onClick={handleChangePassword}
                  disabled={changePwLoading}
                  className="flex-1 rounded-xl bg-black py-2 text-sm font-extrabold text-yellow-400 hover:bg-gray-900 disabled:opacity-60"
                >
                  {changePwLoading ? 'Updating…' : '🔒 Update Password'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <AdminPartnerChat />
    </div>
  );
};

export default AdminDashboard;
